{
  "accessibility": {
    "closeModal": "Fechar modal",
    "useSetting": "Utilize a configuração",
    "srOnly": {
      "close": "Fechar",
      "loading": "Carregando..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Recursos de Vendas",
      "searchDocuments": "Pesquisar arquivos",
      "minimalRating": "Classificação mínima",
      "maxRating": "Classificação Máxima"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Ative a recobrança para este cliente para obter até 10 vezes mais lucro no uso de telefone, e-mails, automações etc.",
      "enableRebilling": "Habilitar refaturamento",
      "servicesActivateAfterPayment": "Os serviços de refaturamento estarão ativos depois que o cliente adicionar um método de pagamento. Até lá, o acesso à conta do cliente será restrito.",
      "cannotModifyOnHold": "Não é possível modificar as configurações de refaturamento, pois esta conta já tem um plano SaaS em espera. As margens de refaturamento serão configuradas de acordo com o plano quando o cliente adicionar um método de pagamento.",
      "rebillingSettings": "Configurações de refaturamento"
    }
  },
  "affiliates": {
    "aboutMe": "Sobre mim",
    "error": {
      "unableToSend": "Não foi possível enviar Email"
    },
    "industriesServed": "Indústrias atendidas",
    "sendAMessage": "Enviar uma mensagem",
    "sendMessageIntro": "Envie uma mensagem para se apresentar a este orientador. Inclua detalhes sobre você e os serviços que está procurando.",
    "socialSites": "Redes sociais",
    "success": {
      "emailSent": "E-mail enviado com sucesso"
    },
    "validationErrors": {
      "validEmail": "Forneça um e-mail válido.",
      "validMessage": "Forneça uma mensagem válida.",
      "validName": "Forneça um nome válido."
    },
    "yearsInBusiness": "Anos de atuação no mercado",
    "yourEmail": "Seu e-mail",
    "yourName": "Seu nome",
    "paymentDetailsAccessMessage": " Esta seção de detalhes de pagamento só pode ser acessada e editada pelo <strong>Proprietário da Agência</strong>. Se precisar de ajuda, entre em contato com o <strong>Proprietário da Agência ({ agencyOwnerEmail })</strong>",
    "partnerBadgeAlt": "Emblema de parceiro",
    "photoAlt": "Foto do parceiro",
    "defaultCompany": "Nenhuma empresa",
    "moreServices": "+ {count} serviços adicionais"
  },
  "agency": {
    "saas": {
      "saasMode": "Modo SaaS",
      "pendingPaymentInformation": "Informações de pagamento pendentes",
      "customerId": "ID do cliente",
      "noPaymentMethods": "Parece que nenhum método de pagamento foi adicionado. Adicione um método de pagamento para ativar o modo SaaS",
      "enableSaasDescription": "Habilite o SaaS neste local para criar assinaturas, refaturar o uso de telefone e e-mail",
      "missingEmailAddress": "O endereço de e-mail da conta está ausente, adicione os detalhes primeiro.",
      "toConvertToSaaS": "Para converter esta conta em SaaS, é necessário adicionar primeiro um administrador de local e tentar novamente",
      "newUser": "Criar novo usuário",
      "stripeCustomerConnected": "Cliente da Stripe foi conectado com sucesso!",
      "requestClientPaymentDetails": "Solicitar informações de pagamento dos clientes",
      "saasLocationDescription": "Localizações no modo SaaS precisam do cartão de crédito do cliente para funcionar. Você pode solicitar enviando um e-mail, mensagem de texto ou compartilhando um URL",
      "selectSpace": "Selecione espaço para continuar",
      "spaceDescription": "O espaço que você selecionar aqui será usado para armazenar as informações deste cliente, processar os pagamentos dele e gerenciar suas assinaturas.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Quando um usuário se inscreve, você pode oferecer créditos gratuitos para usar serviços de e-mail e telefonia.",
      "thatAboutMinsInCalls": "Isso é cerca de {count} mensagens de texto ou {count1} minutos em chamadas",
      "subscriptionSettings": "Configurações de assinatura",
      "toUpgradeOrCancelPlan": "Para fazer upgrade ou cancelar o plano",
      "allowClientUpgrade": "Permitir que o cliente (subconta) faça upgrade para um plano superior.",
      "addNewPlanFeatures": "Adicione os recursos do novo plano ao fazer o upgrade",
      "upgradeFeatureDescription": "Ao fazer upgrade para um plano superior, as subcontas terão acesso aos recursos adicionais do novo plano. acesso aos recursos adicionais no novo plano.",
      "allowClientCancel": "Permitir que o cliente (subconta) cancele a assinatura.",
      "snapshotDescription": "O instantâneo selecionado será automaticamente adicionado à nova localização SaaS criada",
      "ownSnapshots": "Obtenha instantâneos",
      "selectAndContinue": "Selecione e continue"
    },
    "advancedSettings": {
      "controlLocationSettings": "Gerenciar as configurações de localização",
      "disableAddSmtp": "Desabilitar o botão \"Adicionar serviço de e-mail\" nas configurações de serviços de e-mail da subconta",
      "disableAddSmtpDescription": "Restringir usuários de subconta de incluir seu próprio provedor de serviço de e-mail",
      "enableReVerification": "Habilitar re-verificação por 90 dias",
      "lcEmailNotEnabled": "A localização não possui LeadConnector como provedor de e-mail padrão",
      "onlyVisibleForAgency": "Você só consegue ver essas configurações habilitadas por agência",
      "reVerificationDescription": "Todos os status de verificação de e-mail serão revogados depois de 90 dias (proteja sua reputação como remetente e garanta capacidade de entrega aprimorada na caixa de entrada)",
      "account": {
        "accountDetails": "Detalhes da conta",
        "advancedEmailSettings": "Configurações avançadas de e-mail",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Conformidade com a HIPAA",
        "smsEmailLimits": "Limites de SMS/e-mail",
        "socialProfiles": "Perfis de redes sociais",
        "subscribed": "Assinatura ativa"
      },
      "activityTracking": {
        "history": "Histórico"
      },
      "addAccount": {
        "accountInfo": "Informações da conta",
        "accountSnapshots": "Instantâneos da conta",
        "businessNiche": "Nicho de negócios",
        "chooseBusinessNiche": "Selecione o nicho de negócios...",
        "pickSnapshot": "Selecione um instantâneo",
        "selectSnapshot": "Selecionar instantâneo",
        "title": "Adicionar subconta",
        "accountInfo1": "Informações da conta"
      },
      "addBalance": {
        "addBalanceToWallet": "Adicionar saldo à carteira",
        "addMoneyToWallet": "Adicionar dinheiro à carteira",
        "balanceAddedSuccessfully": "Saldo adicionado com sucesso",
        "cardWillBeCharged": "Será cobrado o valor correspondente ao cartão que termina em {cardNumber}",
        "complimentaryCredits": "Créditos de cortesia ({credits})",
        "creditsRemovedByAgency": "Créditos removidos por agência",
        "currentBalance": "Saldo atual",
        "customerCCWillNotBeCharged": "O cartão de crédito do cliente não será cobrado",
        "moneyWillBeAddedToWallet": "O dinheiro será adicionado à carteira",
        "pleaseProvideAmountBetween": "Forneça um valor entre {min} e {max}.",
        "processing": "Processando",
        "removeBalance": "Remover saldo",
        "transactionSuccessful": "Transação concluída com sucesso",
        "walletBalance": "Saldo da carteira ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Adicionando...",
        "cardDetails": "Informações do cartão",
        "cardSuccessfullyAdded": "Cartão adicionado com sucesso",
        "errorWhileAddingCard": "Falha ao adicionar novo cartão!",
        "maximumCardUpdateLimitReached": "Limite máximo de atualização do cartão atingido",
        "rateLimitMessage": "Parece que você atingiu o número máximo de tentativas permitidas para adicionar cartões hoje. Tente novamente após 24 horas."
      },
      "aiProductRebilling": {
        "funnel": " funil",
        "images": " Imagens,",
        "per1000Words": " /1000 palavras, ",
        "perFunnel": " /funil",
        "perImage": " /imagem",
        "pleaseCheckSupport": "confira nosso",
        "ratesMayDiffer": "As taxas podem variar de acordo com a região. Os cálculos apresentados são conforme as taxas do Reino Unido,",
        "ratesMayDifferUS": "As taxas podem variar de acordo com a região. Os cálculos mostrados são conforme as tarifas da Twilio para os EUA. Por favor, consulte a Twilio para mais detalhes.",
        "pleaseCheckTwilioRates": "O envio de SMS para os EUA/Canadá será cobrado a US$ 0,0079/segmento. SMS de entrada a US$ 0,0075/segmento.",
        "words": " palavras, "
      },
      "api": {
        "advancedFunctionalityNote": "Observação sobre funcionalidade avançada",
        "agencyApiKeys": "Chaves de API da agência",
        "apiAccess": {
          "partOfAdvancedApi": "Isso faz parte da API Avançada disponível no Plano Pro.",
          "toUpgrade": "para fazer upgrade."
        },
        "createNew": "Criar novo",
        "developerCouncilInfo": "Informações do Conselho de Desenvolvedores",
        "noAccess": "Você não tem acesso a esta seção.",
        "securityAlert": "Mensagem de alerta de segurança",
        "table": {
          "fetchingKeys": "Buscando chaves da empresa...",
          "noKeysYet": "Você ainda não tem nenhuma chave de API.",
          "toCreateFirstKeys": "para criar suas primeiras chaves de API."
        },
        "zapierNote": "Nota do Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Possibilidade de selecionar calendários do Google para \"Adicionar a\" e calendários em \"Conflito\" a serem verificados para calcular a disponibilidade de cada usuário",
        "abilityToAllocateRoundRobin": "Capacidade de alocar compromissos em sistema de rodízio",
        "abilityToChooseSpecificUser": "Possibilidade de escolher um usuário específico para agendamento do compromisso",
        "adminAbilitySeeEveryUser": "Administrador - Capacidade de ver todos os compromissos do calendário de cada usuário",
        "adminAbilityViewAllCalendar": "Administrador - Capacidade de visualizar todos os compromissos do calendário do usuário",
        "adminsCanDeleteIntegrations": "Os administradores podem excluir qualquer integração que desejarem, mas os usuários só podem remover suas próprias integrações",
        "adminsCanSeeAllIntegrations": "Os administradores podem ver todas as integrações, independentemente de quem as criou, mas os usuários podem ver as integrações que eles mesmos criaram",
        "contactDetailAppointments": "Detalhes do contato > Compromissos (Novo)",
        "conversationsScheduleAppointment": "Conversas > Agendar compromisso (Novo)",
        "essentialConsiderations": "Considerações essenciais",
        "funnelsWebsitesCalendar": "Funis/Sites > Calendário (Novo)",
        "helpReorientTriggers": "Durante a ligação, ajudaremos a reorientar os gatilhos para se adequarem à nova configuração do calendário",
        "iAgreeMessage": "Se você concorda com as alterações mencionadas, clique em \"Concordo\" e comece a usar o Calendário (Beta) nesta subconta",
        "integrationNew": "Integração (Novo)",
        "loseAbilityToViewEdit": "Os usuários da nova versão perderão a capacidade de \"visualizar/editar\" compromissos (criados na versão anterior) por meio do modal de detalhes da oportunidade, mas poderão continuar realizando todas essas ações na página de compromissos",
        "newOldTriggersCoexist": "Os gatilhos novos e antigos coexistirão",
        "nonAdminAbilityViewPersonal": "Não administradores - Capacidade de visualizar apenas seus compromissos pessoais (o mapeamento de dados/calendário atribuído em GERENCIAMENTO DE GRUPO não tem impacto)",
        "nonAdminViewPersonalOnly": "Não administrador - Capacidade de visualizar apenas seus compromissos pessoais",
        "notAtMoment": "Não neste momento. Mas estamos nos esforçando ao máximo para disponibilizá-lo para dispositivos móveis o mais rápido possível.",
        "oldAppointmentsCanBeViewed": "Os compromissos antigos podem ser visualizados na página de compromissos por meio de um botão de alternância.",
        "oldAppointmentsDisplayed": "Os compromissos antigos serão exibidos junto com os compromissos novos na mesma lista de compromissos",
        "oldCalendarVersionAppointments": "Versão Antiga do Calendário + Compromissos Antigos",
        "onlyNewCalendarWidget": "Somente o novo widget de calendário pode ser adicionado",
        "opportunityAddAppointment": "Oportunidade > Adicionar compromisso (Novo)",
        "profilePageAdmin": "Página de perfil para administrador (Novo)",
        "profilePageAllUsers": "Página de perfil (todos os usuários)",
        "providesAllOptions": "Fornece todas as opções (Grupos + Serviços) necessárias para configurar o novo calendário",
        "reintegratingConnectionsRequired": "Pode ser necessário reintegrar todas as conexões após a ativação do Calendário Beta para uma subconta",
        "roundRobinHighlight": "A principal novidade desta atualização é a possibilidade de redistribuir os agendamentos entre diferentes grupos de agentes.",
        "schedulingCalendarAppointments": "Agendamento > Calendário/Compromissos (Novos filtros + Alternar para mudar entre compromissos novos e antigos)",
        "settingsCalendarBeta": "Configurações > Calendário (Beta)",
        "surfacingFirstTime": "Apresentando pela primeira vez",
        "teamManagementAdminOnly": "Gerenciamento de grupo (disponível apenas para administradores)",
        "toggleOffNewVersion": "Desativar (Nova versão)",
        "toggleOnOldVersion": "Habilitar (versão antiga)",
        "whatChangesWithNewVersion": "Quais são as mudanças realizadas na nova versão do calendário?",
        "whatDoesCalendarEntail": "O que o calendário (beta privado) envolve?",
        "whatHappensToOldAppointments": "O que acontece com nossos compromissos antigos depois da transição?",
        "whatWillWeSeeMobile": "O que veremos na versão móvel durante o beta?",
        "willOldAppointmentsBeFactored": "Os compromissos antigos serão considerados ao calcular a disponibilidade para os novos compromissos?",
        "willOldCalendarUrlsWork": "Nossos URLs antigos do calendário continuarão funcionando após a transição?",
        "willWeGetNewVersionMobile": "Vamos poder usar a nova versão em dispositivos móveis durante o beta?",
        "yesOldSettingsPageContinues": "Sim. Na verdade, a página de configurações antiga continuará existindo, assim como a sua capacidade de fazer alterações por lá. O widget de calendário antigo e o novo funcionarão de forma independente, mas estarão constantemente sincronizados para garantir o cálculo preciso da sua disponibilidade nos dois sistemas. Para evitar confusão, recomendamos fortemente que você utilize os novos URLs sempre que possível, para que não precise monitorar dois URLs diferentes para os mesmos conjuntos de usuários.",
        "yesSyncOnGoogleCalendar": "Sim, como a sincronização unidirecional está habilitada, o Google Agenda garantirá que os horários indisponíveis sejam bloqueados."
      },
      "companyPlansModal": {
        "billedAnnually": "Cobrado anualmente",
        "billedMonthly": "Cobrado mensalmente",
        "changePlanFor": "Alterar plano para {locationName}",
        "notAuthorized": "Você não tem autorização para executar esta ação. Somente usuários e administradores da agência, administradores de localização podem realizar isso.",
        "payAnnually": "Pagar anualmente",
        "payMonthly": "Pagar mensalmente"
      },
      "locationBillingHistory": {
        "billingHistory": "Histórico de faturamento",
        "cardNo": "N.º do cartão",
        "errorWhileFetchingInvoices": "Falha ao buscar faturas, clique para tentar novamente",
        "invoiceDescription": "Descrição da fatura",
        "invoiceNo": "Nº da fatura",
        "noInvoices": "Nenhuma fatura",
        "refunded": "Reembolsado",
        "succeeded": "bem-sucedido",
        "view": "VISUALIZAR"
      },
      "locationWallet": {
        "autoRechargeWith": "Recarga automática com",
        "balance": "Saldo:",
        "credits": "Créditos",
        "seeTransactions": "Ver vendas",
        "whenBalanceLowerThan": "quando o saldo for inferior a"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Verifique seu e-mail ({emails}).",
        "csvSentMessage": "Enviaremos um arquivo CSV para seu e-mail. Normalmente leva de 7 a 10 minutos.",
        "enterEmailAddress": "Insira o endereço de e-mail",
        "exportAndSendCsv": "Exportar e enviar CSV",
        "exportTransactions": "Exportar transações",
        "itUsuallyArrives": "Normalmente chega em 10 minutos.",
        "useCommasToSeparate": "Use vírgulas para separar vários e-mails."
      },
      "modifySubscription": {
        "cancelClientDescription": "Cancele a assinatura do seu cliente e encerre a conta",
        "cancelDescription": "Cancele sua assinatura e encerre a conta",
        "cancelImmediately": "Cancelar imediatamente",
        "cancelNow": "Cancelar agora",
        "cancelSubscription": "Cancelar assinatura",
        "changedYourMind": "Mudou de ideia?",
        "changedYourMindClient": "Você pode retomar a assinatura do seu cliente",
        "changedYourMindYou": "Você pode retomar sua assinatura",
        "confirmByTyping": "Confirme digitando {text} abaixo",
        "confirmCancellation": "Confirmar cancelamento",
        "modifySubscription": "Modificar assinatura",
        "modifyYourSubscription": "Modifique sua assinatura",
        "resumeSubscription": "Retomar assinatura",
        "subscriptionWillBeCancelledOn": "Isso agendará o cancelamento da sua assinatura em {date}. Você pode retomar a assinatura anulando o agendamento de cancelamento a qualquer momento.",
        "subscriptionWillBeCancelledOnClient": "Isso programará o cancelamento da assinatura do seu cliente para {date}. Você e seus clientes podem retomar a assinatura anulando o agendamento de cancelamento a qualquer momento.",
        "subscriptionWillBeCancelledOnDate": "Sua assinatura será cancelada em {date}.",
        "subscriptionWillBeCancelledOnDateClient": "A assinatura do seu cliente será cancelada em {date}.",
        "subscriptionWillBeResumed": "Sua assinatura será retomada e você começará a ser cobrado normalmente.",
        "subscriptionWillBeResumedClient": "A assinatura do seu cliente será retomada e a cobrança será feita normalmente.",
        "upgradeDescription": "Migrar para um plano de assinatura superior",
        "weAreGladYouStaying": "Que bom saber que você vai ficar!",
        "nextBillingDate": "Próxima data de faturamento: {date}",
        "cancelImmediatelyTitle": "Você realmente deseja cancelar a assinatura imediatamente?",
        "cancelNowDescription": "Sua assinatura está programada para ser cancelada em {date}. Se optar por cancelar agora, a sua conta, incluindo todas as atividades de envio, como mensagens agendadas e emails, será interrompida imediatamente.",
        "cancelNowDescriptionClient": "A assinatura do seu cliente está programada para ser cancelada em {date}. Se optar por cancelar agora, a conta do seu cliente, incluindo todas as atividades de saída, como mensagens agendadas e e-mails, será interrompida imediatamente.",
        "modifyDescription": "Você pode {action} sua assinatura",
        "modifyDescriptionClient": "Você pode {action} a assinatura do cliente"
      },
      "noPaymentMethodWarning": {
        "addNow": "Adicionar agora",
        "youNeedToEnterCardInfo": "Você precisa inserir os detalhes do seu cartão.",
        "youNeedToEnterClientCardInfo": "Você precisa inserir os detalhes do cartão do seu cliente."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "As cobranças são calculadas com base em tokens. A contagem de palavras mostrada abaixo é uma estimativa para ajudar você a entender o uso. O faturamento real pode variar.",
        "examplePricingGpt4oMini": "Exemplo de precificação - GPT-4o Mini",
        "for750kWords": "(para 750.000 palavras) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Entrada",
        "or": "ou ",
        "output": "Saída",
        "perImage": " /imagem",
        "perResultSelection": " /seleção de resultados",
        "ratesMayDifferUK": "As taxas podem variar de acordo com a região. Os cálculos exibidos são baseados nas taxas do Reino Unido, por favor, verifique nossa",
        "ratesMayDifferUS": "As tarifas podem variar de acordo com a região e o tipo de número. Os cálculos são baseados nas taxas do Twilio para os EUA,",
        "pleaseCheckSupport": "confira nosso",
        "resultSelection": " Seleção de resultados",
        "supportDoc": "documento de suporte",
        "forMoreDetails": "para mais detalhes",
        "words": " palavras"
      },
      "removePaymentMethod": {
        "endingIn": "Terminando em *{cardNo}",
        "no": "Não",
        "removeCard": "Remover cartão?",
        "removing": "Removendo...",
        "yesRemove": "Sim, remover"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Solicitar informações de pagamento do cliente",
        "saasLocationDescription": "Configure uma assinatura SaaS para esta subconta",
        "selectSpace": "Selecione o espaço",
        "spaceDescription": "Escolha onde deseja configurar a cobrança para este local"
      },
      "saasEnableProducts": {
        "disable": "Desabilitar",
        "enableDisableProducts": "Habilitar/desabilitar produtos",
        "feature": "Recurso",
        "unsavedChanges": "Alterações não salvas"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "O próximo faturamento para este cliente parece estar no passado. Isso acontece quando a conta Stripe da sua agência não está funcionando corretamente. Faça login na conta Stripe da agência para corrigir o problema.",
        "copiedText": "texto copiado:",
        "couldNotCopy": "Assíncrono: não foi possível copiar o texto: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Próxima data de faturamento: ",
        "plan": "Plano",
        "pleaseContactAgency": "Entre em contato com a agência para habilitar sua assinatura.",
        "stripeSubscriptionId": "ID de assinatura do Stripe:",
        "subscriptionPlans": "Planos de assinatura",
        "subscriptionWillBeCancelledOn": "Sua assinatura será cancelada em {date}",
        "subscriptionWillBeCancelledOnClient": "A assinatura do seu cliente será cancelada em {date}",
        "toModifyClientSubscription": "para modificar a assinatura do seu cliente",
        "toModifyYourSubscription": "para modificar a sua assinatura",
        "whatsappNumberSubscription": "Assinatura de número do WhatsApp",
        "yourBillingDatePast": "Sua próxima data de faturamento parece estar no passado. Entre em contato com {email} para corrigir isso. Por enquanto, tudo continuará como de costume."
      },
      "salesResources": {
        "certifiedUser": "Usuário certificado",
        "clearFilter": "Limpar filtro",
        "dateRange": "Intervalo de datas"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Você pagará US$ {amount} por mês, faturado {interval}",
        "planUpgradeFailed": "Seu plano não pôde ser atualizado!",
        "planUpgraded": "Seu plano foi atualizado!",
        "retryUpgrade": "Tentar fazer upgrade novamente",
        "upgradeFailed": "A atualização do seu plano falhou, tente novamente",
        "upgradedSuccessfully": "Você atualizou com sucesso seu plano {oldPlan} para {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "faturado como cobrança mensal de {amount} por mês",
        "billedAsYearlyCharge": "faturado como cobrança anual de {amount} por ano",
        "upgradeFrom": "Fazer upgrade de",
        "whatYouWillGet": "O que você receberá:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo após a transação:",
        "callDuration": "Duração da chamada:",
        "callSid": "SID de chamada:",
        "charge": "Cobrança:",
        "contact": "Contato:",
        "contactName": "Nome do contato:",
        "contactPhone": "Telefone de contato:",
        "credit": "Crédito:",
        "creditsAfterTransaction": "Créditos após a transação:",
        "dateSent": "Data de envio",
        "deleted": "<Deleted>*",
        "discount": "Desconto:",
        "eventId": "ID do evento:",
        "from": "De:",
        "noContactFound": "Nenhum contato encontrado",
        "noOfSegments": "Nº de segmentos:",
        "openContactPage": "Abrir página de contato",
        "openConversation": "Abrir chat",
        "openEvent": "Abrir evento",
        "originalCharge": "Cobrança original:",
        "received": "Recebido(a)",
        "smsSid": "SMS SID:",
        "timeBilled": "Tempo faturado:",
        "timeOfCall": "Hora da ligação",
        "transactionDetails": "Detalhes da transação -",
        "transactionId": "ID da transação:",
        "type": "Tipo:",
        "segments": "Segmentos"
      },
      "calendarSettings": {
        "meetings": "Reuniões",
        "services": "Serviços",
        "hideCalendarWarning": "Se você quiser ocultar totalmente o módulo de calendário, faça-o nas configurações da subconta > minha equipe > funções e permissões",
        "calendarSettingsUpdated": "Atualização das configurações do calendário",
        "meetingDescription": "Habilite esta opção para permitir que subcontas usem o recurso de Reuniões, projetado para gerenciar calendários de vendas, chamadas de integração, agendamento em rodízio, colaborações de grupo, agendamento de aulas, entrevistas e muito mais. Ideal para empresas que precisam de ferramentas de agendamento flexíveis e colaborativas.",
        "serviceDescription": "Ative os serviços para dar às subcontas acesso a uma solução de agendamento completa para empresas baseadas em serviços. Isso inclui a criação de páginas de agendamento com vários serviços, o gerenciamento de recursos, de várias subcontas, configuração de precificação específica para a equipe, adição de variações de serviço ou complementos, e muito mais."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Copiado!",
      "copyApiKey": "Copiar chave da API",
      "createApiKey": "Criar chave de API",
      "deleteAllKeys": "Excluir todas as chaves",
      "nameRequired": "O campo Nome é obrigatório.",
      "somethingWentWrong": "Ops! Algo deu errado! Tentar de novo.",
      "updatedSuccessfully": "Atualizado com sucesso"
    },
    "billing": {
      "accountPaused": "Sua conta {name} foi pausada.",
      "accountProvisioned": "Sua conta está sendo configurada.",
      "activateSubAccount": "Habilitar subconta",
      "activeServices": "Serviços ativos",
      "addNewCard": "Adicionar novo cartão",
      "addNewService": "Adicionar novo serviço",
      "addPaymentMethod": "adicione um método de pagamento",
      "alertIcon": "alertIcon",
      "approve": "Aprovar",
      "authenticateCardMessage": "Para maior segurança, você precisa autenticar os dados do seu cartão novamente.",
      "badActorWarning": "Se você acredita que esta subconta foi criada por alguém mal-intencionado, recomendamos excluí-la e cancelar a assinatura correspondente.",
      "callUs": "Ligue para nós",
      "cancelAndDelete": "Cancelar assinatura e excluir subconta",
      "completeFormNextStep": "Conclua o formulário na próxima etapa",
      "congratulations": "🎉 Parabéns! 🎉",
      "contactAgency": "Entre em contato com a sua agência para resolver este problema",
      "contactThroughEmailOrPhone": "Você pode entrar em contato conosco por e-mail ou telefone para resolver isso",
      "dataSafe": "Todos os seus dados estão seguros e todas as automações, páginas da web etc. continuarão a funcionar após o pagamento bem-sucedido.",
      "declineSubAccount": "Rejeitar a subconta",
      "deleteRecommendation": "Recomenda-se excluir essa subconta. Ou você pode fazer isso mais tarde na página Subcontas > Gerenciar cliente.",
      "emailUsAt": "Envie-nos um e-mail para",
      "moveToDashboard": "Mover para o painel",
      "noPaymentMethods": "Parece que nenhum método de pagamento foi adicionado! Por favor",
      "paymentMethod": "Método de pagamento",
      "paymentMethodUpdated": "Seu método de pagamento foi atualizado",
      "paymentNotCompleted": "Você está vendo esta mensagem porque o pagamento não foi concluído.",
      "proceedToNextStep": "Continuar para a próxima etapa",
      "questionMark": "?",
      "reachOutMessage": "fique à vontade para entrar em contato conosco caso tenha alguma dúvida.",
      "reactivateBillingFor": "Reativar o faturamento para {location}",
      "retryPayment": "Tentar novamente o pagamento",
      "secureSystemMessage": "Adotamos um sistema de faturamento mais seguro.",
      "setupMessage": "Alguém entrará em contato com você para configurar a conta. Geralmente leva de 12 a 24 horas,",
      "signout": "Sair",
      "subAccountId": "ID da subconta:",
      "successfullyInitiated": "{product} foi iniciado com sucesso",
      "systemError": "Há um erro no sistema",
      "toReactivate": "para reativar a conta",
      "userImage": "userImage",
      "verificationSkipped": "A verificação de e-mail e telefone dessa subconta será ignorada e o cliente poderá acessá-la.",
      "verifyAccount": "Verificar conta",
      "verifyAfterAttempt": "Você poderá verificar esta conta após pelo menos uma tentativa de verificação por parte do administrador da subconta",
      "verifySubAccount": "Verificar a subconta",
      "recommendedPlans": "Planos Recomendados",
      "buildYourOwnPlan": "CRIE SEU PRÓPRIO PLANO",
      "resetToDefaults": "Redefinir para os padrões",
      "paymentMethodChange": "Se precisar alterar o método de pagamento",
      "approveSubAccount": "Aprovar a subconta",
      "approveSubAccountDescription": "A subconta será retomada, e os administradores da subconta poderão acessá-la e usá-la.",
      "productInitiated": "Produto Iniciado"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Esta ação não pode ser desfeita.",
      "cancelKeep": "Cancelar, manter",
      "confirmDeletionInstructions": "Confirme a exclusão digitando {word} abaixo:",
      "enterConfirm": "Digite {word} para regenerar",
      "message": "A chave de API desta localização será excluída.",
      "title": "Excluir a chave de API desta localização?",
      "yesDelete": "Sim, excluir"
    },
    "generalDetails": {
      "noPermission": "Você não tem permissão para carregar o arquivo. Verifique suas permissões com o administrador da sua agência.",
      "relatedContacts": "({count}) contatos relacionados"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Tem certeza de que deseja excluir todas as chaves de API desta localização?",
      "deleteAllConfirmTitle": "Excluir todas as chaves de API da Localização?",
      "deleteConfirmMessage": "Isso vai excluir a chave de API da localização: {location}. Deseja continuar?",
      "deleteAgencyApiKeyConfirmMessage": "Isso excluirá a chave de API. Deseja continuar?",
      "fetchingLocations": "Buscando localizações...",
      "maxApiKeysMessage": "Você pode ter no máximo 5 chaves de API.",
      "noLocationsFound": "Nenhuma localização encontrada",
      "old": "Antigo",
      "proPlanRequiredMessage": "Isso faz parte da API Avançada disponível no Plano Pro.",
      "searchLocation": "Pesquisar localização",
      "title": "Chave de API da localização"
    },
    "locationCard": {
      "deletionScheduledMessage": "Esta subconta será apagada em {date}, se você mudou de ideia",
      "emailUsageNotRebilled": "O uso de e-mail não está sendo refaturado",
      "emailUsageRebilled": "O uso de e-mail está sendo refaturado para o seu cliente",
      "listings": "Listagens",
      "manageClient": "Gerenciar cliente",
      "paymentPending": "O pagamento está pendente",
      "remainingWalletBalance": "Saldo restante da carteira desta localização SaaS",
      "requestPaymentAgain": "Solicitar pagamento novamente",
      "saasModeActivated": "O modo SaaS está habilitado",
      "saasModeNotActivated": "O modo SaaS não está habilitado",
      "saasSubscriptionNotEnabled": "O plano de assinatura SaaS não está habilitado",
      "saasSubscriptionRunning": "A programação de assinatura SaaS está ativa",
      "social": "Rede social",
      "switchToSaaS": "Mudar para SaaS",
      "switchToSubAccount": "Alternar para subconta",
      "telephoneUsageNotBilled": "O uso do telefone não está sendo faturado",
      "telephoneUsageRebilled": "O uso do telefone está sendo refaturado para o seu cliente",
      "wordpressActive": "WordPress ativo",
      "wordpressInactive": "Wordpress inativo",
      "wordpressNotSoldYet": "WordPress ainda não vendido",
      "wordpressSaleSuccessful": "Venda do WordPress bem-sucedida",
      "yextActive": "Yext ativo",
      "yextInactive": "Yext inativo",
      "yextNotSoldYet": "Yext ainda não foi vendido",
      "yextSaleSuccessful": "Venda bem-sucedida do Yext",
      "reviews": "Avaliações"
    },
    "messageUsage": {
      "acceptTnc": "Aceite os termos e condições",
      "cannotPerformAction": "Não é possível executar esta ação. Por favor, entre em contato com o suporte.",
      "currentLimit": "Limite atual",
      "days": "Dia(s)",
      "failedToUpdate": "Falhou ao atualizar o uso da mensagem",
      "helpCentre": "Central de ajuda",
      "increaseLimitFurther": "Aumentar ainda mais o limite",
      "increaseLimitNow": "Aumentar limite agora",
      "lessThanUsage": "O uso atual é {usage}, e o uso selecionado é menor que o uso atual.",
      "lessThanUsageModal": "O uso atual é {usage}, o limite não pode ser menor que o uso atual",
      "limitAlreadyUnlocked": "O limite já foi desbloqueado",
      "limitReached": "Limite atingido",
      "limitUpdatedFrom": "O limite de {type} foi atualizado de {old} para {new}",
      "lookingForSmsLimit": "Procurando o limite de SMS?",
      "minLimitShould": "O limite mínimo deve ser {limit}",
      "newLimit": "Novo limite de {type}",
      "perDay": "/ Dia",
      "sameLimit": "O limite selecionado é o mesmo que o limite atual!",
      "smsLimitLocation": "O limite de SMS agora pode ser encontrado no plano da subconta",
      "smsLimitSettingsInfo": "Agora, você encontra essas configurações em \"Limite de mensagens\" em \"Configurações avançadas\".",
      "timesInLast30Days": "Vezes nos últimos 30 dias",
      "todaysUsage": "Uso atual",
      "typePerDay": "{type} / Dia",
      "updateLimit": "Atualizar limite",
      "updateLimitFor": "Atualizar o limite de {type} para {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Ativo {type}",
      "contactSource": "Fonte de contato",
      "customer": "Cliente",
      "noPastCampaignsWorkflows": "Sem Passado {type}",
      "pastCampaignsWorkflows": "Passado {type}"
    },
    "settings": {
      "affiliateSettings": "Configurações de Afiliados",
      "agencyBilling": "Cobrança da agência",
      "agencyTeamManagement": "Gerenciamento da equipe da agência",
      "apiKeys": "Chaves de API",
      "compliance": "Conformidade",
      "customMenuLink": "Link personalizado no menu",
      "launchpadSettings": "Configurações do Launchpad",
      "phoneSystemTwilio": "Sistema telefônico - Twilio",
      "smtpService": "Serviço de SMTP",
      "userSettings": "Configurações do Usuário",
      "agencySettings": "Configurações da agência",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Falhou ao criar o instantâneo",
      "pickAnAccount": "Você precisa selecionar uma conta.",
      "snapshotName": "Nome do instantâneo",
      "snapshotNameRequired": "Você precisa dar um nome ao instantâneo."
    },
    "socialDetails": {
      "blogRss": "RSS do Blog",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "ID do Google Places",
      "googlePlus": "Google+",
      "googlePlusUrl": "URL do Google+",
      "instagramUrl": "URL do Instagram",
      "linkedInUrl": "URL do LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL do Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Solicitação via SMS",
    "iAlreadyHaveACustomer": "Eu já tenho um cliente",
    "noAccountFound": "Nenhuma conta encontrada!!",
    "thisIs": "Isto é",
    "pleaseEnterValueBetween0To30Days": "Por favor, insira um valor entre 0 e 30 dias",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Saiba como adicionar uma taxa de configuração única a esses planos",
    "doNotDeleteStripeProductsWarning": "Por favor, <span style=\"font-weight: bold;\">não exclua</span> esses produtos dentro de sua conta Stripe!",
    "opportunityStats": "Estatísticas de Oportunidades",
    "createNewSnapshot": "Criar novo instantâneo",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Painel da agência visível para",
      "onlyMe": "Somente eu",
      "allAgencyAdmins": "Todos os administradores da agência",
      "stripeConnect": "Será descontinuado em breve. Mudar para Stripe Connect",
      "recommendStripe": "Recomendamos o uso do Stripe Connect para maior segurança",
      "switchToStripeConnect": "Mudar para Stripe Connect",
      "highLevelAccess": "A HighLevel terá acesso aos seus dados e poderá criar pagamentos e clientes em seu nome",
      "stripeAccountWarning": "Uma vez conectada, a conta Stripe não poderá ser alterada posteriormente. Recomenda-se o uso de uma nova conta Stripe dedicada aos ganhos da Highlevel.",
      "connectToStripeAccount": "Conecte-se à sua conta do Stripe",
      "unverified": "A conta Stripe conectada a esta agência não é verificada e não pode receber pagamentos. Conclua a verificação fazendo login em sua conta Stripe.",
      "loginToStripe": "Fazer login no Stripe",
      "connectedAccount": "Conta conectada",
      "verified": "VERIFICADO",
      "totalPendingBalance": "Saldo total pendente",
      "disconnectStripe": "Desconectar Stripe",
      "removeSaasPlanConfigurations": "Remover todas as configurações do plano SaaS?",
      "haveSaasPlans": "Você tem planos SaaS criados na conta Stripe.",
      "disconnectWarning": "Se você desconectar, todos os planos SaaS serão perdidos e você precisará criá-los novamente.",
      "acknowledgeDisconnect": "Reconheço que todos os meus planos SaaS serão perdidos e que precisarei refazê-los",
      "disconnect": "Desconectar"
    },
    "zoomSuccess": {
      "title": "Espero que você tenha tido uma ótima experiência.",
      "message": "Agradecemos por participar da ligação. Esperamos hospedá-lo novamente!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Seu profissional de experiência de teste",
      "successSpecialist": "Seu profissional de sucesso",
      "supportSpecialist": "Seu profissional de suporte",
      "jumpOnZoomCall": "Participe de uma chamada Zoom comigo para fazer sua primeira chamada",
      "jumpOnChat": "Fale comigo pelo chat para obter ajuda",
      "joinVideoCallNow": "Participar da videochamada agora",
      "whatToExpect": "O que você pode esperar?",
      "helpArticles": "Artigos de ajuda",
      "changelog": "Registro de alterações",
      "ideasBoard": "Quadro de ideias"
    },
    "saasDashboard": {
      "title": "Painel SaaS",
      "plansAndPricing": "Planos e preços"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Um console mais limpo e rápido já está disponível para esta página. Experimente!",
      "enableInLabs": "Habilitar no Labs",
      "pendingTransferRequests": "Você tem solicitações de transferência de subconta pendentes.",
      "otherAgenciesRequested": "Outras agências solicitaram a transferência de subcontas para você.",
      "reviewRequests": "Solicitações de avaliação",
      "clientList": "Lista de clientes (subcontas)",
      "subAccountTransfers": "Transferências de subconta"
    },
    "implementationModal": {
      "title": "Sua experiência de videochamada HighLevel está prestes a começar.",
      "videoCall": "Videochamada",
      "whatsNext": "O que vem a seguir?",
      "enteringLobby": "Você entrará em nosso lobby com outros membros da HighLevel, como você!",
      "successConcierge": "Nosso concierge de sucesso vai recebê-lo e conectá-lo com o próximo consultor disponível para uma sessão individual.",
      "haveReady": "Tenha o seguinte em mãos:",
      "stableInternet": "Conexão de internet estável.",
      "videoNameMatches": "O nome do seu vídeo coincide com o seu nome de usuário da HighLevel.",
      "estimatedDuration": "Duração estimada da sessão",
      "firstVisit": "Primeira visita: sessão de integração da HighLevel (45-60 min.).",
      "returning": "Retorno: assistência contínua na configuração da implementação (15 a 25 min.).",
      "meetingBegins": "Sua reunião começará automaticamente em <span class=\"text-[#155EEF]\">{ countdown } segundos.</span>  Ou você pode entrar imediatamente clicando no botão abaixo:",
      "joinNow": "Participe agora mesmo"
    },
    "gdpr": {
      "logo": "Logotipo GDPR",
      "dataProtection": "Proteção de dados e GDPR",
      "introduction": "Introdução",
      "intro1": "A HighLevel está comprometida em proteger a privacidade de seus usuários e seus clientes. Nós nos mantemos atualizados sobre as mudanças nas leis de proteção de dados para garantir que você possa ter confiança na sua segurança ao usar nossa plataforma.",
      "intro2": "Esta página tem como objetivo explicar quais são as regras, como elas se aplicam ao seu uso do canal HighLevel e as medidas que tomamos para cumpri-las.",
      "intro3": " Você deve analisar este documento juntamente com nossa Política de Privacidade e entrar em contato com um profissional jurídico especializado caso necessite de mais informações ou aconselhamento.",
      "gdprRegulation": "Regulamento Geral de Proteção de Dados (GDPR)",
      "regulation1": "O Regulamento (UE) 2016/679, mais conhecido como Regulamento Geral sobre a Proteção de Dados (GDPR), é um regulamento da UE que visa harmonizar as leis de proteção de dados e privacidade em toda a UE. As disposições do GDPR aplicam-se sempre que dados pessoais de um titular de dados da UE estiverem envolvidos.",
      "regulation2": "O GDPR tem como foco dar aos indivíduos mais controle sobre como seus dados são usados pelas empresas e tornar a coleta e o processamento de dados mais transparentes.",
      "regulation3": "O GDPR foi incorporado diretamente à legislação do Reino Unido após o fim do período de transição do Brexit, o que significa que as empresas britânicas ainda precisam cumprir suas disposições por meio do \"GDPR do Reino Unido\".",
      "basicConcepts": "Conceitos básicos do GDPR",
      "controllerAndProcessor": "Controlador e processador",
      "controllerProcessorObligation": "O RGPD impõe diversas obrigações a uma pessoa, dependendo se ela é controladora ou processadora de dados pessoais.",
      "controllerDefinition": " Um controlador é uma entidade que decide processar dados pessoais e toma decisões sobre a base legal do processamento e os métodos que serão utilizados. As operadoras têm certas obrigações em relação aos dados pessoais, com as quais você deve se familiarizar antes de coletar dados pessoais de seus clientes.",
      "processorDefinition": "Um processador é uma entidade que processa dados para e em nome de uma operadora. Eles não tomam decisões independentes em relação aos dados ou ao seu processamento, pois apenas os processam em nome da operadora e devem cumprir todas as instruções dadas por ela.",
      "youAreController": "Quando você utiliza o serviço HighLevel, você é um controlador. Você controla os dados que carrega no sistema HighLevel, o que faz com esses dados e o motivo. Consequentemente, você é responsável por garantir que possui uma base legal para processar os dados e que não os retenha por mais tempo do que o necessário.",
      "highlevelIsProcessor": "Você deve garantir que compreende suas obrigações como controladora, e atualizar seus próprios sistemas e políticas para permitir a transferência legal de dados pessoais para a HighLevel. A HighLevel é uma processadora de dados. Nós, por meio da plataforma HighLevel, armazenamos e gerenciamos os dados que você coletou de acordo com suas instruções. Nunca utilizaremos dados pessoais que você tenha carregado no sistema HighLevel para nossos próprios fins ou sem sua instrução.",
      "legalBasisForProcessing": "Base legal para o processamento",
      "legalBasisRequirement": "Dados pessoais só podem ser coletados e processados se houver uma base legal para fazê-lo. As bases legais permitidas estão definidas no GDPR.",
      "processorReliesOnCustomers": "Como processador, a HighLevel depende de seus clientes para selecionar a base legal correta para a coleta e o processamento de dados pessoais, bem como para implementar os avisos e consentimentos adequados. Antes de utilizar o serviço HighLevel, você deve dedicar um tempo para identificar quais bases legais podem estar disponíveis para você e coletar e reter dados pessoais apenas na medida necessária para cumprir essa base. Você não deve alterar a base legal para a coleta de dados pessoais sem um motivo muito forte, por isso é importante entender os requisitos das diferentes bases e garantir que você selecione a base correta desde o início.",
      "dataSubjectAccessRights": "Direitos de acesso do titular dos dados",
      "dataSubjectRights": "O GDPR concede aos titulares dos dados (ou seja, seus clientes) certos direitos relacionados aos seus dados pessoais, incluindo o direito de acessar, corrigir e/ou excluir dados relacionados a eles.",
      "highlevelEasySystems": "A HighLevel implementou sistemas simples para que você nos informe caso receba uma solicitação desse tipo de um titular de dados, e para que nós o informemos caso recebamos uma solicitação desse tipo. Garantiremos que, seguindo suas instruções, essas solicitações sejam atendidas prontamente. Você deve se familiarizar com as obrigações que lhe serão impostas, incluindo as relacionadas a quaisquer dados pessoais que você mantenha em seus próprios sistemas ou serviços que não sejam da HighLevel.",
      "transfersToUSA": "Transferências de dados para os EUA",
      "transfersRestrictions": "Os dados pessoais não podem ser transferidos para fora do Espaço Econômico Europeu (EEE), exceto em circunstâncias específicas. Utilizamos as Cláusulas Contratuais Padrão como parte do nosso Contrato de Processamento de Dados, que assinamos com todos os nossos clientes.",
      "dataSecurity": "Segurança de dados",
      "securitySafeguards": "Implementamos medidas e salvaguardas de segurança robustas para garantir que todos os dados pessoais que detemos sejam armazenados de forma segura. Testamos regularmente nossos produtos em busca de erros e vulnerabilidades.",
      "backupSystems": "Garantimos que temos sistemas de backup regulares em funcionamento, bem como sistemas e processos de recuperação e integridade de dados para minimizar o risco de corrupção ou perda de dados pessoais.",
      "stepsForCompliance": "Medidas que tomamos para garantir a conformidade com o GDPR",
      "dutyAsProcessor": "Levamos muito a sério as nossas obrigações como processador. Implementamos diversos procedimentos e tomamos várias medidas para garantir que permanecemos em conformidade com o GDPR e que você possa nos enviar legalmente os dados pessoais que coletou, por exemplo:",
      "standardContractualClauses": "Nosso contrato de processamento de dados utiliza as Cláusulas Contratuais Padrão para garantir que você possa nos enviar dados pessoais legalmente nos EUA.",
      "detectBreaches": "Somos capazes de detectar violações de segurança pessoais e informar nossos clientes o mais rápido possível.",
      "dealWithAccessRequests": "Podemos lidar com solicitações de acesso do titular dos dados e pedidos de direito ao apagamento, e garantimos que o informaremos quando um titular de dados nos fizer uma solicitação desse tipo.",
      "assessedDocumented": "Avaliamos e documentamos os dados pessoais processados por nós em seu nome.",
      "assessedSecurity": "Avaliamos nossa segurança e a aprimoramos onde necessário para garantir que seja adequada ao nível de risco que enfrentamos em relação a uma violação de dados.",
      "dataProcessingAgreement": "Acordo de Processamento de Dados",
      "dateUpdated": "Data da última atualização: 1.º de abril de 2023",
      "downloadAgreement": "Baixar acordo",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Alguma dúvida?"
    },
    "sendGridSettings": {
      "title": "Configurações do SendGrid",
      "settingsForLocations": "Configurações do SendGrid para subcontas",
      "sendGrid": "SendGrid",
      "last12Months": "Últimos 12 meses",
      "totalSent": "Total de enviados",
      "opens": "Abre",
      "clicks": "Cliques",
      "bounces": "Rejeições"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Desativar o Launchpad para todas as minhas subcontas.",
      "description1": "O Launchpad é uma página de destino bem elaborada e comprovadamente eficaz no aumento da satisfação e fidelização do cliente, aumentando a utilização do produto. ",
      "description2": "A integração com GMB, Facebook, plugin de chat online, uso de app móvel etc., provou ser um excelente recurso para fidelizar os clientes por mais tempo.",
      "confirmDisable": "Tem certeza de que deseja desabilitar o Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Este é o seu link de afiliado. Use este link para permitir que pessoas que você conhece se inscrevam em uma conta e você receberá 40% da receita recorrente mensal delas para sempre.",
      "appendToUrls": "Adicione isto ao final dos seus URLs:",
      "needToSignUp": "Precisa se cadastrar?",
      "goToUrl": "Ir para a URL:",
      "andSignUpUsing": "e cadastre-se usando o endereço de e-mail",
      "asYourEmailAddress": "como seu endereço de e-mail para FirstPromoter.",
      "pageSettings": "Configurações da página",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "ID do pixel"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "A partir de 17 de junho de 2024, a Segurança Aprimorada da Conta será automaticamente habilitada em sua conta por padrão. Os aprimoramentos de segurança incluem:",
      "discontinuationOfAutoGeneration": "Descontinuação da geração automática de chaves API Keys de localização",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusão de chaves de API em APIs CRUD de localização",
      "optOutLink": "Para optar por não participar desta alteração, desative a Segurança Aprimorada da Conta em <a href=\"/settings/company\">Configurações &gt; Empresa</a>",
      "advancedFunctionalityNote": "Esta API é destinada a funcionalidades avançadas. Nossa equipe de suporte não está apta a fornecer assistência direta sobre a configuração da API.",
      "developerCouncilInfo": "Nós oferecemos um Conselho de Desenvolvedores que se reúne para o horário de atendimento uma vez por mês (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) e um canal Slack da Comunidade de Desenvolvedores, onde você pode encontrar assistência da comunidade e da nossa equipe de API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Para utilizar o Zapier, é necessário usar a chave da API de Localização para a localização específica. Você pode obter isso na lista abaixo ou alternando para a conta usando o comutador no menu à esquerda.",
      "partOfAdvancedApi": "Isso faz parte da API Avançada disponível no Plano Pro.",
      "upgradeMessage": "Isso faz parte da API Avançada disponível no Plano Pro. <a>Clique aqui</a> para fazer upgrade."
    },
    "accountMap": {
      "addAccountManually": "Adicionar Conta Manualmente"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Configurações como Grupos."
    },
    "accountDetails": {
      "basicDetails": "Detalhes básicos",
      "saas": "SaaS",
      "rebilling": "Refaturamento",
      "marketplaceApps": "Apps do marketplace",
      "advancedEmailSettings": "Configurações avançadas",
      "calendarSettings": "Configurações do calendário"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Gerenciar as configurações de localização",
      "disableAddEmailService": "Desabilitar o botão \"Adicionar serviço de e-mail\" nas configurações de serviços de e-mail da subconta",
      "disableAddSmtp": "Desabilitar o botão \"Adicionar serviço de e-mail\" nas configurações de serviços de e-mail da subconta",
      "restrictSubAccountEmailProvider": "Restringir usuários de subconta para adicionar seu próprio provedor de serviço de e-mail",
      "disableAddSmtpDescription": "Restringir usuários de subconta de incluir seu próprio provedor de serviço de e-mail",
      "enableReVerification": "Habilitar re-verificação por 90 dias",
      "locationNoLeadConnector": "A localização não possui LeadConnector como provedor de e-mail padrão",
      "lcEmailNotEnabled": "A localização não possui LeadConnector como provedor de e-mail padrão",
      "onlyForAgency": "Você só consegue ver essas configurações habilitadas por agência",
      "onlyVisibleForAgency": "Você só consegue ver essas configurações habilitadas por agência",
      "reVerificationDescription": "Cada status de verificação de e-mail será revogado após 90 dias (Proteja sua reputação como remetente e garanta a mais alta capacidade de entrega na caixa de entrada)"
    }
  },
  "attributes": {
    "addAttribute": "Adicionar atributo",
    "attributeName": "Nome do atributo",
    "enterAttributeName": "Insira o nome do atributo",
    "number": "Número",
    "selectAttributeType": "Selecione o tipo de atributo"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Metadados adicionais",
      "title": "Campos adicionados/atualizados"
    }
  },
  "bulkActions": {
    "additionalDetails": "Detalhes adicionais",
    "allOnGivenDate": "Todo mundo em uma determinada data",
    "attempted": "Tentado",
    "batchQuantity": "Quantidade do lote",
    "bulkActionProcessing": "Carregando ações em massa",
    "bulkActionTitle": "Ação em massa",
    "campaignRequired": "A campanha é obrigatória",
    "currentStatus": "Status atual",
    "delayBetweenBatches": "Atraso entre lotes",
    "dispatchMode": "Modo de envio: {mode}",
    "editBatchQuantity": "Editar quantidade do lote",
    "emailStats": "Estatísticas de e-mail",
    "enterBatchSprintLimit": "Insira um limite de sprint em lote",
    "hideStats": "Ocultar estatísticas",
    "mode": "Modo",
    "nextProcessingOn": "Próximo processamento em",
    "noStatsFound": "Nenhuma estatística encontrada",
    "parentBulkActionID": "ID da ação em massa principal",
    "pleaseEnterQuantity": "Insira uma quantidade",
    "processAllAsSoonAsPossible": "Processar tudo o mais rápido possível",
    "processAllOnGivenDate": "Processar tudo em uma data determinada",
    "processDuring": "Processar durante",
    "processGraduallyDrip": "Processar gradualmente (gotejamento)",
    "processingAllowedOn": "Processamento permitido em",
    "restoredBulkActionId": "ID da ação em massa restaurada:",
    "revert": "Reverter",
    "revertedBulkActionId": "ID da ação em massa revertida:",
    "saveChanges": "Salvar alterações",
    "scheduledStart": "Início programado",
    "showErrorLog": "Exibir log de erros",
    "showImported": "Exibir importações",
    "showStats": "Exibir estatísticas",
    "skipped": "Ignorado",
    "statistics": "Estatísticas",
    "statuses": {
      "complete": "Concluído",
      "next-drip": "Próxima gotejamento",
      "notStarted": "Não iniciado",
      "processing": "Processando",
      "queueing": "Filas",
      "reading": "Leitura",
      "resumed": "Continuar",
      "reverted": "revertido(a)",
      "waiting": "Aguardando"
    },
    "successful": "Êxito",
    "tagsAdded": "Tags adicionadas",
    "tagsRemoved": "Tags removidas",
    "tagsRestored": "Tags restauradas",
    "timeElapsed": "Tempo decorrido",
    "totalExported": "Total exportado",
    "totalMerge": "Total mesclado",
    "unknownError": "Erro desconhecido",
    "updateBatchQuantity": "Atualizar quantidade do lote",
    "updated": "Atualizado",
    "usesDynamicList": "** Usa lista dinâmico",
    "workflowRequired": "É obrigatório um fluxo de trabalho"
  },
  "business": {
    "addedToCompany": "Contato(s) adicionado(s) à empresa com sucesso",
    "cantAddMoreContacts": "Não é possível incluir mais de 50 contatos de uma vez",
    "cleanerUi": "Interface mais limpa",
    "common": {
      "addContact": "Adicionar contato",
      "internalServerError": "Erro Interno do servidor",
      "to": "para"
    },
    "companiesNowHave": "As empresas agora têm",
    "companyNoteLabsText": "Notas da empresa é um recurso de laboratório",
    "contactRemoveCompany": "Tem certeza de que deseja remover este contato da empresa?",
    "moreFunctionalUx": "UX mais funcional",
    "newCompanyUpdate": "Atualização da nova empresa.",
    "tabs": "Guias",
    "tasks": {
      "assignTask": "Atribuir tarefa",
      "assignee": "Titular",
      "deleteTask": "Excluir tarefa",
      "editTask": "Editar tarefa",
      "markAsComplete": "Marcar como concluído",
      "markAsPending": "Marcar como pendente",
      "nameAndDescription": "Nome e descrição",
      "noTasksAvailable": "Nenhuma atividade disponível"
    },
    "visitLabs": "Visite Labs"
  },
  "calendar": {
    "googleCalendar": "Google Agenda",
    "noSync": "Sem sincronização",
    "outlookCalendar": "Calendário do Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Alternar depurador de frontend"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Ocorreu um erro. Tente novamente.",
    "tabs": "Guias",
    "showPassword": "Mostrar senha",
    "hidePassword": "Ocultar senha",
    "goToHomepage": "Ir para a página inicial",
    "leadConnectorHqLogo": "Logo Lead Connector HQ",
    "companyLogo": "Logo da empresa",
    "countries": {
      "australia": "Austrália",
      "austria": "Áustria",
      "czechRepublic": "República Tcheca",
      "belgium": "Bélgica",
      "brazil": "Brasil",
      "canada": "Canadá",
      "chile": "Chile",
      "denmark": "Dinamarca",
      "switzerland": "Suíça",
      "germany": "Alemanha",
      "estonia": "Estônia",
      "spain": "Espanha",
      "finland": "Finlândia",
      "france": "França",
      "uk": "Reino Unido",
      "hongKong": "Hong Kong",
      "hungary": "Hungria",
      "ireland": "Irlanda",
      "italy": "Itália",
      "japan": "Japão",
      "kenya": "Quênia",
      "lithuania": "Lituânia",
      "mexico": "México",
      "netherlands": "Países Baixos",
      "newZealand": "Nova Zelândia",
      "norway": "Noruega",
      "philippines": "Filipinas",
      "puertoRico": "Porto Rico",
      "poland": "Polônia",
      "portugal": "Portugal",
      "sweden": "Suécia",
      "singapore": "Singapura",
      "unitedStates": "Estados Unidos",
      "vietnam": "Vietnam",
      "southAfrica": "África do Sul"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "UE",
      "in": "EM",
      "na": "NA",
      "us": "EUA"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "IVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Editar pool de números - <strong>{name}</strong>",
      "displayphonenumber": "displayPhoneNumber",
      "js_heap_memory": "Memória Heap do JS",
      "vuex_store_modules": "Módulos de loja Vuex",
      "vuex_store_size": "Tamanho da loja Vuex",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://exemplo.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com ou utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "A verificação <strong>SHAKEN/STIR</strong> está concluída para sua subconta. Fortaleça a confiança dos seus clientes com chamadas verificadas.",
      "mp3wavfile": "arquivo mp3/wav",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Etapa {currentStep} de {totalSteps}",
    "loadMore": "Carregar mais",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segmento é igual a um SMS de 160 caracteres. Clique no ícone para saber mais detalhes sobre os preços.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "Um segmento é igual a um SMS de 160 caracteres. Clique no ícone para saber mais detalhes sobre os preços.",
    "_email": "/ e-mail",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% do Total",
    "_please_add_a_payment_method_for": "! Por favor, adicione um método de pagamento para ",
    "_segment": " /segmento",
    "_used": "% utilizado",
    "a_new_twilio_account_needs_to_be_created_before_we": "É necessário criar uma nova conta Twilio antes de podermos iniciar a nova cobrança",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Uma subconta pode ter até 10 objetos personalizados. Se o limite for excedido, nenhum objeto personalizado será criado a partir desse instantâneo.",
    "a_twilio_account_is_already_setup_for_this_location": "Já existe uma conta Twilio configurada para esta localização",
    "accountName": "Nome da conta",
    "account_sid": "SID da Conta:",
    "action": "Ação",
    "actions": "Ações",
    "activate": "Ativar",
    "active": "Ativo",
    "active_listeners": "Ouvintes ativos",
    "active_subscriptions": "Assinaturas ativas",
    "ad_manager": " Gerenciador de anúncios",
    "add": "Adicionar",
    "addAction": "Adicionar ação",
    "add_eliza": "Adicione Eliza",
    "add_image": "Adicionar imagem",
    "add_payment_method": "Adicionar método de pagamento",
    "add_to_account": "Adicionar à Conta",
    "add_user_icon": "Adicionar Ícone de Usuário",
    "add_your_first_email": "Adicione o seu primeiro e-mail.",
    "address": "Endereço",
    "adwords_reporting": "Relatórios do Adwords",
    "affiliate_manager": "Gerente de afiliados",
    "agency": "Agência",
    "agency_logo": "logotipo da agência",
    "agency_settings": "Configurações da agência",
    "agent_reporting": "Relatório de agente",
    "ai_employee": " Funcionário de AI ",
    "all": "Todos",
    "allow_subaccounts_to_cancel_their_subscription": "Permitir que as subcontas cancelem suas assinaturas",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Permitir que as subcontas façam upgrade para um plano superior",
    "allowed_format": "Formato permitido:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Anúncios - clique para abrir em uma nova aba",
    "answers": "Respostas",
    "app_name": "Nome do app",
    "appointments": "Compromissos",
    "apps": " apps",
    "ask_ai": "Pergunte à AI",
    "ask_anything": "Pergunte qualquer coisa...",
    "assigned_to_another_user": "(Atribuído a outro usuário)",
    "at_least_one_location_is_required": "Pelo menos um local é necessário",
    "attach_snapshot": "Anexar instantâneo",
    "attribution_reporting": "Relatório de atribuição",
    "authorized_representative": "Representante autorizado",
    "automation_type": "Tipo de automação",
    "available_hours": "Horários disponíveis",
    "avg_memoryinstance": "Média de memória/instância",
    "back": "Voltar",
    "base_url": "URL base",
    "between_10_kb_and_5_mb": " Entre 10 KB e 5 MB",
    "birthday_sms": "SMS de Aniversário",
    "birthday_sms_with_image": "SMS de Aniversário com Imagem",
    "blogging": "Escrevendo em blog",
    "bounced": "Rejeitado(a)",
    "bulk_requests": "Solicitações em massa",
    "business_email": "E-mail comercial",
    "business_hours_configurations": "Configurações de Horário Comercial",
    "business_industry": "Setor empresarial",
    "business_information": "Informações da empresa",
    "business_logo": "Logotipo da empresa",
    "business_niche": "Nicho da empresa",
    "business_phone": "Telefone comercial",
    "business_physical_address": "Endereço físico da empresa",
    "business_regions_of_operations": "Regiões de operações da empresa",
    "business_registration_id_type": "Tipo de ID de registro comercial",
    "business_registration_number": "Número de registro da empresa",
    "business_type": "Tipo de empresa",
    "business_website": "Site da empresa",
    "busy": "Ocupado",
    "buttons": {
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "deleteAll": "Apagar tudo",
      "view": "Visualizar",
      "close": "Fechar",
      "previous": "Anterior",
      "next": "Seguinte",
      "clear": "Limpar",
      "save": "Salvar",
      "edit": "Editar",
      "delete": "Apagar",
      "reset": "Redefinir",
      "refresh": "Atualizar",
      "nextLoading": "Próximo...",
      "copied": "Copiado",
      "notNow": "Agora não",
      "send": "Enviar",
      "send1": "Enviar",
      "download": "Baixar",
      "sendNow": "Enviar agora",
      "saved": "Salvo(a)",
      "back": "Voltar",
      "update": "Atualizar",
      "add": "Adicionar",
      "submit": "Enviar",
      "submitting": "Enviando",
      "done": "Concluído",
      "manageUsers": "Gerenciar usuários",
      "no": "Não",
      "yes": "Sim"
    },
    "calendar": "Calendário",
    "calendar_groups": "Grupos de calendário",
    "call": "Ligação",
    "call_reporting": "Relatório de Chamadas",
    "call_tracking_is_disabled": "O rastreamento de chamadas está desativado",
    "call_voicemail_settings": "Configurações de chamadas e correio de voz",
    "calls": " ligações",
    "campaign": "Campanha",
    "campaigns": "Campanhas",
    "cancel": " Cancelar ",
    "cancel_subscription": "Cancelar assinatura",
    "cancelled": "Cancelado",
    "certificates": "Certificados",
    "change": "Alterar",
    "changed_data": "Dados alterados",
    "charge": " Cobrança",
    "charged_to_customer": "Cobrado ao cliente",
    "chat": "Chat",
    "chat_user": "Usuário do Chat",
    "chat_widget_icon": "Ícone do Widget de Chat",
    "chats_will_be_saved_for_2_days": "As conversas serão armazenadas por 2 dias",
    "check": "verificar",
    "check_number_validity_before_first_sms_block_incom": "Verifique a validade do número antes de enviar o primeiro SMS, bloqueie chamadas de spam recebidas e pesquise os nomes de chamadores desconhecidos antes de atender o telefone. Cobranças adicionais serão aplicadas",
    "cinque_terre": "Cinque Terre",
    "city": "Cidade",
    "clear_history": "Limpar Histórico",
    "click_here": "Clique aqui",
    "click_on_create_new_snapshot_to_add_one": " Clique em Criar novo instantâneo para adicionar um.",
    "click_to_access_the_highlevel_welcome_course": "Clique para acessar o Curso de boas-vindas da HighLevel",
    "click_to_upgrade": "Clique para fazer upgrade",
    "clicked": "Clicado(a)",
    "clio": "Clio",
    "cloning": "Clonando",
    "close_debugger": "Fechar o depurador",
    "close_whatsapp_template_creator": "Fechar Criador de modelos do WhatsApp",
    "collection": "Coleção",
    "columns": "Colunas",
    "coming_soon": "Em breve",
    "company_email_": "E-mail da empresa (",
    "complete_component_data": "Dados completos do componente",
    "complete_event_data": "Dados Completos do Evento",
    "complete_query_data": "Dados Completos da Consulta",
    "completed": "Concluído",
    "complimentary_credits": "Créditos gratuitos",
    "component": "Componente",
    "component_name": "Nome do Componente",
    "component_type": "Tipo de Componente",
    "components": " componentes",
    "condition": "Condição",
    "confirm": "CONFIRMAR",
    "confirmation_message": "Mensagem de confirmação",
    "confirmed": "Confirmado",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Conecte-se com um Administrador Certificado — clique para abrir em uma nova guia",
    "connect_with_us_start_live_chat": "Conecte-se conosco — inicie um chat ao vivo",
    "connect_your_stripe_account": "Conecte sua conta Stripe ",
    "connect_zoom": "Conectar o Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Considere deixar em branco, caso você opte por usar a localização de reunião pré-configurada",
    "contact": "Contato",
    "contact_support": "contate o suporte",
    "contact_us_call_highlevel_at_18887324197": "Entre em contato conosco — ligue para a HighLevel no +1(888)732-4197",
    "contacts": "Contatos",
    "content_ai": "Content AI",
    "controls": "Controles",
    "conversations": "Conversas",
    "copied": "Copiado",
    "cost_borne_by_you": " custo que cabe a você",
    "count": "Contagem",
    "country": "País",
    "createNewFolder": "Criar nova pasta",
    "credit_balance": "SALDO DE CRÉDITO",
    "current_location_id": "ID da localização atual",
    "custom": "Personalizado(a)",
    "custom_email": "E-mail personalizado",
    "custom_niche": "Nicho personalizado",
    "customer_notifications": "Notificações do cliente",
    "customize": "Personalizar",
    "customize_chat_widget": "Personalizar Widget de Chat",
    "dashboard_stats": "Estatísticas do Dashboard",
    "data_keys": "Chaves de Dados",
    "date": "Data",
    "days": "Dias",
    "dedicated_ip": "IP dedicado ",
    "default": "Padrão",
    "default_snapshots": "Instantâneos padrão",
    "delete": "Excluir",
    "deleted": "excluído",
    "delivered": "Entregue",
    "description": "Descrição",
    "details": "Informações",
    "disable_gbp_messaging_not_recommended": "desabilitar mensagens GBP (não recomendado)",
    "disable_tracking": "Desativar Rastreamento",
    "disabled": "Desabilitado(a)",
    "dismiss": "Ignorar",
    "display_name": "Nome de exibição",
    "do_not_delete": "não excluir",
    "do_something": "FAÇA ALGO",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Deseja manter o mesmo ou criar um novo?",
    "download_application_icon": "Baixar ícone do aplicativo",
    "draft": "Rascunho",
    "dropdown_icon": "ícone de lista suspensa",
    "duplicate": "Duplicar",
    "duration": "Duração",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Tag de bypass Eliza (opcional)",
    "eliza_is_required": "Eliza é necessário.",
    "eliza_service": "Serviço Eliza",
    "email": "E-mail",
    "email_resell_settings": "Configurações de revenda de e-mail",
    "email_sending": "Envio de e-mails",
    "email_signature": "Assinatura de E-mail",
    "enable": "Habilitar",
    "enable_beta": " Ativar Beta",
    "enable_company_automation": "Ativar a automação da empresa",
    "enable_disable_deprecated_features": "Habilitar/desabilitar recursos obsoletos",
    "enable_gbp_call_tracking": " Habilitar rastreamento de chamadas no GBP ",
    "enable_gbp_messaging": "habilitar mensagens GBP",
    "enable_signature_on_all_outgoing_messages": "Habilitar assinatura em todas as mensagens de saída",
    "enabled": "Habilitado(a)",
    "notEnabled": "Não habilitado(a)",
    "enter_a_logical_name": "Insira um nome lógico",
    "enter_the_exact_business_address_as_it_appears_in_": "Insira o endereço comercial exato como aparece na listagem EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Insira a razão social exata da empresa, conforme registrada no EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Insira o endereço completo da rua conforme consta na listagem EIN.",
    "enter_user_email": "Digite o e-mail do usuário",
    "enter_user_phone_number": "Insira o número de telefone do usuário",
    "enter_your_business_registration_id_type": "Informe o tipo de identificação do registro da sua empresa",
    "enter_your_business_vertical_eg_travel": "Insira seu ramo de atividade (ex: Viagens)",
    "error_code": "Código de erro",
    "error_code_chart": "Gráfico de códigos de erro",
    "error_while_copying_api_key": "Erro ao copiar a chave da API!",
    "event": "Evento",
    "event_bus_listeners": "Ouvintes do Event Bus",
    "events": " eventos",
    "everything_in": "Tudo em ",
    "exact": "Exato",
    "execute_this_action_if_the_current_time_falls_in_t": "Execute esta ação se a hora atual estiver dentro desta janela; caso contrário, aguarde até a próxima janela para executar esta ação.",
    "extension": "Extensão",
    "facebook": "Facebook",
    "facebook_ads": "Anúncios do Facebook",
    "facebook_ads_reporting": "Relatórios de anúncios do Facebook",
    "facebook_adsets": "AdSets do Facebook",
    "facebook_campaigns": "Campanhas do Facebook",
    "facebook_icon": "Ícone do Facebook",
    "facebook_page": "Página do Facebook",
    "feature_image": "imagem em destaque",
    "features": "Recursos:",
    "feedback": "Feedback: ",
    "file_path": "Caminho do arquivo",
    "firestore_listeners": "Ouvintes do Firestore",
    "forms": "Formulários",
    "free": "Gratuito",
    "fri": "Sex",
    "friendly_business_name": "Nome fantasia",
    "from": " de ",
    "funnels": "Funis",
    "gbp_call_tracking": "Rastreamento de chamadas GBP",
    "gbp_configuration": "Configuração GBP",
    "general": "Geral",
    "general_information": "Informações gerais",
    "generating_link_please_wait": "Gerando link, por favor, aguarde...",
    "google_ads_adgroups": "Grupos de Anúncios do Google Ads",
    "google_ads_ads": "Anúncios do Google Ads",
    "google_ads_campaigns": "Campanhas do Google Ads",
    "google_ads_keywords": "Palavras-chave do Google Ads",
    "google_business_messaging": "Mensagens do Google Business",
    "google_business_profile": "Perfil do Google Business",
    "google_my_business_icon": "Ícone do Google My Business",
    "hello": "Olá ",
    "here": "aqui",
    "hhmm_a": "hh:mm A",
    "hi": "Olá ",
    "hide": "Ocultar",
    "highlevel_events_click_to_open_in_new_tab": "Eventos HighLevel - clique para abrir em uma nova aba",
    "how_can_i_help_you_today": "Como posso ajudar hoje?",
    "how_did_the_call_go": "Como foi a ligação?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Como faço para calcular o custo do meu e-mail? Clique no ícone para saber mais",
    "how_does_it_work": "Como funciona",
    "htmlElement": "Elemento HTML (TODO):",
    "html_element_todo": "Elemento HTML (TODO): ",
    "id": "ID: ",
    "if": "Se",
    "if_activated_the_sender_information_will_be_automa": "Se ativado, as informações do remetente serão automaticamente adicionadas à primeira mensagem SMS de qualquer mensagem em massa para garantir a conformidade e aumentar as taxas de entrega.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Se ativada, inseriremos links para cancelamento de inscrição nos rodapés dos seus e-mails, para que os destinatários possam cancelar a inscrição sem marcar o e-mail como Reclamação/Spam.",
    "ignore_this_update": "Ignorar esta atualização",
    "image": "imagem",
    "image_turned_on": "Imagem ativada",
    "imported_date": "Data de importação",
    "imported_snapshots": "Instantâneos importados",
    "inbound": "Recebidos",
    "inbound_number": "Número de entrada",
    "incoming_call_timeout": "Tempo limite para chamadas recebidas",
    "instance_id": "ID da Instância",
    "instances": "Instâncias: ",
    "instructions_mentioned_in_this_page": "instruções mencionadas nesta página",
    "internal": "Interno",
    "intro_message": "Mensagem de Introdução",
    "intro_question": "Pergunta Introdutória",
    "invalid": "Inválido",
    "invoicing": "Faturamento",
    "is_scheduled_for_deletion_on": " está agendado para exclusão em ",
    "job_position": "Cargo",
    "job_title": "Título",
    "join_our_facebook_group_click_to_open_in_new_tab": "Participe do nosso grupo no Facebook - clique para abrir em uma nova aba",
    "jpg_or_png": " JPG ou PNG ",
    "just_one_sec": "Aguarde um momento...",
    "key_sizes": "Tamanhos de chave",
    "label": "rótulo",
    "labels": {
      "sortDirection": "Direção de ordenação",
      "tableStyling": "Estilização de tabela",
      "loadingMore": "Carregando mais...",
      "loading": "Carregando...",
      "filter": "Filtrar",
      "search": "Pesquisar...",
      "sortBy": "Ordenar por",
      "perPage": "Por página",
      "date": "Data",
      "time": "Hora",
      "readMore": "Ler mais",
      "day": "Dia",
      "slot": "Intervalo",
      "template": "Modelo",
      "city": "Cidade",
      "country": "País",
      "state": "Estado",
      "customerName": "Nome do cliente",
      "friendlyName": "Nome amigável",
      "required": "* obrigatório",
      "addressLine1": "Endereço - Linha 1",
      "addressLine2": "Endereço - Linha 2",
      "postalCode": "Código Postal",
      "searchUsers": "Pesquisar usuários",
      "unknown": "Desconhecido",
      "businessName": "Nome da empresa"
    },
    "last_updated": "Atualizado(a) em",
    "launchpad_icon": "ícone do launchpad",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(Saiba como?)",
    "legal_business_name": "Razão social",
    "limit_updated_from": " limite atualizado de ",
    "listeners": " ouvintes",
    "loading_your_conversation_history": "Carregando o seu histórico de conversas...",
    "location": "Localização",
    "locations": " subcontas",
    "logical_name": "Nome Lógico",
    "logical_name_is_required": "É necessário um nome lógico.",
    "logo": "Logotipo",
    "mailgun": "MailGun",
    "making_calls": "Realizar chamadas",
    "manage_custom_email": "Gerenciar e-mail personalizado",
    "marketing": "Marketing",
    "maximize": "Maximizar",
    "me_": "Eu (",
    "member_since": "Membro desde",
    "membership": "Assinatura",
    "memory_analysis": "Análise de Memória",
    "memory_api_not_available": "API de Memória não disponível",
    "message": "Mensagem",
    "minimize": "Minimizar",
    "minimum_must_be": " O mínimo deve ser ",
    "miscellaneous_charges": "Cobranças diversas",
    "missed_call_text_back": "Texto para retorno de chamada perdida",
    "missed_text_back_call_message": "Texto de mensagem de retorno de chamada perdida",
    "model": "Modelo",
    "module": "Módulo",
    "modules": " módulos",
    "mon": "Seg",
    "month": "/mês",
    "monthly": "mensalmente",
    "more_emails_in_thread": " mais e-mails na conversa",
    "mount_count": "Montar contagem",
    "mount_time": "Tempo de montagem",
    "moved_to_calendar_settings": "Movido para as configurações do calendário",
    "multiple_locations_using_same_twilio_account": "Várias localizações usando a mesma conta Twilio",
    "must_be_in_range_of_0": " Deve estar no intervalo de 0 a",
    "must_be_less_than_monthly_plan_12": " Deve ser inferior ao Plano Mensal * 12 ",
    "my_business_is": "Meu negócio é ",
    "my_snapshots": "Meus instantâneos",
    "name": "Nome",
    "name_of_other_registration_id_type": "Nome de outro tipo de ID de registro",
    "newFolder": "Nova pasta",
    "new_task_update": "Nova atualização de tarefa!",
    "next": "Seguinte",
    "no_answer": "Sem resposta",
    "no_bigger_than_25mb": "não mais que 2,5 MB",
    "no_customer_selected": "Nenhum cliente selecionado",
    "no_error_data_found": "Nenhum dado de erro encontrado",
    "no_payment_method_available": "Nenhum método de pagamento disponível",
    "no_provider_found": "Nenhum provedor foi encontrado",
    "no_snapshots_found": "Nenhum instantâneo encontrado!",
    "noshow": "Não comparecido",
    "not": "Não",
    "not_now": "Agora não",
    "not_saved": "Não salvo",
    "notes": "Notas",
    "notifications": "Notificações",
    "now": "Agora",
    "numbers_and": " número(s) e ",
    "objective": "Objetivo:",
    "of": "de",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Tutoriais em vídeo de integração - clique para abrir em uma nova aba",
    "online_listings": "Listagens on-line",
    "only_assigned_data": "Somente dados atribuídos",
    "open_performance_debugger": "Abrir Depurador de Desempenho",
    "opened": "Aberto(a)",
    "opportunities": "Leads",
    "options": {
      "ascending": "Ascendente",
      "descending": "Descendente",
      "none": "-- Nenhum --"
    },
    "or_drag_and_drop": "ou arraste e solte",
    "outbound": "Enviados",
    "pagination": "Paginação",
    "pass_body_content_here": " Insira o conteúdo do corpo aqui ",
    "password": "Senha",
    "paused": "Pausado",
    "payment_links": "Links de pagamento",
    "payment_methods": "Métodos de pagamento",
    "payment_refund": "Reembolso de Pagamento",
    "payment_settings_navigation": "Navegação das configurações de pagamento",
    "payments": "Pagamentos",
    "payments_integration": "Integrações de pagamentos",
    "pending": "Pendente",
    "per_page": "Por página",
    "percentage": "Porcentagem",
    "permanently_delete_this_email": "Exclua permanentemente este e-mail",
    "personal_logo": "Logotipo pessoal",
    "phone": "Telefone",
    "phone_number_with_country_code": "Número de telefone (com código do país)",
    "pick_a_niche": "Selecione um nicho",
    "pick_a_snapshot": "Selecione um instantâneo",
    "pick_business_industry": "Selecione o setor empresarial",
    "pick_business_registration_id_type": "Escolha o tipo de ID de registro comercial",
    "pick_business_type": "Selecione o tipo de empresa",
    "pick_job_position": "Selecione o cargo",
    "plans_pricing": "Planos e preços",
    "please_enter_a_value_greater_than_20": "Por favor, insira um valor superior a 20.",
    "pm": "PM",
    "points": "Pontos",
    "postalzip_code": "Código postal/CEP",
    "previous": "Anterior",
    "privacy_policy_url": "URL da Política de Privacidade",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "O Url da Política de Privacidade será exibido nas suas informações do agente do Google.",
    "process_your_payment": "Processe o seu pagamento",
    "profile_picture": "Foto de perfil",
    "profit": "Lucro",
    "prospecting": " Prospecção ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Forneça instantâneos pré-criados para as novas contas.",
    "queries": " consultas",
    "questions": "Perguntas",
    "quick_actions_icon": "Ícone de Ações Rápidas",
    "re_generate_key": "Regenerar chave",
    "read_only": "Somente Leitura",
    "receipts_settings": "Configurações de recibos",
    "receiving_calls": "Recebendo chamadas",
    "recent_events": "Eventos recentes",
    "recommended": "Recomendado",
    "recommended_resolution": "Resolução recomendada:",
    "reconnect": "Reconectar ",
    "record_payment": "Registrar pagamento",
    "registered": " registrado.",
    "renameFolder": "Renomear pasta",
    "replied": "Respondido(a)",
    "representative_email": "E-mail do representante",
    "resell_settings": " Configurações de revenda",
    "reset": "Redefinir",
    "resolve_now": "Resolver agora",
    "resource_counts": "Contagens de Recursos",
    "restore": "Restaurar",
    "results": "Resultados",
    "reviews": "Avaliações",
    "rollover_unused_credits_to_next_month": "Acumule créditos não utilizados para o próximo mês",
    "row": " linha",
    "runNow": "Executar agora",
    "sample_data": "(Dados de Amostra)",
    "sat": "Sab",
    "save": "Salvar",
    "save_missed_call_text_settings": "Salvar configurações de texto de chamadas perdidas",
    "save_staging_url": "Salvar URL de teste",
    "saved": "Salvo",
    "saving": "Salvando...",
    "search": "Pesquisar",
    "search_active_apps": "Procurar apps ativos...",
    "search_components": "Pesquisar componentes...",
    "search_customer": "Pesquisar cliente",
    "search_email": "Pesquisar E-mail",
    "search_history": "Histórico de pesquisa...",
    "search_icon": "Ícone de pesquisa",
    "search_listeners": "Pesquisar ouvintes...",
    "search_modules": "Pesquisar módulos...",
    "search_queries": "Consultas de busca...",
    "see_this_review_on_gbp": "Confira esta avaliação sobre GBP ",
    "segments": " segmentos",
    "select": "Selecionar",
    "select_a_snapshot": "Selecione um instantâneo",
    "monetary": "MONETÁRIO",
    "pleaseSelectAValue": "Selecione um valor",
    "select_account": "Selecionar conta",
    "select_an_account": "Selecione uma conta",
    "select_eliza_bypass_tag": "Selecione a tag de bypass Eliza",
    "select_phone_number": "Selecionar número de telefone",
    "select_send_to_eliza_tag": "Selecione Enviar para a Tag Eliza",
    "select_snapshot": " Selecionar instantâneo",
    "select_upto": "Selecione até ",
    "selected": "Selecionado: ",
    "send": "Enviar",
    "send_to_eliza_tag_optional": "Enviar para Eliza Tag (Opcional) ",
    "seo": " SEO ",
    "settings": "Configurações",
    "setup_pending": "Configuração Pendente",
    "share": "Compartilhar",
    "shared_snapshots": "Instantâneos compartilhados",
    "shared_type": "Tipo compartilhado",
    "shipping_and_delivery": "Envio e entrega",
    "shipping_origin": "Origem do envio",
    "show": "Exibir",
    "showed": "Comparecido",
    "signin_with_single_signon": "Entrar com autenticação única",
    "size": "Tamanho",
    "sms_message_sent_to_customer": "Mensagem SMS enviada ao cliente",
    "snapshot_date": "Data do instantâneo",
    "snapshot_name": "Nome do instantâneo",
    "social_planner": "Planejador de redes sociais",
    "sortBy": "Ordenar por",
    "sortOptions": {
      "createdDate": "Data de criação"
    },
    "source": "Fonte",
    "sources": "Fontes:",
    "spent": "Gasto",
    "staging_url_settings_for_db_event": "Configurações de URL de teste (para evento de Db)",
    "state": "Estado",
    "state_prov_region_": "Estado/Prov/Região*",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alasca",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Califórnia",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "Distrito de Colúmbia",
      "florida": "Flórida",
      "georgia": "Geórgia",
      "hawaii": "Havaí",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "Nova Jersey",
      "new_mexico": "Novo México",
      "new_york": "Nova Iorque",
      "north_carolina": "Carolina do Norte",
      "north_dakota": "Dakota do Norte",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pensilvânia",
      "rhode_island": "Rhode Island",
      "south_carolina": "Carolina do Sul",
      "south_dakota": "Dakota do Sul",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virgínia",
      "washington": "Washington",
      "west_virginia": "Virgínia Ocidental",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Nenhum registro encontrado",
      "noEntriesToShow": "Nenhuma entrada para exibir",
      "unsuccessful": "Sem sucesso",
      "pending": "Pendente",
      "noUsersFound": "Nenhum usuário encontrado"
    },
    "status": "Status",
    "stop_delete_operation": "Interromper a operação de exclusão",
    "street_address": "Rua",
    "street_address_as_it_appears_in_the_ein_listing": "Endereço conforme aparece na listagem EIN.",
    "stripe_icon": "Ícone Stripe",
    "stripe_integration": "Integração Stripe",
    "stripe_secret_key": "Chave Secreta do Stripe",
    "subscriptions": "Assinaturas",
    "sun": "Dom",
    "surveys": "Pesquisas",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspenda a subconta quando a assinatura de SaaS falhar.",
    "switchAccount": "Trocar de conta",
    "switch_off_sections_below_to_disable": "Desative as seções abaixo para desabilitar",
    "tags": "Palavras-chave",
    "tax_settings": "Configurações de impostos",
    "team_management": "Gestão de grupo",
    "team_notifications": "Notificações da equipe",
    "template": "Modelo",
    "terms_and_conditions": "Termos e condições",
    "test_mobile_no": "Testar número de celular",
    "text_messages": "Mensagens de texto",
    "the_proposed_size_is_350px_180px": "O tamanho proposto é 350 px * 180 px",
    "the_proposed_size_is_512512px": "O tamanho proposto é 512*512 px",
    "the_selected_language_will_be_used_by_the_system_a": "O idioma selecionado será usado pelo sistema como padrão.",
    "the_welcome_message_automatically_appears_after_a_": "A mensagem de boas-vindas aparece automaticamente após um usuário iniciar uma nova conversa.",
    "these_are_margins_that_are_billed_to_your_clients_": "Essas são as margens que são cobradas de seus clientes sobre o ",
    "this_data_will_be_used_for_future_compliance_regis": "Esses dados serão utilizados para futuros registros de conformidade.",
    "this_is_my_twilio_use_same": "Este é o meu Twilio, use o mesmo",
    "this_is_visible_to_both_agency_and_location": "Isso é visível tanto para a agência quanto para a localização",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Este nome será visível para leads que estiverem conversando com a sua empresa",
    "this_setting_is_applicable_with_only_team_calendar": "Esta configuração é aplicável apenas aos calendários de equipe.",
    "this_stripe_customer_is_already_connected_to_anoth": "Este cliente do Stripe já está conectado a outra subconta.",
    "thu": "Qui",
    "tiktok": "Tiktok",
    "time_signed": " Hora da assinatura: ",
    "time_zone_": "Fuso Horário *",
    "timestamp": "Carimbo de data/hora",
    "title": "Título",
    "to_resolve_this_problem_follow_the": "Para resolver este problema, siga as ",
    "token": "Token:",
    "total": "Total: ",
    "trigger_link": "Acionar link",
    "triggers": "Gatilhos",
    "tue": "Ter",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configuração do Twilio Pendente",
    "type": "Tipo",
    "type_campaign_objective": "Digite o objetivo da campanha",
    "type_message": "Digite uma mensagem",
    "unsavedChangesWarning": "Suas alterações não serão salvas. Tem certeza de que deseja sair?",
    "unsaved_changes": "Alterações não salvas",
    "unsubscribed": "Inscrição cancelada",
    "unsuccessful": "Sem sucesso",
    "update_business_profile_details": "Atualize os detalhes do perfil comercial",
    "update_is_inprogress_visit_integrations_page_to_fi": "A atualização está em andamento, visite a página de integrações para saber mais.",
    "update_url": "Atualizar URL",
    "updated_date": "Data de atualização",
    "updates": " atualizações",
    "updating": "Atualizando...",
    "upgrade_to_agency_pro": "fazer upgrade para o Agency Pro ",
    "upload": "Carregar",
    "upload_a_file": "Carregar um arquivo",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Use isso para integração com Zapier e API.",
    "user_email": "Email do usuário",
    "user_permissions": "Permissões de usuário",
    "user_role": "Função do usuário",
    "user_type": "Tipo de usuário",
    "valid": "Válido",
    "verification_status": "Status de verificação",
    "verify": "Verificar",
    "verify_email_using_otp": "Verifique o e-mail usando OTP",
    "view_less": " Ver menos ",
    "visiblehidden": "Visível/Oculto",
    "visit_our_help_center_click_to_open_in_new_tab": "Visite nossa Central de ajuda - clique para abrir em uma nova aba",
    "voicemail": "Correio de voz",
    "wave_integration": "Integração Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Encontramos alguns erros nos seus campos de contato. Clique na pasta para visualizar e resolver.",
    "websites": "Sites",
    "wed": "Qua",
    "welcome_message": "Mensagem de boas-vindas",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Ícone do WhatsApp",
    "when": "Quando",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Quando selecionadas, as chamadas serão direcionadas para o seu aplicativo móvel. (Compatível com iOS e Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Quando selecionadas, as chamadas serão direcionadas para o seu app web.",
    "which_business_do_you_want_to_link_to_this_locatio": "Qual empresa você deseja vincular a esta subconta?",
    "widget_code": "Código do Widget",
    "will_give_you_about": " vai te dar aproximadamente",
    "wordpress": "WordPress",
    "wordpress_icon": "Ícone do WordPress",
    "workflows": "Fluxos de trabalho",
    "xero_integration": "Integração Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Você precisa realizar algumas etapas simples para excluir essa localização",
    "you_are_not_authorized_to_perform_this_action_only": "Você não tem autorização para executar esta ação. Somente os administradores da agência podem excluir subcontas.",
    "your_email_cost": "O custo do seu e-mail",
    "your_facebook_page_has_been_integrated_however_the": "Sua página do Facebook foi integrada. No entanto, os seguintes recursos não funcionarão, pois o LeadConnector não possui as permissões necessárias: ",
    "your_outlook_connection_has_expired_please_disconn": "Sua conexão com o Outlook expirou. Desconecte-se e reconecte-se à conta para restabelecer a conexão.",
    "zip_code": "Código postal",
    "zoom_connected_please_close_this_modal": "Zoom conectado, por favor, feche este modal",
    "hidden": "Oculto",
    "messageDetails": "Detalhes da mensagem",
    "openOptions": "Abrir opções",
    "progress": "Progresso",
    "close": "Fechar",
    "loading": "Carregando",
    "fullName": "Nome completo",
    "languages": "Idiomas",
    "phoneNumber": "Número de telefone",
    "phoneNumberWithCountry": "Número de telefone com código do país",
    "sendMessage": "Enviar mensagem",
    "services": "Serviços",
    "servicesProvided": "Serviços oferecidos",
    "pleaseProvideAValid": "Forneça um número de telefone válido.",
    "copy": "Copiar",
    "editApiKey": "Editar chave de API",
    "confirmPay": "Confirmar e pagar",
    "contactUs": "Fale conosco",
    "decline": "Recusar",
    "deleteSubaccount": "Excluir subconta",
    "disabled1": "desabilitado",
    "purchaseSummary": "Resumo da compra",
    "subscriptionPlan": "Plano de assinatura",
    "businessName": "Nome comercial",
    "chooseOne": "Selecionar um...",
    "stateProvRegion": "Estado/Prov/Região",
    "streetAddress": "Endereço",
    "timeZone": "Fuso horário",
    "website": "Site",
    "zipPostalCode": "CEP/Código postal",
    "apiKey": "Chave de API",
    "createdAt": "Criado em",
    "deleteAllLocationApi": "Excluir todas as chaves de API da localização",
    "deleteApiKey": "Excluir chave de API",
    "generatedBy": "Gerado por",
    "lastUsedAt": "Última utilização em",
    "pageNavigation": "Navegação de página",
    "somethingWentWrong": "Algo deu errado!",
    "clickHere": "Clique aqui",
    "emailRebillingActive": "Refaturamento por e-mail ativo",
    "saasSubscriptionActive": "Assinatura SaaS ativa",
    "scheduledForDeletion": "Programado(a) para exclusão",
    "twilioRebillingActive": "Refaturamento do Twilio ativo",
    "iAcknowledgeThisIs": "Confirmo que esta é uma subconta válida e verifiquei o caso de uso de envio de mais de {limit} {type} por dia",
    "iAcknowledgeThisIs1": "Confirmo que esta é uma subconta válida e verifiquei o caso de uso para envio, ajustando assim o limite diário de SMS.",
    "emailSentByLocation": "E-mails enviados por subconta até o momento hoje.",
    "goToSmsLimit": "Acesse as configurações de limite de SMS",
    "toIncreaseTheLimit": "Para aumentar o limite ainda mais, entre em contato com a equipe de suporte.",
    "newLimitOfLimit": "O novo limite de {limit} é inválido. Forneça um valor entre {min} e {max}",
    "typeLimitUpdatedSuccessfully": "Limite {type} atualizado com sucesso",
    "locationsCurrentLimitIs": "O limite atual da subconta é {current}. Você só pode atualizar o limite de {min} e {max} a partir daqui. Para qualquer atualização de limite além de {maxAllowed}, entre em contato com a equipe de suporte.",
    "notNow": "Agora não",
    "smsSentByLocation": "SMS enviado por subconta até o momento hoje.",
    "youHaveSuccessfullyUpdated": "Você atualizou o limite com sucesso",
    "willAutoUnlockIn": "Será desbloqueado automaticamente em",
    "contactType": "Tipo de contato",
    "createdBy": "Criado por:",
    "createdOn": "Criado em:",
    "dateOfBirth": "Data de nascimento",
    "emailAddress": "Endereço de e-mail",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "twilioLookupMarkedThis": "O Twilio Lookup marcou este número de telefone como inválido.",
    "twilioLookupStatedThis": "O Twilio Lookup afirmou que este é um número {type}, portanto, ele não receberá SMS.",
    "accountSnapshot": "Instantâneo da conta",
    "auditLogs": "Registros de auditoria",
    "account": "Conta",
    "selectAccount": "Selecionar conta",
    "facebookUrl": "URL do Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL do Twitter",
    "youtubeUrl": "URL do YouTube",
    "text": "Texto",
    "allTagsLinkedTo": "Todas as tags vinculadas aos contatos selecionados devem ser removidas",
    "automation": "Automação",
    "bulkOperation": "Operação em massa",
    "campaign1": "Campanha",
    "created": "Criado(a)",
    "dateTime": "Data e hora",
    "description1": "Descrição",
    "drip": "Liberação contínua",
    "edit": "Editar",
    "someStatsAreNot": "Algumas estatísticas não estão disponíveis se o provedor for SMTP. A precisão das métricas depende do domínio do destinatário.",
    "error": "Erro",
    "from1": "De",
    "immediately": "Imediatamente",
    "pause": "Pausar",
    "processed": "Processado",
    "queued": "Em fila",
    "restored": "Restaurado",
    "resume": "Continuar",
    "sent": "Enviado(a)",
    "scheduled": "Programado",
    "success": "Sucesso",
    "templateName": "Nome do modelo",
    "total1": "Total",
    "totalAttempted": "Total de tentativas",
    "user": "Usuário",
    "viewDetails": "Visualizar detalhes",
    "workflow": "Fluxo de trabalho",
    "company": "Empresa",
    "note": "Observação",
    "perPage": "por página",
    "showing": "Exibindo",
    "task": "Tarefa",
    "tasks": "Tarefas",
    "customFields": "Campos personalizados",
    "dueDate": "Data devida",
    "tryNow": "Testar agora!",
    "archive": "Arquivar",
    "markAsRead": "Marcar como lido",
    "markAsUnread": "Marcar como não lido",
    "youNeedToAdd": "Você precisa adicionar um calendário para começar a agendar compromissos.",
    "additionalNotes": "Notas adicionais",
    "appointmentStatus": "Status do agendamento",
    "appointmentTitle": "Título do compromisso",
    "contactName": "Nome do contato",
    "contactTimezoneUsedFor": "Fuso horário do contato (usado para lembrete)",
    "day": "Dia",
    "editAppointment": "Editar compromisso",
    "nameRequired": "O nome é obrigatório",
    "slotRequired": "O intervalo é obrigatório",
    "teamMemberIsRequired": "O membro do grupo é obrigatório.",
    "meetingLocation": "Localização da conferência",
    "pickTeamMember": "Selecionar membro do grupo",
    "phoneNumbers": "Números de telefone",
    "roundRobin": "Rodízio",
    "selectCalendar": "Selecionar calendário",
    "selectTeamMember": "Selecionar membro do grupo",
    "actionRequired": "Ação necessária",
    "scheduleAppointment": "Agendar compromisso",
    "considerLeavingItBlank": "Considere deixar em branco, caso você opte por usar o título do compromisso pré-configurado",
    "assignedTo": "Atribuído a",
    "download": "Baixar",
    "loadingTranscription": "Carregando a transcrição...",
    "mute": "Mudo",
    "playpause": "Reproduzir/pausar",
    "playbackSpeed": "Velocidade de reprodução",
    "remove": "Remover",
    "stop": "Parar",
    "timePlayedTotalTime": "Tempo de jogo: tempo total",
    "viewTranscript": "Visualizar transcrição",
    "below": "abaixo",
    "calls1": "Chamadas",
    "liveChat": "Chat ao vivo",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversa no chat atribuída",
    "youAreChoosingNot": "Você está optando por não excluir e fechar a subconta do telefone LC, o que significa que haverá cobrança de uso, independentemente de a localização ser cobrada ou não.",
    "thingsAreJustGetting": "As coisas estão apenas começando, vamos explorar como a HighLevel pode ajudar a construir sua empresa.\nEnquanto isso, você pode continuar enviando mensagens à vontade",
    "wohooConversationsAreFlowing": "Eba! As conversas estão fluindo agora",
    "conversationBegan": "Conversa iniciada",
    "fetchOlderMessages": "Buscar mensagens mais antigas",
    "inboundDndHasBeen": "O DND recebido foi habilitado para este contato",
    "internalComment": "Comentário interno",
    "confirmByTyping": "Confirme digitando",
    "iConfirmToDisconnect": "Confirmo que vou desconectar e encerrar a conta do telefone LC dessa localização. Estou ciente de que isso significa que todos os números e campanhas A2P serão apagados e não poderão ser recuperados.",
    "iConfirmThatI": "Confirmo que discuti este assunto com meu cliente e que tenho autoridade para realizar esta ação",
    "connect": "Conectar",
    "disputeThisReview": "Contestar esta avaliação",
    "dndIsActiveFor": "O DND está habilitado para ligações",
    "off": "DESATIVADO",
    "done": "Concluído",
    "downloadFile": "Baixar arquivo",
    "AddAccount": "+ Adicionar conta",
    "attachFile": "Anexar documento",
    "clickHereToAdd": "Clique aqui para incluir um(a).",
    "customerName": "Nome do cliente",
    "customerPhone": "Telefone do cliente",
    "orEnterAMessage": "Ou insira uma mensagem",
    "fromEmail": "Do e-mail",
    "fromName": "Do nome",
    "youDontHaveAny": "Você ainda não tem nenhum modelo.",
    "requestPayment": "Solicitar pagamento",
    "schedule": "Programar",
    "selectATemplate": "Selecione um modelo",
    "sendNow": "Enviar agora",
    "smtpProvidersHasSome": "Os provedores SMTP têm algumas limitações. Clique aqui para saber mais.",
    "subject": "Assunto",
    "useATemplateSnippet": "Usar um modelo (trecho)",
    "deliveredtotalDelivered": "{delivered}/{total} entregue(s)",
    "countMoreEmailsIn": "{count} e-mails a mais na conversa por chat",
    "primary": "(Principal)",
    "reply": "Responder",
    "respond": "Responder",
    "retry": "Tentar de novo",
    "to": "Para:",
    "fbCommentReplyDm": "Resposta ao comentário no FB - DM",
    "fbMessage": "Mensagem do FB",
    "theseAttachmentsMayNot": "Esses anexos podem não ser mais compatíveis.",
    "urlCannotBeFound": "O URL não pode ser encontrado",
    "activity": "Atividade",
    "filters": "Filtros",
    "goToPost": "Ir para a publicação",
    "inboundCall": "Chamada de entrada",
    "instagramDm": "DM do Instagram",
    "internalChat": "Chat interno",
    "search2": "Pesquisar...",
    "starred": "Marcado como importante",
    "leftAVoicemail": "Deixou uma mensagem de voz",
    "manual": "Manual",
    "mergeFields": "Mesclar campos",
    "addToDocuments": "Adicionar aos arquivos",
    "failedToAddAttachments": "Falha ao adicionar anexos aos arquivos",
    "attachmentsAddedToDocuments": "Anexos adicionados aos arquivos com sucesso",
    "newCommentOnPagename": "Novo comentário na publicação de {pageName}.",
    "outboundCall": "Ligação de saída",
    "replyAsDm": "Responder como DM",
    "replyingAsAPrivate": "Não é possível responder por DM privada para comentários com mais de 7 dias.",
    "reportFeedbackForAi": "Relatar feedback para AI",
    "storyMention": "Menção do Story",
    "storyReply": "Resposta do story",
    "bulkRequest": "Solicitação em massa",
    "eventsAreCurrentlyCaptured": "Atualmente, as ocorrências são capturadas apenas para o endereço de e-mail do contato.",
    "failed": "Falhou",
    "gbpMessage": "Mensagem GBP",
    "pageName": "Nome da página",
    "unknown": "Desconhecido",
    "typeAMessage": "Digite uma mensagem",
    "new": "Novo",
    "newAppointmentBookedBy": "Novo compromisso agendado por",
    "customerNameRequired": "O nome do cliente é obrigatório",
    "messageIsRequired": "A mensagem é obrigatória",
    "pickATemplateTo": "Selecione um modelo para usar.",
    "newMessage": "Nova mensagem",
    "newTask": "Nova tarefa",
    "toMakeACall": "Para fazer uma ligação, insira um número de telefone neste campo.",
    "primary1": "Principal",
    "provider": "Provedor",
    "refresh": "Atualizar",
    "resetPassword": "Redefinir senha",
    "thisReviewHasAlready": "Esta avaliação já foi publicada em {network}. Tem certeza de que deseja republicá-la?",
    "seeThisReviewOn": "Confira esta avaliação sobre GBP",
    "reviewResponse": "Resposta da revisão",
    "searchUsers": "Pesquisar usuários",
    "sendEmail": "Enviar e-mail",
    "sending": "Enviando...",
    "thisSubaccountHasPhonenumberco": "Essa subconta tem {phoneNumberCount} número(s) e {campaignsCount} campanha(s) A2P. Se a conta do sistema de telefone LC não estiver desconectada e fechada, a exclusão dessa conta ainda será cobrada.",
    "thisSubaccountDoesNot": "Essa subconta não tem nenhum número e campanhas A2P. Ao pausar essa conta, não haverá cobrança, mas sugerimos que desconecte e encerre a conta do telefone LC.",
    "summary": "Resumo",
    "unassigned": "Não atribuído",
    "viewSubmission": "Exibir envio",
    "contactSupport": "Fale com o suporte",
    "create": "Criar",
    "illDoThisLater": "Farei isso mais tarde",
    "enterBusinessName": "Insira o nome da empresa",
    "firstNameOfThe": "Nome do proprietário da empresa",
    "mobileBusinessPhone": "Celular/telefone comercial",
    "iDontHaveA": "Eu não tenho um site",
    "clientName": "Nome do cliente",
    "letUsSetupYour": "Vamos configurar sua própria conta ou seu primeiro cliente",
    "clientNameIsRequired": "O nome do cliente é obrigatório",
    "pleaseEnterAValid": "Insira um endereço de e-mail válido",
    "emailAddressIsRequired": "O endereço de e-mail é obrigatório",
    "firstNameIsRequired": "O nome é obrigatório",
    "lastNameIsRequired": "O sobrenome é obrigatório",
    "phoneNumberIsRequired": "O número de telefone é obrigatório",
    "copyOfName": "Cópia de {name}",
    "goToDashboard": "Acessar painel",
    "permissionsNotEnabled": "As permissões não estão habilitadas!",
    "createAndSellCustom": "Crie e venda produtos personalizados com dropshipping de impressão sob demanda",
    "viewApp": "Visualizar aplicativo",
    "seamlessFulfillmentRealtimeShi": "Cumprimento de prazos e taxas de envio em tempo real para suas lojas de comércio eletrônico",
    "learnMore": "Saiba mais",
    "activateFormMapping": "Ativar mapeamento de formulário",
    "avatarName": "Nome do avatar",
    "formFields": "Campos de formulário",
    "formName": "Nome do formulário",
    "mapFields": "Mapear campos",
    "update": "Atualizar",
    "pauseSubaccount": "Pausar subconta",
    "pausing": "Pausando...",
    "subaccount": "subconta",
    "howItWorks": "Como funciona",
    "uponCompletingThisAction": "Após essa ação, a solicitação de transferência será enviada à agência destinatária ({relNo}). Após aceita, a subconta será transferida imediatamente. Essa ação é irreversível.",
    "ejectSubaccount": "Remover subconta",
    "newAgencyCreationMail": "O e-mail de criação da nova agência foi enviado ao usuário selecionado. O usuário pode criar uma nova agência clicando no link enviado no e-mail.",
    "unableToTransferSubaccount": "Não foi possível carregar a subconta para esta agência.",
    "nominateAccountOwnerFor": "Nomear o proprietário da conta para a nova conta",
    "pleaseConfirmOwnershipWill": "Confirme se a propriedade será transferida para",
    "scheduledDate": "Data programada",
    "thisDateIsBased": "Este dia é baseado no fuso horário desta empresa, que é {timezone}",
    "campaignName": "Nome da campanha",
    "copyCampaign": "Copiar campanha",
    "endTime": "Hora de término",
    "event10xEmail4": "Evento: 10X e-mail 4 (distribuição de listagem) ",
    "10xEmail1Reviews": "10X e-mail 1 (avaliações)",
    "fromAddress": "Do endereço",
    "leadValue": "Valor do lead",
    "option1": "Opção 1",
    "option2": "Opção 2",
    "option3": "Opção 3",
    "preview": "Pré-visualizar",
    "selectCampaign": "Selecionar campanha",
    "startTime": "Hora de início",
    "time": "Hora",
    "users": "Usuários",
    "noRecordsFound": "Nenhum registro encontrado",
    "pageDetail": "Detalhe da página",
    "selectAll": "Selecionar tudo",
    "submission": "Envio",
    "addProduct": "Adicionar produto",
    "visitors": "visitantes",
    "By": " por",
    "conversions": "Taxa de conversão ",
    "liveReviews": "Avaliações ao vivo",
    "liveVisitors": "Visitantes ao vivo",
    "pageVisits": "Visitas à página",
    "stream": "Transmitir",
    "addOneOrMore": "Adicione um ou mais URLs de página ou copie-as diretamente do seu navegador.",
    "WeWillAutomatically": " Rastrearemos automaticamente os visitantes do seu site em tempo real. ",
    "connectYourLocationsFacebook": "Conectar a conta do Facebook da sua localização",
    "connected": "Conectado!",
    "Contains": " contém ",
    "expression": "Expressão",
    "facebookAccount": "Conta do Facebook",
    "wowYouDontNeed": "Uau! Você não precisa configurar nada aqui, pode seguir.",
    "Regex": " regex ",
    "selectUrlMatchType": "Selecione o tipo de correspondência de URL",
    "Simple": " simples ",
    "LivePreview": " Pré-visualização ao vivo",
    "seconds": "segundos",
    "launch": "Iniciar ",
    "decorativeVector1": "Vetor decorativo 1",
    "showingFromToTo": "Exibindo {from} a {to} de {total} entradas",
    "cloneProduct": "Clonar produto",
    "connectFacebookInstagram": "Conectar Facebook e Instagram",
    "connectPage": "Conectar página!",
    "everythingIn": "Tudo em",
    "agentChat25": "Chat com agente (tempo de espera de aprox. 2 a 5 minutos)",
    "aiSupportChat": "Chat de suporte com AI",
    "startChat": "Iniciar chat",
    "locations1": "subcontas",
    "phone1": "telefone",
    "slack": "Slack",
    "segments1": "segmentos",
    "areYouSureYou": "Tem certeza de que deseja excluir esta pasta?",
    "verified": "Verificado",
    "highlevelPrice": "Preço da HighLevel",
    "howDoesItWork": "Como funciona?",
    "payNow": "Pagar agora",
    "priceMustBeMore": "O preço deve ser maior ou igual ao preço da HighLevel",
    "saving2": "Salvando",
    "yourPrice": "Seu preço",
    "yourProfit": "Seu lucro",
    "youNeedToComplete": "Você precisa concluir algumas etapas simples de conformidade para desabilitar o modo SaaS para esta localização",
    "youAreNotAuthorized": "Você não tem autorização para executar esta ação. Somente administradores da agência podem realizar isso.",
    "disableSaasModeFor": "Desabilitar o modo SaaS para {name}",
    "companyBilling": "Faturamento da empresa",
    "bccEmailsCommaDelimited": "E-mails em BCC (separados por vírgula)",
    "unableToDeleteMailgun": "Não foi possível excluir a conta do Mailgun. Entre em contato com o suporte.",
    "forwardingAddress": "Endereço de encaminhamento",
    "forwardingAddressesCommaDelimi": "Endereços de encaminhamento (separados por vírgula)",
    "amount": "Quantidade",
    "billingDate": "Data de faturamento",
    "debugWalletTransactionsTotal": "DEPURAR transações da carteira, total: {count}",
    "detailedTransactions": "Transações detalhadas",
    "transactionsOnlyAfter26th": "Apenas as transações após 26 de abril de 2022 estão listadas e disponíveis para exportação",
    "someRecordsMayTake": "Alguns registros podem levar até 24 horas para atualizar aqui.",
    "totalBalance": "Saldo total",
    "walletTransactions": "Transações da carteira",
    "walletTransactionsAllDate": "Transações da carteira - Todas - {date}",
    "enterMessage": "Digitar mensagem",
    "applyThisChangeTo": "Aplique esta alteração a todas as subcontas.",
    "characters": "Caracteres",
    "iConfirmThatI1": "Confirmo que conversei isso com o meu cliente e tenho a aprovação dele.",
    "iConfirmThatI2": "Confirmo que garantirei que todas as mensagens SMS enviadas por esta conta estejam em conformidade com a política atual.",
    "theContentsOfThis": "O conteúdo desta mensagem será automaticamente adicionado ao primeiro SMS que é enviado via Mensagens em massa.",
    "iConfirmThatSms": "Confirmo que as mensagens SMS só serão enviadas para contatos que optaram por receber SMS.",
    "quickTip": "Dica rápida",
    "messageWillBeAppended": "A mensagem será anexada ao primeiro SMS de uma conversa, caso não contenha uma opção de cancelamento de inscrição",
    "readMore": "Ler mais",
    "noncompliantActivityMayLead": "Atividade não conforme pode levar à suspensão dos recursos de SMS e voz da sua conta.",
    "typeConfirmBelowTo": "Digite \"Confirmar\" abaixo para continuar",
    "products": "Produtos",
    "chooseCountry": "Selecione um país...",
    "email2": "E-mail*",
    "firstName1": "Nome*",
    "lastName1": "Sobrenome*",
    "brandDetails": "Detalhes da marca",
    "brandName": "Nome da marca*",
    "useEitherLegalName": "Use o nome legal da organização que está enviando as mensagens ou o seu próprio nome, caso esta marca não represente uma empresa.",
    "businessIndustry": "Setor de negócios*",
    "chooseVertical": "Escolha o segmento...",
    "mobileNumberForOtp": "Número de celular para verificação de OTP (com código do país)*",
    "pleaseProvideAMobile": "Forneça um número de celular ao qual você tenha acesso para confirmar a verificação OTP. Somente números dos EUA ou do Canadá serão aceitos. Você não pode usar um número de telefone CPaaS, como um obtido do LeadConnector. Você não pode usar o mesmo número de celular para registrar mais de 3 marcas de Empreendedor Individual. Esse limite é controlado pelo TCR.",
    "increasedDeliveryRate": "Taxa de entrega aprimorada",
    "sendUpto3000Segments": "Enviar até 3000 segmentos por dia",
    "businessDetails": "Detalhes da empresa",
    "thereWasSomeIssue": "Ocorreu um problema ao enviar o perfil.",
    "yourProfileSubmissionFailed": "O envio do seu perfil falhou.",
    "endUserConsent": "Consentimento do usuário final",
    "minLength40Characters": "Mínimo de 40 caracteres. Máximo de 2.048 caracteres.",
    "closeExamples": "Fechar exemplos",
    "sampleMessage1": "Mensagem de exemplo nº 1*",
    "seeExamples": "Ver exemplos",
    "enterCampaignDetails": "Inserir detalhes da campanha",
    "youWillReceiveAn": "Você receberá uma mensagem OTP no número de celular informado para verificação pelo TCR. Por favor, responda Sim dentro de 24 horas após receber o SMS.",
    "brandNameIsRequired": "O nome da marca é obrigatório.",
    "businessVerticalIsRequired": "O segmento de atuação é obrigatório.",
    "mobileNumberIsRequired": "O número de telefone é obrigatório.",
    "hideDetail": "Ocultar detalhes",
    "showDetail": "Exibir detalhes",
    "people": "pessoas",
    "person": "indivíduo",
    "after": "depois",
    "before": "antes",
    "hour": "hora",
    "hours": "horas",
    "minute": "minuto",
    "minutes": "minutos",
    "triggerLinksEmbeddedIn": "% dos cliques nos links de acionamento (incorporados na mensagem) em relação às mensagens enviadas",
    "addNewEvent": "Adicionar novo evento",
    "addTask": "Adicionar tarefa",
    "manualCall": "Ligação manual",
    "manualSms": "SMS manual",
    "messenger": "Messenger",
    "wait": "Aguardar",
    "webhook": "Webhook",
    "about": "Sobre",
    "accessRestricted": "Acesso restrito",
    "addPartner": "Adicionar parceiro",
    "addPartnerForm": "Formulário para adicionar parceiro",
    "affiliatePortal": "Portal do afiliado",
    "badges": "Emblemas",
    "aBriefBio": "Uma breve biografia",
    "dashboard": "Painel",
    "experience": "Experiência",
    "industryServed": "Setor atendido",
    "instagramAccount": "Conta do Instagram",
    "invoiceHistory": "Histórico de faturas",
    "englishGermanHindi": "English, German, Hindi",
    "linkToWebsite": "link para o site",
    "linkedinAccount": "Conta do LinkedIn",
    "locationId": "Id de localização",
    "partnerName": "Nome do parceiro",
    "partnerStatus": "Reputação do parceiro",
    "paymentDetails": "Detalhes do pagamento",
    "paymentHistory": "Histórico de pagamento",
    "profilePhoto": "Foto do perfil",
    "profilePhotoUrl": "url da foto do perfil",
    "promoterReports": "Relatórios de promotor",
    "searchPartner": "Pesquisar parceiro",
    "twitterAccount": "Conta no Twitter",
    "updatePartner": "Atualizar parceiro",
    "updatePartnerForm": "Atualizar formulário de parceiro",
    "yearOfExperience": "ano de experiência",
    "youtubeAccount": "Conta do Youtube",
    "serviceProvided": "Serviço Prestado",
    "controlTheSubaccountSettings": "Gerenciar as configurações da subconta",
    "generalInfo": "Informações gerais",
    "okay": "OK",
    "proceed": "Prosseguir",
    "addCard": "Adicionar cartão",
    "makeThisCardPrimary": "Definir este cartão como principal",
    "nameOnCard": "Nome no cartão",
    "chargedToCustomer": "Cobrado ao cliente",
    "clientBillingPage": "Página de faturamento do cliente",
    "companyStripeIntegrationPage": "Página de integração do Stripe da empresa",
    "enableRebilling": "Habilitar refaturamento",
    "enabling": "Habilitando...",
    "forMoreDetails": "para mais detalhes.",
    "youreOnTheFreelancer": "Você está no plano Freelancer, que limita sua margem de lucro a 1,05x.",
    "minimumAmountShouldBe": "A quantidade mínima deve estar entre ${min} e ${max}",
    "beforeEnablingThisFeature1": "Antes de habilitar este recurso, conecte sua conta Stripe na",
    "planToSetYour": "planeje aumentar suas margens.",
    "rebillAmount": "Valor de Refaturamento",
    "supportDoc": "documento de suporte",
    "10WillGiveYou": "Com 10 dólares você consegue aproximadamente",
    "minimumMustBeBetween": "O mínimo deve estar entre 0,0001 e 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Desculpe! Você não pode refaturar com a margem de lucro no plano Freelancer, por favor",
    "modifyingTheseSettingsWillChange": "Modificar essas configurações altera o custo incorrido por seus clientes daqui para frente.",
    "pleaseDoNotModifyThese": "Não modifique essas opções se não tiver certeza dos seus efeitos.",
    "theseSettingsWillApply": "Essas configurações serão aplicadas aos seus novos clientes daqui para a frente",
    "congratulationsYourDedicatedIp": "Parabéns! O valor de revenda do seu IP dedicado foi salvo com sucesso.",
    "youHaveAgreedToProvide": "Você concordou em fornecer IPs dedicados diretamente para uma subconta. A agência cobrirá os encargos em nome da subconta.",
    "youHaveDiscontinuedToProvide": "Você interrompeu o fornecimento de IPs dedicados diretamente a uma subconta. A agência não cobrirá mais os encargos em nome da subconta.",
    "oopsSomethingWentWrongAndWeCouldnt": "Ops! Algo deu errado, e não conseguimos salvar a sua configuração dedicada de revenda de IP. Tente novamente mais tarde.",
    "pleaseAgreeToTheTerms": "Por favor, concorde com os termos",
    "errorWhileFetchingDomains": "Erro ao buscar domínios",
    "sameStripeCustomerProfileCantBeMapped": "O mesmo perfil de cliente do Stripe não pode ser mapeado para mais de uma subconta.",
    "pleasePickADifferentStripeCustomer": "Selecione um perfil de cliente Stripe diferente ou use a opção \"Compartilhar um link\" para que possamos criar um novo perfil de cliente Stripe para esta subconta.",
    "clickNextToChooseAPlan": "Clique em \"Próximo\" para escolher um plano e criar uma nova assinatura.",
    "youDontHaveAnyActiveSubscriptions": "Você não tem nenhuma assinatura ativa",
    "youCanEitherSelectAnExistingSubscription": "Você pode selecionar uma assinatura existente ou criar uma nova assinatura na próxima etapa.",
    "useCommasToSeparateMultipleEmails": "Use vírgulas para separar vários e-mails.",
    "useCommasToSeparateMultiplePhoneNumbers": "Use vírgulas para separar múltiplos números de telefone.",
    "noUserFoundInThisLocation": "Nenhum usuário foi encontrado nesta localização",
    "noPhoneNumberAttached": "Nenhum número de telefone vinculado",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Utilize o seguinte link para cadastrar seu método de pagamento.",
    "allowDuplicateContact": "Permitir contato duplicado",
    "allowDuplicateOpportunity": "Permitir oportunidade duplicada",
    "mergeFacebookContactsByName": "Mesclar contatos do Facebook por nome",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Somente mensagens recebidas do Facebook serão mescladas se corresponderem ao nome de um contato existente. Os nomes diferenciam maiúsculas de minúsculas.",
    "disableContactTimezone": "Desabilitar fuso horário de contato",
    "markEmailsAsInvalidDueToHardBounce": "Marcar e-mails como inválidos devido a uma rejeição permanente",
    "contactsEmailsWillBeMarkedAsInvalid": "Os e-mails do contato serão marcados automaticamente como inválidos quando houver rejeição permanente. As ações de e-mail nas automações serão ignoradas para contatos com e-mails inválidos.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Reunir inteligência sobre números de telefone desconhecidos",
    "makeSmsCompliantByAddingAnOptOutMessage": "Torne SMS compatível adicionando uma mensagem de cancelamento.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Se ativada, a mensagem de cancelamento será automaticamente adicionada ao primeiro SMS enviado por mensagens em massa para garantir a conformidade e aumentar as taxas de entrega.",
    "platformLanguage": "Idioma da plataforma",
    "outboundCommunicationLanguageForCustomValues": "Idioma de comunicação externa para valores personalizados",
    "updateInformation": "Atualizar informações",
    "upgradeToTheAgency": "Faça upgrade para o plano Agency Pro",
    "yourCost": "Seu custo",
    "addACalendarTo": "Adicione um calendário para começar a agendar compromissos.",
    "addselectAContactTo": "Adicionar/selecionar um contato para agendar compromissos",
    "appointmentSlotIsNot": "O intervalo do compromisso ainda não foi selecionado",
    "loading1": "Carregando . . .",
    "teamMemberIsRequired1": "O membro do grupo é obrigatório",
    "currentPlan": "Plano atual",
    "features1": "Recursos",
    "upgrade": "Fazer upgrade",
    "viewLess": "Visualizar menos",
    "viewMoreCount": "Ver mais (+{count})",
    "cardNumber": "Número do cartão",
    "expiryDate": "Data de validade",
    "paymentMethods": "Métodos de pagamento",
    "primaryCard": "Cartão principal",
    "removeCurrentCard": "Remover cartão atual",
    "AddBalance": "+ Adicionar saldo",
    "complimentaryCredits": "Créditos gratuitos:",
    "expiringOnDate": "Expira em {date}",
    "apiVersion": "Versão da API",
    "application": "Aplicativo",
    "ipAddress": "Endereço IP",
    "related": "Relacionado",
    "request": "Solicitações",
    "yourAccountIncludingAll": "Sua conta, incluindo todas as atividades de saída, como mensagens programadas e e-mails, será interrompida imediatamente.",
    "yourAccountIncludingAll1": "Sua conta, incluindo todas as atividades de saída, como mensagens programadas e e-mails, será interrompida imediatamente.",
    "nextBillingDateDate": "Próxima data de faturamento: {date}",
    "scheduledForCancellation": "Programado(a) para cancelamento",
    "abandoned": "Abandonado(a)",
    "add1": "Adicionar",
    "addOpportunity": "Adicionar oportunidade —",
    "addOpportunityName": "Adicionar nome da oportunidade",
    "Task": "+ Tarefa",
    "bookupdateAppointment": "Agendar/atualizar compromisso",
    "companyName": "Nome da empresa",
    "areYouSureYou1": "Tem certeza de que deseja excluir esta oportunidade?",
    "contactInfo": "Informações de contato",
    "editOpportunity": "Editar oportunidade —",
    "enterValue": "Digite o valor",
    "goToContactDetail": "Acesse a página de detalhes de contato",
    "leads": "Leads",
    "lost": "Perdido(a)",
    "nameIsRequired": "O nome é obrigatório.",
    "youreNotAllowedTo": "Você não tem permissão para alterar o nome do cliente! Verifique suas permissões com o administrador da agência.",
    "open": "Abrir",
    "opportunity": "Oportunidade",
    "opportunityAlreadyExistsIn": "Já existe uma oportunidade nesse pipeline",
    "opportunityInfo": "Informações da oportunidade",
    "opportunityName": "Nome da oportunidade",
    "opportunitySource": "Fonte da oportunidade",
    "owner": "Proprietário",
    "pipeline": "Pipeline",
    "removeOwner": "Remover proprietário",
    "selectPipeline": "Selecionar Pipeline",
    "selectStage": "Selecionar estágio",
    "stage": "Fase",
    "countTasks": "{count} tarefas",
    "won": "Ganho(a)",
    "and": "e ",
    "addASubscription": "adicione uma assinatura",
    "noSaasPlanEnabled": "Nenhum plano SaaS habilitado",
    "per": "por",
    "assignTo": "Atribuir a",
    "assignedTo1": "Atribuído a:",
    "areYouSureYou2": "Tem certeza de que deseja excluir essa tarefa?",
    "due": "Devido:",
    "dueDateIsRequired": "O campo Data devida é obrigatório",
    "dueIn": "Devido(a) em",
    "dueToday": "Devido(a) hoje",
    "late": "Atrasado(a)",
    "notAssigned": "Não atribuído",
    "taskDescription": "Descrição da tarefa",
    "taskTitle": "Título da tarefa",
    "annually": "anualmente",
    "attachments": "Anexo(s)",
    "areYouSureYou3": "Tem certeza de que deseja apagar esta solicitação em massa?",
    "startImmediately": "Comece Imediatamente",
    "customers": "Clientes",
    "tag": "Tag",
    "pickType": "Selecione o tipo",
    "whoShouldItRun": "Para quem ele deve executar?",
    "addBulkRequest": "Adicionar solicitação em massa",
    "editBulkRequest": "Editar solicitação em massa",
    "scheduledDateIsRequired": "A data programada é obrigatória",
    "newCampaignName": "Novo nome da campanha",
    "areYouSureYou4": "Tem certeza de que deseja apagar esta campanha?",
    "moveToFolder": "Mover para a pasta",
    "pleaseRename": "renomeie",
    "removeFromFolder": "Remover da pasta",
    "photoPreview": "pré-visualização da foto",
    "pleaseWait": "Aguarde...",
    "customValues": "Valores personalizados",
    "whatActionShouldWe": "Que ação devemos executar?",
    "entitynameName": "Nome de {entityName}",
    "useLcEmail": "Usar LC Email",
    "21Jun2018": "21 de junho de 2018",
    "930Am": "9h30 AM",
    "Via": " via ",
    "createdTrackingNumbers": "Números de rastreamento criados",
    "iUnderstandImBuyingadding": "Entendo que estou comprando/adicionando {count} novos números de telefone.",
    "forwardCallsTo": "Encaminhar chamadas para",
    "numberName": "Nome do número",
    "numberPoolName": "Nome do conjunto de números",
    "numberToSwap": "Número para alternar",
    "sameAsForwardingNumber": "Igual ao número de encaminhamento",
    "callFromSource": "Chamada de [Fonte].",
    "callRecording": "Gravação de chamada",
    "84Complete": "84% concluído",
    "thisCallWillBe": "Esta ligação será gravada para fins de garantia de qualidade.",
    "whisperMessage": "Mensagem de aviso",
    "allExceptDirect": "Todos, exceto tráfego direto",
    "allExceptDirectOrganic": "Todos, exceto tráfego direto e orgânico",
    "allSearch": "Todas as Buscas",
    "allVisitorsRecommended": "Todos os visitantes (recomendado)",
    "bing": "Bing",
    "direct": "Direto",
    "visitorsWithoutAReferring": "Visitantes sem site de referência",
    "for": "para",
    "google": "Google",
    "landingPageOrUrl": "Página de destino ou parâmetro de URL",
    "organic": "Orgânico",
    "paid": "Pago(a)",
    "pickOneYouCan": "Escolha uma opção — você sempre pode alterar isso mais tarde.",
    "ppcSearch": "Busca PPC",
    "visitorsFromGoogleBing": "Visitantes de buscas PPC no Google, Bing e Yahoo",
    "referringPage": "Página de referência",
    "visitorsFrom": "Visitantes de",
    "visitorsFromGoogleAds": "Visitantes vindos do Google Ads",
    "visitorsWhoAreReferred": "Visitantes que são indicados de",
    "visitorsWhoLandOn": "Visitantes que chegam à página",
    "whichVisitorsDoYou": "Quais visitantes você deseja rastrear?",
    "yahoo": "Yahoo",
    "17Complete": "17% concluído",
    "callTimeoutS": "Tempo limite de ligações",
    "callWhisper": "Sussurro de ligação",
    "disableVoicemailDetect": "Desativar detecção de correio de voz",
    "eventName": "Nome do evento",
    "timeoutSeconds": "Timeout (segundos)",
    "editCall": "Editar chamada",
    "callWillPatchInstantly": "A ligação será transferida imediatamente; não ouviremos se o correio de voz foi selecionado no lado da oportunidade. Isso significa que a campanha será marcada como respondida, mesmo que a caixa postal atenda.",
    "thisIsTheMessage": "Esta é a mensagem que você quer que a pessoa que atende o telefone ouça. Você pode usar variáveis personalizadas para personalizar esta mensagem.",
    "pleaseCheckTheLinks": "Verifique os links nos quais você tem um valor personalizado. Há um '%20' extra entre {{ e os valores_personalizados.",
    "anErrorOcurredPlease": "Ocorreu um erro. Tente novamente.",
    "pleaseInsertATo": "Insira um endereço de destino.",
    "pickEmailTemplate": "Selecionar modelo de e-mail",
    "sendTest": "Teste de envio",
    "composeEmail": "Escrever e-mail",
    "composeEmailTemplate": "Redigir modelo de e-mail",
    "toAddress": "Para o endereço",
    "addFileThroughUrl": "Adicionar documento via URL",
    "appCharacters": "Caracteres do app:",
    "approximateCost": "Custo aproximado:",
    "estimatedCostForUs": "Custo estimado apenas para SMS dos EUA para os EUA.",
    "mobilePhoneNumber": "Número de telefone móvel",
    "numSegments": "Núm. de segmentos",
    "pickMessageTemplate": "Selecione o modelo de mensagem",
    "pleaseProvideAPhone": "Forneça um número de telefone para o qual possamos enviar o teste.",
    "composeEventtype": "Compor {eventType}",
    "composeEventtypeTextTemplate": "Compor modelo de texto {eventType}",
    "unsupportedSmsContentType": "Tipo de conteúdo SMS não compatível {fileType}",
    "countOfTheProvided": "{count} dos anexos de URL fornecidos {plural} não é(são) uma imagem. Isso pode causar erros no Twilio. Deseja salvar mesmo assim?",
    "dropFileHereOr": "Solte o arquivo aqui ou clique para carregar",
    "ifYouHaveAdditional": "Caso tenha dúvidas adicionais, consulte as Perguntas frequentes sobre o envio de correio de voz na seção de ajuda.",
    "editVoicemail": "Editar correio de voz",
    "selectAMp3Or": "Selecione um arquivo mp3 ou wav; não oferecemos suporte a outros formatos.",
    "voicemailFile": "Arquivo de correio de voz",
    "warningVoicemailDropsAre": "Atenção: o correio de voz é um sistema de melhor tentativa e funciona cerca de 70% das vezes.",
    "youNeedToPick": "Você precisa selecionar pelo menos 1 dia",
    "editWait": "Editar espera",
    "url": "URL",
    "customTime": "Horário personalizado",
    "executeThisActionIf": "Execute esta ação se a hora atual estiver dentro dessa janela; caso contrário, ignore esta etapa e prossiga para a próxima ação.",
    "pickDays": "Selecione dias",
    "pickTime": "Selecionar hora",
    "noRecordsFound1": "Nenhum registro encontrado.",
    "formAnalyze": "Análise de formulário",
    "totalSubmission": "Envio total",
    "forgotPassword": "Esqueceu a senha?",
    "orContinueWith": "Ou continue com",
    "signIn": "Entrar",
    "signIntoYourAccount": "Faça login na sua conta",
    "thePasswordYouPicked": "A senha que você escolheu",
    "yourEmailAddress": "Seu endereço de e-mail",
    "newEmailFrom": "Novo e-mail de",
    "newMessageFrom": "Nova mensagem de",
    "hasLeftANew": "deixou uma nova avaliação.",
    "repliedToTheReview": "respondeu à avaliação.",
    "loaded": "Carregado",
    "snapshot": "Instantâneo",
    "appointment": "Compromisso",
    "appointmentDueInMinutes": "Compromisso agendado para daqui a {minutes} minutos para {contactName}",
    "appointmentReminder": "Lembrete de compromisso",
    "completedCount": "Concluído: {count}",
    "conversation": "Conversa",
    "facebookReview": "Avaliação do Facebook",
    "failedCount": "Falha: {count}",
    "googleReview": "Avaliação do Google",
    "internalChatMessage": "Mensagem interna de chat",
    "usernameMentionedYouIn": "{userName} mencionou você em uma conversa com {contactName}",
    "newAppointmentAssigned": "Novo compromisso atribuído",
    "aNewAppointmentWith": "Um novo compromisso com {contactName} foi atribuído a você.",
    "newAppointmentBooked": "Novo compromisso agendado",
    "youHaveNewAppointment": "Você tem um novo compromisso agendado com {contactName}",
    "newCall": "Nova ligação",
    "aNewChatWith": "Um novo chat com {contactName} foi atribuído a você.",
    "newEmail": "Novo e-mail",
    "newMention": "Nova menção",
    "newReviewReceivedFrom": "Nova avaliação recebida de {contactName}",
    "aNewTypeIs": "Um(a) novo(a) {type} é recebido(a) de {contactName}",
    "notification": {
      "noRecentActivity": "Nenhuma atividade recente"
    },
    "subAccount": "Subconta",
    "subaccount1": "Subconta:",
    "titleOnDateAt": "{title} em {date} às {time} para {contactName}",
    "titleDueInDuetime": "{title} devido em {dueTime} {unitOfTime} para {contactName}",
    "taskReminder": "Lembrete de tarefa",
    "youHaveCountTasks": "Você tem {count} tarefas devidas hoje",
    "youHaveCountTasks1": "Você tem {count} tarefas atrasadas até agora",
    "droppedVoicemailTo": "Deixou correio de voz para",
    "errorWhileCloningProduct": "Falha ao clonar o produto!",
    "productName": "Nome do produto",
    "selectLocations": "Selecionar localizações",
    "selectUptoMaxselectablelocatio": "Selecione até {maxSelectableLocations} localizações",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} mais",
    "emails": "E-mails",
    "accountNotification": "Notificação de conta",
    "customerCare": "Atendimento ao cliente",
    "deliveryNotification": "Notificação de entrega",
    "fraudAlertMessaging": "Mensagens de alerta de fraude",
    "higherEducation": "Ensino superior",
    "lowVolumeMixedRecommended": "Mistura em baixo volume (recomendado)",
    "mixed": "Misturado",
    "pollingAndVoting": "Enquetes e votação",
    "publicServiceAnnouncement": "Anúncio de utilidade pública",
    "securityAlert": "Alerta de segurança",
    "mixedRecommended": "Misturado (Recomendado)",
    "australiaCompanyNumberFrom": "Austrália: Número de registro da empresa na ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canadá: Número comercial canadense (CBN)",
    "indiaCorporateIdentityNumber": "Índia: Número de Identificação Corporativa",
    "greatBritainCompanyNumber": "Grã-Bretanha: Número da Empresa",
    "usaEmployerIdentificationNumbe": "EUA: Número de Identificação do Empregador (EIN)",
    "other": "Outro",
    "israelRegistrationNumber": "Israel: Número de Registro",
    "estoniaVatNumber": "Estônia: Número de IVA",
    "cooperative": "Cooperativa",
    "corporation": "Corporação",
    "limitedLiabilityCompanyOr": "Sociedade de responsabilidade limitada ou empresa individual",
    "nonprofitCorporation": "Empresa sem fins lucrativos",
    "partnership": "Parceria",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Diretor",
    "generalCounsel": "Diretor Jurídico",
    "onlineTrainingEducation": "Cursos e educação online",
    "financialServices": "Serviços financeiros",
    "fitnessLifestyle": "Boa forma e estilo de vida",
    "healthMedical": "Saúde e Medicina",
    "homeServices": "Serviços domésticos",
    "legalServices": "Serviços Jurídicos",
    "marketingAdvertising": "Marketing e Publicidade",
    "others": "Outros",
    "realEstate": "Imóveis",
    "restaurants": "Restaurantes",
    "retailEcommerce": "Varejo e comércio eletrônico",
    "yourInformationHasBeen": "Suas informações foram enviadas com sucesso.",
    "somethingWentWrong1": "Algo deu errado",
    "newPassword": "Nova senha",
    "proceedToLogin": "Prosseguir para o login",
    "anyTime": "a qualquer momento.",
    "callUsHighlevelSupport": "Ligue para o Suporte da HighLevel em",
    "troubleLoggingIn": "Problemas para fazer login?",
    "sendSecurityCode": "Enviar código de segurança",
    "sendCodeToEmail": "Enviar código para o e-mail",
    "verifySecurityCode": "Verificar Código de Segurança",
    "privacyPolicy": "Política de privacidade",
    "businessProfile": "Perfil da empresa",
    "reserveWithGoogleIntegration": "Reservar com Integração Google",
    "friendlyName": "Nome de identificação",
    "updateCallerId": "Atualizar ID do chamador",
    "internationalFormat": "Formato internacional",
    "localFormat": "Formato local",
    "poolNumbers": "Conjunto de números",
    "swappingNumbers": "Números alternados",
    "selectField": "Selecionar campo",
    "surveyAnalyze": "Análise da pesquisa",
    "locationIsRequired": "A localização é obrigatória.",
    "newSurveyName": "Novo nome da pesquisa",
    "copySurvey": "Copiar pesquisa",
    "primaryCalendar": "Calendário principal",
    "cloneEntityname": "Clonar {entityName}",
    "youHaveSuccessfullySubmitted": "Você enviou arquivos com sucesso",
    "addCustomValue": "Adicionar valor personalizado",
    "value": "Valor",
    "youHaveSuccessfullyDeleted": "Você apagou o pacote com sucesso.",
    "bundleDeletedSuccessfully": "Pacote excluído com sucesso",
    "thereIsAnIssue": "Há um problema com um dos seus documentos de suporte. Revise os documentos de suporte e o(s) motivo(s) da rejeição.",
    "connect1": "Conecte-se!",
    "itSeemsEitherThe": "Parece que a conexão com o Google está interrompida ou não está sendo estabelecida na localização atual. Verifique as configurações de integrações e reintegre se a conexão já existir.",
    "selectPage": "Selecionar página",
    "somethingWentWrongPlease": "algo deu errado, tente novamente",
    "accept": "Aceitar",
    "moreThan1Phone": "Mais de um número de telefone permitido",
    "byContinuingToUse": "Ao continuar a usar o Canal HighLevel, você concorda com estes novos {termsLink} e {privacyLink}.",
    "byContinuingToUse1": "Ao continuar a usar o Canal HighLevel, você concorda com estes novos",
    "termsOfService": "Termos de Serviço",
    "weHaveUpdatedOur": "Atualizamos nossos Termos de Serviço e Política de Privacidade, não deixe de conferi-los!",
    "newTriggerName": "Nome do novo gatilho",
    "triggerName": "Nome do gatilho",
    "disableDndForSpecific": "Desabilitar DND para canais específicos",
    "selectAdAccount": "Selecionar conta de anúncio",
    "selectAppointmentStatus": "Selecionar status do agendamento",
    "below1": "abaixo.",
    "Required": "* obrigatório",
    "whenYouGetA": "Quando você receber uma nova avaliação, nós a publicaremos automaticamente na sua página do Facebook. Lembre-se de que a melhor prática é compartilhar no máximo 3 avaliações por dia na sua conta.",
    "skip": "Ignorar",
    "copyShareLink": "Copiar link para compartilhar",
    "agencyRelationshipNumbers": "Números de relacionamento da agência",
    "alteast1AgencyRelationship": "Pelo menos 1 número de relacionamento da agência é obrigatório.",
    "alteast1SubaccountId": "É necessário pelo menos 1 ID de subconta.",
    "somethingWentWrongWhile": "Algo deu errado ao salvar. Tente novamente mais tarde!",
    "5PerPage": "5 por página",
    "10PerPage": "10 por página",
    "amountMustGreaterOr": "O valor deve ser igual ou superior a 1 dólar AUD.",
    "regions": {
      "africa": "África",
      "asia_pacific": "Ásia/Pacífico",
      "europe": "Europa",
      "latin_america": "América Latina",
      "usa_and_canada": "EUA e Canadá",
      "asia": "Ásia",
      "latinAmerica": "América Latina",
      "usaCanada": "EUA e Canadá"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Nenhuma entrada para exibir",
    "clear": "Limpar",
    "filter": "Filtrar",
    "test": "Testar",
    "createNewTwilioSubAccountText": "Você precisará criar uma nova conta Twilio, atualizar as credenciais dessa conta nas configurações do Twilio e mover os números de telefone antes de ativar a refaturamento.",
    "viewing": "Visualizando",
    "makeSmsCompliantByAddingASenderInformation": "Torne SMS conforme adicionando informações do remetente.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Torne o e-mail conforme adicionando um link de cancelamento de inscrição em seu e-mail",
    "enableMissedCallTextBack": "Habilitar resposta em texto para chamadas perdidas",
    "productInventory": "Inventário de Produtos",
    "viewProductVariants": "Visualizar Variantes do Produto",
    "smtpSettings": "Configurações de SMTP",
    "locationOPMTrafficStatis": "Localização OPM Estatísticas de tráfego",
    "locationGPMTrafficStatis": "Estatísticas de Tráfego de Localização GPM",
    "blacklistMonitorReports": "Relatórios do monitor da lista negra",
    "twoFactorAuthentication": "Autenticação de dois fatores (2FA)",
    "recent": "Recente",
    "noPermission": "Você não tem permissão para gerenciar modelos para este produto. Redirecionando para o painel.",
    "tasksNowHave": "As tarefas agora possuem",
    "option": "Opção",
    "facebookAdsReporting": "Relatórios de anúncios do Facebook",
    "googleAdsReporting": "Relatórios Google Anúncios",
    "adsDatePicker": "Seletor de Datas de Anúncios",
    "feedbackSubmitBtn": "Botão Enviar Feedback",
    "ifYouThinkMistakePleaseContact": "Se achar que isso é um erro, entre em contato",
    "forResolution": "para resolvermos.",
    "live": "Ao vivo",
    "payouts": "Pagamentos",
    "greatChoice": "Ótima escolha!",
    "toNavigate": "navegar",
    "teams": "Grupos",
    "role": "Função",
    "searchAccounts": "Pesquisar Contas",
    "searchByNameEmailPhone": "Pesquisar por nome, e-mail ou telefone",
    "addEmployee": "Adicionar Funcionário",
    "removeFromLocation": "Remover da subconta",
    "knowMore": "Saiba mais",
    "usingNumberPool": "Usando o Pool de Números",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Revisor",
    "cancel1": "Cancelar",
    "delete1": "Excluir",
    "call1": "Ligação",
    "message1": "Mensagem",
    "name1": "Nome",
    "voicemail1": "Correio de voz",
    "title1": "Título",
    "choose_one": "Selecionar um",
    "select_page": "Selecione a página",
    "confirm1": "Confirmar",
    "conversations1": "Conversas",
    "copied1": "Copiado",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Voltar",
    "details1": "Informações",
    "month1": "/mês",
    "select1": "Selecionar",
    "share1": "Compartilhar",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Relatórios do Monitor de Lista Negra",
      "domainPurchase": "Compra de domínio"
    },
    "confirmDelete": "Tem certeza de que deseja excluir {name}?",
    "clicked1": "Clicado(a)",
    "delivered1": "Entregue",
    "invalid1": "Inválido",
    "open_options": "Abrir opções",
    "_add_account": "Adicionar conta",
    "setTimezoneWarning": "Por favor, defina o fuso horário da sua localização para obter os horários disponíveis adequados.",
    "save1": "Salvar",
    "action1": "Ação",
    "actions1": "Ações",
    "all1": "Todos",
    "previous1": "Anterior",
    "results1": "Resultados",
    "next1": "Seguinte",
    "payments1": "Pagamentos",
    "settings1": "Configurações",
    "total_js_heap": "Total de Heap JS",
    "table": {
      "pagination": {
        "previous": "Anterior",
        "next": "Próximo"
      },
      "rowsSelected": "{count} colunas selecionadas",
      "cantRearrange": "{type} não pode ser reorganizado"
    },
    "ivrCall": "Ligação de IVR",
    "sms": "SMS",
    "username": "Nome de usuário",
    "stay": "Permanecer",
    "placeholders": {
      "selectCountry": "Selecione seu país",
      "nameOfBusiness": "Nome da empresa",
      "line1": "Linha 1",
      "line2": "Linha 2",
      "enterState": "Insira o estado",
      "enterCity": "Insira a cidade",
      "enterPostalCode": "Insira o código postal",
      "chooseCountry": "Selecione um país..."
    },
    "addressLine1": "Endereço - Linha 1",
    "addressLine2": "Linha de Endereço 2",
    "postalCode": "Código postal",
    "nameOfBusiness": "Nome da empresa",
    "dispute_this_review": "Contestar esta avaliação",
    "story_mention": "Menção do Story",
    "story_reply": "Resposta do story",
    "no": "Não",
    "yes": "Sim",
    "annual": "anual",
    "plan": "Plano",
    "errors": {
      "somethingWrong": "Algo deu errado"
    },
    "zero": "0",
    "perMonth": "por mês",
    "emailCheckLinks": "Verifique os links nos quais você tem um valor personalizado. Há um \"%20\" extra entre o {{ e os valores personalizados.",
    "fileSizeTooLarge": "O arquivo excede 5 MB.",
    "fileSizeTooLargeDescription": "O arquivo que você está tentando enviar é muito grande. Tente com um arquivo menor",
    "minMaxLength40Characters2048Characters": "Comprimento mínimo: 40 caracteres. Máximo de 2.048 caracteres.",
    "sampleMessage2": "Mensagem de exemplo #2*",
    "pleaseSelectWorkflow": "Selecione um fluxo de trabalho",
    "childrens": "Crianças",
    "brandAndCampaignRegistration": "Será cobrada uma taxa única de US$ 20,95 pelo registro da marca e pela campanha. Uma taxa adicional de campanha de até US$ 2,25 por mês será aplicada de acordo com as regras da TCR.",
    "einRequiredForRegistration": "EIN obrigatório para o registro",
    "changed_props": "Propriedades alteradas",
    "total_memory": "Memória Total",
    "total_store_size": "Tamanho total da loja",
    "total_watchers": "Total de Observadores",
    "update_count": "Atualizar contagem"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Ações em massa",
      "clickHere": "Clique aqui para visualizar a lista de atividades em massa.",
      "mergedMessage": "Esta página foi mesclada com a lista de atividades em massa.",
      "title": "Solicitações de Contato"
    }
  },
  "conversations": {
    "noConversationsFound": "Nenhuma {status} conversa encontrada",
    "create_new": "Criar nova mensagem​",
    "validations": {
      "minCharsRequired": "Mínimo de 3 caracteres obrigatórios",
      "twoMoreCharsRequired": "É necessário mais 2 caracteres",
      "oneMoreCharRequired": "É necessário mais 1 caractere"
    },
    "sortLabels": {
      "latestAllMessages": "Mais recentes - Todas as mensagens",
      "oldestAllMessages": "Mais antigas - Todas as mensagens",
      "latestManualMessages": "Mais recentes - Mensagens manuais",
      "oldestManualMessages": "Mais antigas - Mensagens manuais",
      "latestAll": "Todas as mais recentes",
      "oldestAll": "Todas as mais antigas",
      "latestManual": "Mais recentes - Manuais",
      "oldestManual": "Mais antigas - Manuais",
      "highToLow": "{name} (do maior para o menor)",
      "manualMessagesTooltip": "A opção de classificação será aplicável às mensagens após 18 de maio de 2023."
    },
    "deleteConversation": {
      "title": "Confirmação",
      "confirmWithName": "Tem certeza de que deseja excluir o chat com {name} permanentemente? Isso não pode ser desfeito.",
      "confirmWithoutName": "Tem certeza de que deseja excluir este chat permanentemente? Isso não pode ser desfeito."
    },
    "makeCall": {
      "enterPhoneNumber": "Para fazer uma ligação, insira um número de telefone neste campo.",
      "invalidPhoneNumber": "O Twilio Lookup marcou este número de telefone como inválido."
    },
    "actions": {
      "markAsStarred": "Marcado como importante",
      "unarchive": "Desarquivar",
      "unmarkAsStarred": "Desmarcar como importante"
    },
    "send": {
      "perMonthPerIp": "/Mês/IP",
      "perIp": "/ IP",
      "replyingTo": "Respondendo a",
      "requestClientsPaymentDetails": "Solicitar informações de pagamento dos clientes",
      "saasModeCreditCardRequired": "O modo SaaS requer que o cliente tenha um cartão de crédito registrado.",
      "please": "Por favor",
      "firstBeforeEnablingSaaS": "primeiro, antes de habilitar o Modo SaaS.",
      "shareALink": "Compartilhar um link",
      "shareLinkInstructions": "Compartilhe um link com o seu cliente para coletar os dados de pagamento deles",
      "requestViaEmail": "Solicitação por e-mail",
      "twilioRebillingDescription": "Refature os custos do Twilio ({twilioCopy}) para seus clientes e inclua uma margem de lucro",
      "seeHow": "Veja como",
      "phoneRebillingCardInfoRequired": "Para o serviço de refaturamento telefônico, é necessário que o cliente tenha cadastrado os dados do cartão de crédito.",
      "clientsCompanyBillingPage": "página de faturamento da empresa do cliente",
      "ifYouPayForTwilioKeepUsing": "Se você paga pelo Twilio, continue usando a mesma conta do Twilio",
      "ifClientPaysForTwilioCreateNew": "Se o cliente pagar pelo Twilio, crie uma nova conta no Twilio",
      "learnHow": "Saiba como",
      "createNewTwilioAccountInstructions": "Crie uma nova conta Twilio para esta localização",
      "learnHowToMovePhoneNumbers": "Saiba como mover números de telefone",
      "thisIsMyClientsTwilioCreateNew": "Este é o Twilio do meu cliente, crie uma nova conta",
      "featureUnderDevelopment": "Este recurso está em desenvolvimento",
      "emailRebillingDescription": "Refature os custos de e-mail para seus clientes e inclua uma margem de lucro",
      "emailRebillingCardInfoRequired": "O refaturamento por e-mail requer que as informações do cartão do cliente estejam registradas.",
      "emailRebillingMarginsDescription": "Essas são margens cobradas de seus clientes além dos custos de e-mail",
      "provider": "Provedor",
      "morePlanCustomizationsAvailable": "Mais personalizações de planos disponíveis",
      "plansAndPricing": "Planos e preços",
      "connectYourStripeAccountFirst": "Primeiro, conecte sua conta Stripe",
      "createRecommendedPlansOnStripe": "Crie planos recomendados no Stripe",
      "createdPlanInStripe": "Plano criado no Stripe",
      "customizeYourSaasPlans": "Personalize os seus planos de SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Você pode oferecer planos recomendados ou criar os seus próprios",
      "trialPeriod": "Período de teste",
      "enterNumberOfDaysForTrial": "Insira o número de dias para o teste",
      "nameCantBeEmpty": "O nome não pode estar vazio",
      "showStripeProductDetails": "Mostrar Detalhes do Produto Stripe",
      "addEmail": "Adicionar e-mail",
      "resetMountCounts": "Redefinir Contagens de Montagem",
      "connectReconnectGoogleForGbp": "Conecte ou reconecte o Google para GBP",
      "downloadFile": "Baixar arquivo",
      "showOnlySlowQueries": "Mostrar Apenas Consultas Lentas",
      "gmbMessagingAvailable": "A mensagem GMB já está disponível",
      "reconnectGbpPageToEnable": "Reconecte sua página GBP para habilitar a troca de mensagens",
      "failedPaymentsCheckBilling": "Pagamentos não realizados detectados. Verifique a sua fatura.",
      "onlyAgencyAdminsCanSeeWarning": "Somente os administradores da agência podem ver este aviso.",
      "filter": "Filtrar",
      "stopDeleteOperation": "Interromper a operação de exclusão",
      "summary": "Resumo",
      "enableTracking": "Habilitar Rastreamento",
      "exportAll": "Exportar tudo",
      "newConversationStarted": "Nova conversa iniciada",
      "startNewConversation": "Iniciar novo chat",
      "subAccountScheduledForDeletion": "Subconta programada para exclusão",
      "deleteSubAccountOnScheduledTime": "Excluir subconta no horário agendado",
      "componentUpdatesDebuggerAlpha": "Depurador de Atualizações de Componentes (Alpha)",
      "componentUpdateTrackingDisabled": "O rastreamento de atualização de componentes está desativado.",
      "deleteSubAccount": "Excluir subconta",
      "subAccountHasNumbersAndCampaigns": "Esta subconta tem {phoneNumberCount} número(s) de telefone e {campaignsCount} campanha(s).",
      "subAccountNoNumbersOrCampaigns": "Esta subconta não tem números de telefone ou campanhas.",
      "areYouSureDeleteSubAccount": "Você tem certeza de que deseja excluir essa subconta?",
      "confirmDiscussedWithClient": "Confirmo que discuti isso com o meu cliente",
      "understandActionIrreversible": "Entendo que essa ação é irreversível",
      "confirmDisconnectCloseLcPhone": "Confirmo que desejo desconectar e encerrar a conta LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Aviso: caso opte por não excluir a conta LC Phone, você continuará a ser cobrado pelos números de telefone associados a esta subconta.",
      "deleteAccount": "Excluir conta",
      "send": "Enviar",
      "typeMessage": "Digite uma mensagem",
      "requestPayment": "Solicitar pagamento",
      "reply": "Responder",
      "retry": "Tentar de novo",
      "analyzeMemory": "Analisar Memória",
      "memoryAnalysisApproximate": "🚧 A análise de memória é aproximada e não é 100% precisa.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Essa subconta foi programada para exclusão. Ela será excluída em",
      "youCanChangeYourMindBeforeThisTime": "Você pode mudar de ideia antes desse momento.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Ignorar",
          "cannotIdentifyContact": "Não é possível identificar o contato e sua localização.",
          "contactNotSelected": "O contato não foi selecionado.",
          "messageRequired": "Confira se inseriu uma mensagem ou um modelo selecionado.",
          "noPhoneNumber": "O contato não possui número de telefone.",
          "genericError": "{message}",
          "stayPrompt": "Permanecer"
        },
        "scheduledSuccess": "E-mail programado com sucesso",
        "confirmDelete": "Tem certeza de que deseja excluir {name}?"
      },
      "clear": "Limpar",
      "edit": "Editar",
      "sendNow": "Enviar agora",
      "schedule": "Programar",
      "useTemplate": "Usar um modelo (trecho)",
      "mergeFields": "Mesclar campos",
      "customVariablesError": "Existem problemas nas suas variáveis personalizadas, corrija-os antes de enviar.",
      "sendLater": "Enviar mais tarde",
      "scheduledFor": "Programado para {date}",
      "call": "Ligação",
      "leftVoicemail": "Deixou uma mensagem de voz",
      "pleaseSelectCampaign": "Selecione uma campanha",
      "whatsapp": {
        "no24HourMessage": "Você só pode enviar mensagens de modelo fora da janela de 24 horas. Selecione um modelo para enviar."
      },
      "attachFile": "Anexar arquivo",
      "email": {
        "fromEmail": "Do e-mail",
        "fromName": "Do nome",
        "smtpWarning": "Os provedores SMTP têm algumas limitações. Clique aqui para saber mais.",
        "subject": "Assunto",
        "errors": {
          "cannotIdentifyContact": "Não é possível identificar o contato e sua localização.",
          "contactNotSelected": "O contato não foi selecionado.",
          "genericError": "{message}",
          "bodyRequired": "O e-mail requer o envio de um texto no corpo da mensagem.",
          "noEmailAddress": "O contato não tem um endereço de e-mail."
        },
        "scheduledSuccess": "Email programado com sucesso"
      },
      "addCalendarToSchedule": "Você precisa adicionar um calendário para começar a agendar compromissos.",
      "slotRequired": "O intervalo é obrigatório",
      "teamMemberRequired": "O membro do grupo é obrigatório."
    },
    "added": "adicionado(a)",
    "loadMore": "Carregar mais",
    "admin": "Administrador",
    "aiEmployee": {
      "popupBlockedAlert": "Você desabilitou o pop-up. Habilite o pop-up para este site redirecionar automaticamente para uma chamada do Zoom. Clique em \"participar agora\" para ser redirecionado(a) diretamente para uma chamada do Zoom."
    },
    "alsoCloseAssociatedSubAccount": "Também feche os associados",
    "analyzeMemory": "Analisar Memória",
    "announcements": "Anúncios",
    "apply": "Aplicar",
    "appointment": {
      "pickDay": "Selecione um dia",
      "pickSlot": "Selecione um horário para agendamento",
      "selectDate": "Selecionar data",
      "selectSlot": "Selecionar intervalo",
      "slot": "Intervalo",
      "day": "Dia"
    },
    "areYouReallySureDeleteSubAccount": "Você tem certeza de que realmente deseja excluir essa subconta?",
    "areYouSureDeleteSubAccount": "Tem certeza de que deseja excluir esta subconta?",
    "assignedContactOwner": "Atribuído ({contact} proprietário)",
    "assignedToMe": "Atribuído a mim",
    "audio": {
      "browserNotSupported": "Seu navegador não é compatível com o elemento de áudio.",
      "loadingTranscription": "Carregando a transcrição...",
      "viewTranscript": "Visualizar transcrição",
      "stop": "Parar",
      "playPause": "Reproduzir/pausar",
      "timePlayed": "Tempo de jogo: tempo total",
      "mute": "Mudo",
      "playbackSpeed": "Velocidade de reprodução",
      "download": "Baixar",
      "remove": "Remover"
    },
    "automated": "Automatizado(a)",
    "avatar": {
      "aiGenerated": "Esta mensagem foi gerada pela Conversation AI",
      "messengerAutomation": "Automação do Messenger",
      "workflowGenerated": "Esta mensagem foi gerada pela ação de fluxo de trabalho da Conversation AI",
      "messageByAI": "Esta mensagem foi gerada pela Conversation AI",
      "messageByWorkflow": "Esta mensagem foi gerada pela ação de fluxo de trabalho da Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Faça parte da comunidade que mais cresce.",
    "callHighlevelAt": "Ligue para a HighLevel no número +1(888)732-4197",
    "callQueueTooltip": "Esta ligação está na fila de ligações do usuário aguardando para ser executada.",
    "callTranscript": "Transcrição da ligação",
    "clearFilters": "Limpar filtros",
    "clientsCompanyBillingPage": "página de faturamento da empresa do cliente",
    "closeChat": "Fechar chat",
    "closeConversation": "Fechar conversa por chat",
    "component": {
      "dismissMessage": "IGNORAR ESTA MENSAGEM",
      "unblock": "Desbloquear",
      "inboundDndActive": "O DND de entrada foi ativado para este contato",
      "fetchOlderMessages": "Buscar mensagens mais antigas",
      "conversationBegan": "Chat iniciado",
      "celebrationTitle": "Uau! As conversas estão fluidas agora",
      "celebrationBody": "As coisas estão apenas começando, vamos explorar como a HighLevel pode ajudar a construir sua empresa.\nEnquanto isso, você pode continuar enviando mensagens à vontade"
    },
    "componentUpdateTrackingDisabled": "O rastreamento de atualização de componentes está atualmente desativado",
    "componentUpdatesDebuggerAlpha": "🚧 Depurador de Atualizações de Componentes (Alpha) — Trabalho em Progresso",
    "confirmDelete": "Excluir conversa(s)?",
    "confirmDeleteTextLine11": "Tem certeza de que deseja realizar excluir este chat? Essa ação é irreversível.",
    "confirmDeleteTextLine12": "conversas selecionadas",
    "confirmDeleteTextLine21": "Essa ação é irreversível. Você ainda deseja continuar?",
    "confirmDisconnectedAllIntegrations": "Confirmo que desconectei todas as integrações, como Twilio, Mailgun, GMB, domínios, Facebook, Zoom etc.",
    "confirmStoppedAllAutomations": "Confirmo que pausei todas as automações nessa subconta",
    "connectReconnectGoogleForGbp": "Conecte/reconecte sua conta do Google para obter Mensagens GBP!",
    "connectWithCertifiedAdmin": "Conecte-se com um Administrador certificado",
    "connectWithTeamForHelp": "Conecte-se com nossa equipe para receber ajuda em uma chamada de vídeo ao vivo!",
    "connectWithUs": "Conecte-se conosco",
    "connectZoomAccount": "Conectar conta do Zoom",
    "contactEngagementScore": "Pontuação de engajamento {contact}",
    "dailyBrainstormingSessions": "Sessões diárias de brainstorming com a HighLevel",
    "deleteAccount": "Excluir conta",
    "deleteSubAccountOnScheduledTime": "Excluir subconta no horário programado",
    "disableSaasMode": "Desabilitar o modo SaaS",
    "dnd": {
      "configure": "CONFIGURAR",
      "status": {
        "on": "ATIVADO",
        "partial": "Parcial"
      }
    },
    "editAppointment": {
      "updateButton": "Atualizar compromisso",
      "scheduleAppointment": "Agendar compromisso",
      "editAppointment": "Editar compromisso",
      "calendar": "Calendário",
      "selectCalendar": "Selecionar calendário",
      "roundRobin": "Rodízio",
      "pickTeamMember": "Selecionar membro do grupo",
      "selectTeamMember": "Selecionar membro do grupo",
      "teamMemberRequired": "O membro do grupo é obrigatório.",
      "slotRequired": "Intervalo obrigatório",
      "appointmentTitle": "Título do compromisso",
      "appointmentTitleTooltip": "Considere deixar em branco, caso você opte por usar o título do compromisso pré-configurado",
      "contactName": "Nome do contato",
      "name": "Nome",
      "nameRequired": "O nome é obrigatório",
      "emailAddress": "Endereço de e-mail",
      "phoneNumber": "Número de telefone",
      "phoneNumbers": "Números de telefone",
      "dateOfBirth": "Dia de nascimento",
      "contactTimezone": "Fuso horário do contato (usado para lembrete)",
      "chooseOne": "Selecionar um...",
      "meetingLocation": "Localização da conferência",
      "meetingLocationTooltip": "Considere deixar em branco, caso você opte por usar a localização da conferência pré-configurada",
      "status": "Status",
      "appointmentStatus": "Status do agendamento",
      "additionalNotes": "Notas adicionais",
      "notes": "Observações",
      "actionRequired": "Ação obrigatória",
      "confirmed": "Confirmado(a)",
      "invalid": "Inválido(a)",
      "cancelled": "Cancelado(a)",
      "showed": "Comparecido",
      "noShow": "Não comparecido",
      "busy": "Ocupado",
      "free": "Livre",
      "noCalendarMessage": "Você precisa adicionar um calendário para começar a agendar compromissos."
    },
    "email": {
      "errors": {
        "bodyRequired": "O e-mail requer um corpo de texto para ser enviado.",
        "cannotIdentifyContact": "Não é possível identificar o contato e sua localização.",
        "contactNotSelected": "O contato não está selecionado.",
        "noEmailAddress": "O contato não tem um endereço de e-mail."
      },
      "thread": {
        "failedToFetch": "Não foi possível obter o conteúdo do e-mail",
        "forward": "Reenviar"
      },
      "reply": "Responder",
      "share": "Compartilhar",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Adicionar conta",
      "respond": "Responder",
      "retry": "Tentar de novo",
      "moreEmailsInThread": "{count} mais emails na conversa",
      "fromName": "Do nome",
      "fromEmail": "Do e-mail",
      "subject": "Assunto",
      "attachFile": "Anexar arquivo",
      "useTemplate": "Usar um modelo (curto)",
      "requestPayment": "Solicitar pagamento",
      "clear": "Limpar",
      "sendNow": "Envie agora",
      "schedule": "Programar",
      "send": "Enviar",
      "smtpWarning": "Os provedores SMTP têm algumas limitações. Clique aqui para saber mais.",
      "chooseOne": "Selecionar um...",
      "deliveredCount": "{delivered}/{total} enviado(s)",
      "typeMessage": "Digite uma mensagem",
      "sendLater": "Enviar mais tarde",
      "scheduledFor": "Programado para {date}"
    },
    "emailRebillingCardInfoRequired": "Para ativar o refaturamento por e-mail, você precisa inserir as informações do cartão do seu cliente em",
    "emailRebillingDescription": "Isso permite que você refature os custos de e-mail aos seus clientes e inclua uma margem de lucro.",
    "emailRebillingMarginsDescription": "Essas são margens cobradas de seus clientes além do custo do e-mail arcado por você.",
    "enableTracking": "Habilitar Rastreamento",
    "exploreHighlevelExperts": "Descubra os especialistas da HighLevel que podem ajudar a configurar seu sistema, automatizar fluxos de trabalho ou personalizar seu projeto.",
    "exportAll": "Exportar tudo",
    "facebook": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente de novo ou verifique a integração com o Facebook. Mensagem de erro:",
        "noFacebookId": "O contato não possui um ID do Facebook."
      }
    },
    "failedPaymentsCheckBilling": "O senhor tem um ou mais pagamentos que não foram realizados. Por favor, verifique o seu histórico de faturamento.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Acima",
      "aiActionLogs": "Registros de ações de AI",
      "inRange": "Dentro do alcance",
      "invoice": "Fatura",
      "messageDirectionTooltip": "O filtro será aplicável às mensagens após 9 de maio de 2023",
      "appointments": "Compromissos"
    },
    "followed": "Seguido por",
    "followedByMe": "Seguido(s) por mim",
    "followedBySpecificUser": "Seguido(s) por um usuário específico",
    "follower": "Seguidor",
    "followerAssignmentContact": "Seguidor(es) ({contact} atribuído)",
    "gbp": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração do seu perfil do Google Business Profile. Mensagem de erro:",
        "noGBPId": "O contato não possui um ID GBP."
      }
    },
    "gbpChatNoLongerAvailable": "O Google Business Profile Chat não está mais disponível",
    "getAccessToHighlevelWelcomeCourse": "Tenha acesso ao Curso de boas-vindas da HighLevel",
    "getPriorityTroubleshooting": "Obtenha assistência prioritária, orientação de profissionais e acesso direto à nossa equipe técnica via Slack.",
    "gmbMessagingAvailable": "O Google Business Messaging está disponível para a sua conta.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Classificação:",
      "replyDate": "Data da resposta:",
      "replyFrom": "Resposta de:",
      "review": "Avaliação",
      "reviewDate": "Data da avaliação:",
      "reviewFrom": "Avaliação de:"
    },
    "highlevelEvents": "Eventos HighLevel",
    "igMessengerDM": "DM do IG Messenger",
    "includeSignatureBeforeQuotedText": "Incluir esta assinatura antes do texto citado nas respostas",
    "instagram": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Instagram. Mensagem de erro:",
        "noInstagramId": "O contato não possui um ID do Instagram."
      }
    },
    "joinOurFacebookGroup": "Participe do nosso grupo do Facebook",
    "keepUpToDateWithLatestNews": "Fique por dentro de todas as novidades e lançamentos!",
    "lastMessageChannel": "Canal da última mensagem",
    "lastMessageDirection": "Direção da última mensagem",
    "lastOutboundMessageType": "Tipo da última mensagem enviada",
    "learnHow": "Saber como?",
    "leftComment": "deixou um comentário",
    "leftPanel": {
      "recents": "Recentes",
      "unread": "Não lidos",
      "createNewMessage": "Criar mensagem",
      "minCharsRequired": "Mínimo de 3 caracteres obrigatórios",
      "twoMoreCharsRequired": "É necessário mais 2 caracteres",
      "oneMoreCharRequired": "É necessário mais 1 caractere"
    },
    "liveChat": {
      "endLiveChat": "Encerrar chat ao vivo",
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Google My Business. Mensagem de erro:"
      },
      "requestContact": "Solicitar Contato"
    },
    "live_chat_message": "Mensagem de Chat ao Vivo",
    "made": "feito",
    "memoryAnalysisApproximate": "🚧 A análise de memória é aproximada e não é 100% precisa.",
    "mentioned": "Mencionado para",
    "mentions": "Menções",
    "mentionsOfMe": "Menções a mim",
    "mentionsOfSpecificUser": "Menções de usuários específicos",
    "message": {
      "replyAll": "Responder a todos",
      "details": "Informações",
      "reply": "Responder",
      "unsuccessful": "Falhou",
      "pending": "Pendente",
      "inboundCall": "Ligação recebida",
      "outboundCall": "Ligação efetuada",
      "ivrCall": "Ligação de IVR",
      "leftVoicemail": "Deixou uma mensagem de voz",
      "storyReply": "Resposta do story",
      "storyMention": "Menção do story",
      "replyAsDM": "Responda como DM",
      "newCommentOnPost": "Novo comentário na publicação de {pageName}.",
      "goToPost": "Ir para a publicação",
      "replyNotAvailable": "Não é possível responder por DM privada para comentários com mais de 7 dias.",
      "addToDocuments": "Adicionar aos arquivos",
      "attachmentsAddedSuccess": "Anexos adicionados aos arquivos com sucesso",
      "attachmentsAddedFailed": "Falha ao adicionar anexos aos arquivos",
      "reportFeedbackForAI": "Relatar feedback para AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Tem certeza de que deseja cancelar esta programação?",
      "cancelScheduledMessage": "Cancelar mensagem programada?",
      "cancelSend": "Cancelar envio",
      "cancelScheduledSuccess": "Mensagem programada cancelada com sucesso",
      "cancelScheduledError": "Ocorreu um erro ao cancelar a mensagem agendada",
      "cc": "CC",
      "channel": "Canal",
      "createdBy": "Criado por",
      "direction": "Direção",
      "emailCampaign": "Campanha de e-mail",
      "facebookMessage": "Mensagem do Facebook",
      "instagramMessage": "Mensagem do Instagram",
      "messageId": "ID da mensagem",
      "messageIdLabel": "ID da Mensagem: ",
      "trigger": "Gatilho",
      "unanswered": "Sem resposta",
      "yes": "Sim",
      "messageDetails": "Detalhes da mensagem",
      "from": "De",
      "fromLabel": "De:",
      "to": "Para",
      "toLabel": "Para:",
      "unknown": "Desconhecido",
      "unknownFrom": "Remetente desconhecido",
      "unknownTo": "Desconhecido para",
      "unknownDirection": "Direção desconhecida",
      "dateUnknown": "Data desconhecida",
      "emailFromUnknown": "E-mail de desconhecido",
      "smsFromUnknown": "SMS de desconhecido",
      "callFromUnknown": "Chamada de desconhecido",
      "voicemailFromUnknown": "Correio de voz de desconhecido",
      "emailToUnknown": "E-mail para desconhecido",
      "smsToUnknown": "SMS para desconhecido",
      "callToUnknown": "Ligar para desconhecido",
      "voicemailToUnknown": "Correio de voz para desconhecido",
      "failed": "Falhou",
      "datetime": "Data e hora",
      "manual": "Manual",
      "automation": "Automação",
      "workflow": "Fluxo de trabalho",
      "campaign": "Campanha",
      "bulkRequest": "Solicitação em massa",
      "delivered": "Entregue",
      "bounced": "Rejeitado(a)",
      "opened": "Aberto(a)",
      "sent": "Enviado(a)",
      "scheduled": "Programado(a)",
      "pageName": "Nome da página",
      "gbpMessage": "Mensagem GBP",
      "no": "Não",
      "eventsTrackedForContactOnly": "Atualmente, as ocorrências são registradas apenas para o endereço de e-mail do contato.",
      "completed": "Concluído(a)",
      "voicemail": "Correio de voz",
      "busy": "Ocupado",
      "pending": "Pendente",
      "read": "Ler",
      "nativeIntegrations": "Integrações nativas",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-mail",
      "sms": "SMS",
      "phoneCall": "Ligação telefônica",
      "voiceMail": "Correio de voz",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Avaliações",
      "others": "Outros",
      "partialDetailsWarning": "Informações parciais estarão disponíveis para mensagens enviadas antes de 15 de julho de 2022.",
      "agencySystem": "Sistema da agência",
      "reply": "Responder"
    },
    "multiplePhone": {
      "chooseNumber": "Escolha um número para iniciar a conversa por chat:",
      "continue": "Continuar",
      "noPhones": "Nenhum número de telefone disponível"
    },
    "myChat": "Meu chat",
    "myInbox": "Minha caixa de entrada",
    "newConversationStarted": "Nova conversa iniciada",
    "newMessage": {
      "title": "Nova mensagem:",
      "errors": {
        "phoneRequired": "O telefone é obrigatório"
      }
    },
    "noConversationSelected": "Nenhum chat selecionado",
    "noResultsToShow": "Nenhum resultado para exibir",
    "onboardingVideoTutorials": "Tutoriais em vídeo sobre integração",
    "onlyAgencyAdminsCanSeeWarning": "Somente os administradores da agência podem ver este aviso. Para mais informações",
    "onlyVisibleToUsers": "Visível apenas para usuários",
    "perMonthPerIp": "/Mês/IP",
    "phone": {
      "call": "Ligar para {name}",
      "callingOptions": "{count} opções de ligação",
      "phoneNumbers": "Números de telefone",
      "callOptions": "{count} opções de ligação",
      "dndActive": "O DND está habilitado para ligações",
      "primary": "Principal"
    },
    "pleaseDisableSaasMode": "Por favor, desabilite o modo SaaS para esta subconta",
    "pleaseSelectCampaign": "Selecione uma campanha",
    "premiumSupport": "Suporte Premium",
    "quickFilters": "Filtros rápidos",
    "reconnectGbpPageToEnable": "Reconecte sua página GBP para ativar.",
    "replyAsDMTooltip": "Responda a este comentário por DM privada.",
    "replyingTo": "Respondendo a",
    "resetMountCounts": "Redefinir contagens de montagem",
    "review": {
      "errors": {
        "generalError": "Ocorreu um erro. Mensagem de erro:",
        "googleIntegrationError": "Não foi possível responder a essa avaliação. Parece haver um erro na sua integração com o Google. Reconecte em Configurações -> Integrações.",
        "noReviewId": "A conversa por chat não possui um Id de avaliação."
      },
      "reviewPostTo": "Revisar publicação para {network}",
      "sharedOn": "Avaliação compartilhada em {network}",
      "disputeReview": "Contestar esta avaliação",
      "learnHow": "(Saiba como?)",
      "seeOnGBP": "Confira esta avaliação no GBP",
      "alreadyShared": "Esta avaliação já foi publicada em {network}. Tem certeza de que deseja republicá-la?"
    },
    "reviewId": "ID da avaliação",
    "schedule": {
      "sendSchedule": "Enviar programação",
      "timezone": "Fuso horário ({heading})",
      "title": "Agende o seu {type}"
    },
    "scheduling": "Agendando...",
    "seeHow": "Veja como",
    "selectFilter": "Selecionar filtro",
    "selected": "selecionado(a)",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Assunto:",
      "subjectPlaceholder": "Assunto do e-mail",
      "to": "Para:",
      "sending": "Enviando...",
      "sendButton": "Enviar e-mail"
    },
    "setupAccountWithFreeTutorials": "Configure sua conta com tutoriais gratuitos",
    "showOnlySlowQueries": "Mostrar apenas consultas lentas (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirme o envio de mensagem",
      "editModal": {
        "compose": "Escrever SMS"
      },
      "errors": {
        "customVariablesIssue": "Existem problemas nas suas variáveis personalizadas, corrija-os antes de enviar.",
        "messageOrTemplateRequired": "Confira se inseriu uma mensagem ou um modelo selecionado.",
        "noPhoneNumber": "O contato não possui número de telefone."
      },
      "scheduledSuccessfully": "SMS programado com sucesso",
      "sendAnyway": "Enviar mesmo assim",
      "spamWarning": "Seu conteúdo de SMS pode incluir referências a Cannabis, SHAFT, Vape ou outros temas proibidos. O envio de tal conteúdo via SMS é estritamente proibido e pode resultar em restrições de conta. Por favor, revise seu conteúdo cuidadosamente antes de prosseguir.",
      "send": "Enviar"
    },
    "startNewConversation": "Iniciar novo chat",
    "subAccountAndDeleteAllPhoneNumbers": "subconta e excluir todos os números de telefone",
    "subAccountScheduledForDeletion": "Essa subconta está programada para exclusão",
    "subAccountScheduledForDeletionItWillBeDeleted": "Esta subconta foi programada para exclusão. Será excluído(a) por",
    "teamInbox": "Caixa de entrada do grupo",
    "threshold": "Limite",
    "understandActionIrreversible": "Entendo que essa ação é irreversível e que todos os dados dentro da subconta serão perdidos",
    "unstarred": "Não marcado como importante",
    "use_a_template": "Utilize um modelo",
    "userAvailability": "Disponibilidade do usuário",
    "userCalendarConfiguration": "Configuração do Calendário do Usuário",
    "userInfo": "Informações do Usuário",
    "userRoles": "Funções de Usuário",
    "viewSupportTickets": "Veja seus tíquetes de suporte, nossos artigos de suporte e perguntas frequentes úteis!",
    "visitOurHelpCenter": "Visite nossa Central de ajuda",
    "welcomeCourse": "Curso de boas-vindas",
    "whatsapp_logo": "WhatsApp Logo",
    "youCanChangeYourMindBeforeThisTime": "Você pode mudar de ideia até essa data.",
    "zoomAccount": "Zoom Account",
    "deleteEmails": "Excluir {count} e-mail(s)",
    "fileAttachment": {
      "urlNotFound": "O URL não pode ser encontrado",
      "unsupportedAttachment": "Esses anexos podem não ser mais compatíveis.",
      "downloadFile": "Baixar arquivo"
    },
    "composer": {
      "internalComment": "Comentário interno"
    },
    "dropdown": {
      "openOptions": "Abrir opções",
      "messageDetails": "Detalhes da mensagem"
    },
    "respond": "Responder",
    "selectTemplate": "Selecionar modelo",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Você desabilitou o pop-up. Habilite o pop-up para este site redirecionar automaticamente para uma chamada de Zoom. Clique em \"participar agora\" para ser redirecionado(a) diretamente para uma chamada de Zoom.",
        "helpAndSupport": "Ajuda e suporte",
        "summerOfAI": "Verão com AI"
      }
    },
    "celebration": {
      "dismiss": "Ignorar",
      "body": "As coisas estão apenas começando, vamos explorar como a HighLevel pode ajudar a construir sua empresa.\nEnquanto isso, você pode continuar enviando mensagens à vontade",
      "title": "Eba! As conversas estão fluindo agora"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "artigo de ajuda aqui",
      "message": "Habilite os cookies de terceiros para visualizar esta página corretamente. Você pode consultar nosso",
      "ok": "OK",
      "title": "Cookies de terceiros não estão funcionando"
    }
  },
  "crash": {
    "message": "Pedimos desculpas, mas ocorreu um imprevisto. Tente atualizar a página.",
    "refresh": "Atualizar página",
    "title": "Ops! Algo deu errado"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Cancelando a exclusão de {name}",
      "confirmAbort": "Sim, cancelar",
      "keepDeleting": "Não, manter exclusão",
      "message": "Tem certeza de que deseja cancelar?",
      "scheduledForDeletion": "Esta localização está programada para exclusão em {date}",
      "title": "Cancelar Exclusão",
      "warning": "Mensagem: a localização será apagada no dia programado, a menos que você cancele a exclusão."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Solte os arquivos aqui para carregar",
      "uploadError": "Erro do sistema: não foi possível enviar a solicitação para a AWS (possivelmente um erro de CORS)."
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Adicionar {entityName}",
      "clonedMessage": "{entityName} Clonado! Altere para uma conta onde foi clonado e descubra-o na guia {entityName}.",
      "errorGettingDetails": "Parece haver uma falha ao obter os detalhes de {entityName}. Verifique o URL ou tente novamente.",
      "permissionError": "Autorização falhou: este é um funil protegido e não pode ser criado aqui."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "Logotipo GoogleCalendar"
    },
    "printful": {
      "logo": "Logotipo Printful ",
      "title": "Printful: Impressão sob Demanda"
    },
    "printify": {
      "logo": "Logotipo Printify",
      "title": "Printify: Impressão sob demanda"
    },
    "shipStation": {
      "logo": "Logotipo do ShipStation",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Logotipo da Shippo",
      "title": "Shippo: integração de remessa"
    },
    "tikTok": {
      "accountNotConnected": "Conta não conectada",
      "accountNotConnectedMessage": "Sua conta não está conectada à conta de anúncios do TikTok. Conclua a integração para visualizar formulários e mapear campos.",
      "advertiserId": "ID do Anunciante",
      "companyFields": "Campos {companyName}",
      "editFields": "Editar campos",
      "errorSubscribing": "Falhou ao se inscrever na página.",
      "formsNotAvailable": "Formulários não disponíveis",
      "mandatoryFieldsNote": "Mensagem: mapeie qualquer um dos seguintes campos obrigatórios para receber oportunidades em sua conta com sucesso. Campos: nome, sobrenome, e-mail, número de telefone",
      "noFormsMessage": "Agora, você não possui nenhum formulário de prospecção criado em sua conta de anúncios do TikTok. Visite sua conta de anúncios do TikTok e gere uma para começar.",
      "pageId": "ID da Página",
      "selectAdvertiserAccount": "Selecionar conta de anunciante"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Outro / Não sei",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Você precisa realizar algumas etapas simples para pausar essa subconta"
    },
    "transfer": {
      "chooseDescription": "Selecione seu método de transferência",
      "chooseMethod": "Transferir esta subconta",
      "eject": {
        "description": "Ganhe 40% de comissão recorrente na assinatura da nova conta.",
        "title": "Remover como uma conta nova"
      },
      "modal": {
        "confirmDetails": "Confirme os detalhes antes de transferir",
        "confirmNomineePrefix": "Nomear proprietário para",
        "confirmTransfer": "Confirmar transferência",
        "consentText": "Li e compreendi o manual acima e consinto com todas as limitações",
        "ejectErrorTitle": "Não é possível ejetar a subconta.",
        "ejectGenericError": "A subconta que você está tentando remover não pode ser removida. Entre em contato com o suporte.",
        "ejectGuidelines": "Instruções de remoção de subcontas",
        "ejectSubject": "A remoção da subconta está sujeita à aceitação, por parte do usuário, da solicitação de criação de uma nova agência.",
        "ejectSuccessTitle": "Solicitação para ejetar a subconta enviada ao usuário selecionado",
        "enterPassword": "Insira sua senha para confirmar.",
        "genericError": "A subconta que você está tentando transferir não pode ser transferida. Entre em contato com o suporte.",
        "guidelines": "Instruções de transferência de subcontas",
        "guidelinesConsent": "Por favor, leia e concorde com",
        "hipaaDisclaimer": "Renúncia",
        "hipaaText": "Talvez seja interessante informar essa subconta que ela atualmente possui cobertura HIPAA, mas que pode não ter a mesma cobertura na agência para a qual está sendo transferida.",
        "noUsersDescription": "Não há usuários associados a essa subconta. Adicione um usuário à subconta e clique em \"Continuar\".",
        "noUsersSearch": "Nenhum usuário encontrado.",
        "noUsersTitle": "Nenhum usuário encontrado",
        "nomineeInstructions": "O indicado receberá um link para se cadastrar na HighLevel",
        "passwordError": "Senha inválida",
        "passwordErrorDescription": "A senha que você digitou está incorreta. Tente de novo.",
        "relationshipError": "Por favor, insira o número de relacionamento correto",
        "relationshipNumber": "Número de relacionamento da agência destinatária",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Solicitar transferência",
        "seeAllRequests": "Ver todas as solicitações",
        "successMessage": "A subconta será transferida assim que a agência destinatária aceitar a sua solicitação de transferência.",
        "successTitle": "Solicitação para transferir a subconta enviada para a agência destinatária",
        "title": "Carregar subconta",
        "transferSubject": "A transferência da subconta depende de a agência destinatária aceitá-la na conta dela.",
        "confirmNomineeSuffix": " para "
      },
      "transferExisting": {
        "description": "Transfira toda esta subconta para outra conta.",
        "title": "Transferir para uma conta existente"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Próxima Implementação",
      "title": "Solicitações em massa"
    },
    "campaign": {
      "account": "Conta",
      "accountBuffer": "Buffer de Conta",
      "accountBufferDescription": "Não há limite para o número de destinatários adicionados a esta campanha por dia (a partir de uma lista).",
      "accounts": "Contas",
      "activity": "Atividade",
      "acquire": "Captar",
      "acquisitionDescription": "As campanhas de aquisição de clientes ajudam a gerar mais oportunidades de vendas \"quentes\", prontas para se engajar.",
      "addEvent": "Adicionar evento",
      "addUser": "Adicionar usuário",
      "allMarket": "Todos os mercados",
      "allowMultiple": "Permitir múltiplos",
      "assignedToTooltip": "Quando esta campanha começou, este contato foi atribuído a este usuário. Mudanças em \"atribuído a\" do contato refletirão nas ocorrências, mas não alterarão este valor inicial.",
      "atLeastOneEvent": "É necessário ter pelo menos um evento.",
      "automations": "Automações",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero Menos, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Rejeitado(a)",
      "buffering": "Processando",
      "campaignActivity": "Atividade de Campanha",
      "campaignConfiguration": "Configuração de Campanha",
      "campaignConfigurationWarning": "A configuração da campanha afeta todos os mercados. Certifique-se de que você precisa fazer alterações nessas configurações.",
      "campaignCreation": "Criação de campanha",
      "campaignId": "ID da campanha",
      "campaignStatusByRecipients": "Status da campanha por destinatários",
      "clickThroughRate": "Taxa de cliques (CTR)",
      "clickedThrough": "Cliques realizados",
      "conditionIfExplanation": "Execute esta campanha ou evento se o horário atual estiver dentro desta janela; se estiver fora, pule esta campanha ou evento e avance para o próximo.",
      "conditionWhenExplanation": "Execute os eventos desta campanha quando o horário atual estiver dentro desta janela; caso contrário, aguarde a próxima janela para executar os eventos.",
      "createCampaign": " Criar campanha",
      "ctr": "CTR",
      "customerAcquisition": "Aquisição de Clientes",
      "dateAdded": "Data da adição",
      "dateAddedTooltip": "Data e hora exatas em que o contato foi adicionado a esta campanha. O horário de início do primeiro evento pode variar conforme as configurações.",
      "deletedRestorePrompt": "Esta campanha foi excluída. Deseja restaurá-la?",
      "delivered": "Entregue",
      "deliveryRate": "Taxa de entrega",
      "draftMode": "Modo de rascunho",
      "draftModeDescription": "Esta campanha está em rascunho. Ela não pode ser utilizada até ser publicada.",
      "dropped": "Descontinuado",
      "emailActivity": "Atividade de e-mail",
      "emailActivityFilterExample": "Atividade de e-mail: clique registrado",
      "event": "Evento",
      "eventFilterExample": "Evento: 10X E-mail 4 (Distribuição de Anúncios/Imóveis)",
      "filters": "Filtros",
      "emailPerformanceByAccount": "Performance do e-mail por conta",
      "emailsNotSentOnDays": "Os e-mails não serão enviados aos sábados e domingos.",
      "emailsSentOnDays": "Os e-mails serão enviados às segundas, terças, quartas, quintas e sextas-feiras.",
      "eventStartDate": "Data de início do evento",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "Cafeteria Perks da Cidade",
      "exampleDate": "8 de maio de 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Certifique-se de que os dados não tenham mais de 30 dias",
      "exampleEventName": "10X E-mail 4 (Distribuição de Anúncios)",
      "getMoreCustomers": "Conquiste mais clientes",
      "inProgress": "Em andamento",
      "includedDays": "Dias Incluídos",
      "internalSource": "Fonte Interno",
      "lastUpdate": "Última atualização",
      "leadValuePlaceholder": "Valor em dólares do lead",
      "loopDetected": "Esta campanha foi bloqueada no status de rascunho porque está gerando um loop. Para ativar esta campanha, entre em contato com o Suporte.",
      "market": "Mercado",
      "moreDetails": "Mais detalhes",
      "myCampaigns": "Minhas Campanhas",
      "na": "N/A",
      "newFolder": " Nova pasta",
      "nextCampaign": "Próxima campanha",
      "nextExecutionTime": "Próximo horário de Implementação",
      "opened": "Aberto(a)",
      "openRate": "Taxa de abertura",
      "option2": "Opção 2",
      "option3": "Opção 3",
      "pageNavigation": "Modelo de navegação de página",
      "processed": "Processado",
      "published": "Publicado(a)",
      "recipient": "Destinatário",
      "recipients": "Destinatários",
      "sampleCampaign": "Campanha de amostra ",
      "scheduling": "Programação",
      "seeHotLeads": "Ver Oportunidades Quentes",
      "selectDateRange": "Selecionar o intervalo de datas",
      "selectTimeZone": "Selecionar fuso horário",
      "separator": " / ",
      "showingCount": "Exibindo {current} de {total}",
      "spamReport": "Relatório de Spam",
      "startByAddingEvent": "Comece adicionando um evento a esta campanha.",
      "stopOnResponse": "Parar ao receber resposta",
      "stopped": "Pausado",
      "time": "Horário",
      "timeConditionNote": "Observação: Se o primeiro passo da campanha estiver configurado como “Imediatamente”, então a condição de horário não será aplicada a esse primeiro passo.",
      "timeZoneDescription": "Esta configuração determina o horário em que seu conteúdo será enviado.",
      "totalLeads": "Total de leads",
      "undeliverable": "Não entregável",
      "unsubscribe": "Cancelar assinatura",
      "upNext": "Próximo passo",
      "utc": "UTC",
      "window": "Janela"
    },
    "embed": {
      "copyLinkInstructions": "Copie o link abaixo e compartilhe-o facilmente em qualquer lugar.",
      "embed": "Incorporar",
      "iframeEmbed": "Incorporação de iframe",
      "integrateInstructions": "Use as opções abaixo para integrar seu formulário personalizado ao seu site.",
      "integrateYourForm": "Integre o seu formulário",
      "link": "Link",
      "saveAndExit": "Salvar e sair"
    },
    "jotbox": {
      "deleteSubmission": "Exclusão de envio",
      "downloadPdf": "Baixar PDF",
      "ofSubmissions": " de {total} envios",
      "pages": "páginas",
      "records": "registros",
      "searchPlaceholder": "Pesquise por nome, e-mail, telefone e ID do contato",
      "selectYourForm": "Selecione seu formulário",
      "timeSigned": "Hora da assinatura:",
      "totals": "Totais:"
    },
    "survey": {
      "createNewSurvey": "Criar nova pesquisa",
      "integrateYourSurvey": "Integrar sua pesquisa",
      "noSurveysForAnalyze": "Você ainda não tem nenhuma pesquisa. Crie uma pesquisa primeiro para visualizar a análise aqui.",
      "noSurveysForSubmission": "Você ainda não tem nenhuma pesquisa. Crie uma pesquisa primeiro para visualizar os envios aqui.",
      "noSurveysYet": "Você ainda não tem nenhuma pesquisa.",
      "refreshData": "Atualizar dados",
      "searchSurveys": "Pesquisar Pesquisas",
      "surveyBuilder": "Construtor de pesquisas",
      "toCreateFirstSurvey": "para criar sua primeira pesquisa."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produto clonado! Altere para uma conta onde foi clonado e descubra-o em Assinatura > aba Produtos.",
      "errorGettingDetails": "Parece haver um erro ao obter os detalhes do produto.  Verifique o URL ou tente novamente."
    },
    "resetPassword": {
      "title": "Redefinir senha",
      "button": "Redefinir senha",
      "newPassword": "Nova senha",
      "generateStrongPassword": "Gere uma senha forte",
      "sendEmailNotification": "Além disso, envie notificação por e-mail.",
      "errorMessage": "Ocorreu um erro ao redefinir a senha. Tente de novo.",
      "updating": "Atualizando..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ por",
      "combo": {
        "signedUp": "inscreveu-se no ProveSource nas últimas 24 horas",
        "verifiedBy": "verificado por "
      },
      "conversions": {
        "recentlyBought": "comprou isto recentemente",
        "timeAgo": "nos últimos 16 minutos ",
        "visitorsCount": "50 visitantes"
      },
      "pageVisits": {
        "description": "também parecem estar com fome.",
        "timeAgo": "nos últimos 21 minutos                        ",
        "title": "50 apreciadores de gastronomia"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " Mensagem de Prova",
        "rating": "Classificação de 5 estrelas",
        "recently": "Recentemente",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "Inscrito no ProveSource",
        "location": "(London, Reino Unido)",
        "name": "Mike ",
        "timeAgo": "40 minutos atrás                        "
      },
      "visitors": {
        "description": "amantes de música on-line"
      }
    },
    "step1": {
      "combo": {
        "description": "Exibir o número total de pessoas que realizaram uma ação específica ao longo de 24 horas, 7 ou 30 dias.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Crie validação social exibindo quantos clientes realizaram uma ação específica."
      },
      "liveReviews": {
        "description": "Exiba aos seus visitantes avaliações em tempo real com 4 ou mais estrelas dos últimos 6 meses."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Mostre quantos visitantes estão visualizando todo o seu site em tempo real."
      },
      "pageVisits": {
        "description": "Mostre aos seus visitantes que eles não são os únicos na festa, destacando as visitas recentes à página."
      },
      "stream": {
        "description": "O que é melhor do que dar um rosto à prova social? Mostre seus clientes recentes e suas ações."
      }
    },
    "step2": {
      "captureDescription2": "Todos os URL de página devem ter um setor de formulário de e-mail",
      "captureDescription3": " e ProveSource instalado. ",
      "comboType": "Tipo de Combo",
      "connectAccounts": "Certifique-se de conectar as contas das quais deseja tirar avaliações",
      "connectGoogleAccount": "Conectar a conta do Google do seu local",
      "formSubmissions": "Envios de formulários",
      "googleAccount": "Conta Google",
      "howToTrack": "Como Rastrear",
      "howToTrackDescription": "Como devemos rastrear suas conversões?",
      "pageUrl": "URL da página",
      "productPurchase": "Comprar produto",
      "trackAllUrls": "Rastreie todas as URLs de páginas que contenham a seguinte expressão. ",
      "trackVisitors": "Controlar visitantes",
      "trackVisits": "Rastrear visitas",
      "urlTip": " Tratamos http://, https://, www e non-www como variantes dividir da URL e da página. ",
      "urlValidationError": "Você deve incluir pelo menos uma URL. O URL é inválido. Certifique-se de Incluir http:// Ou https://",
      "userSignup": "Inscrição de usuário",
      "visits": " Visitas",
      "webhookDescription": "Ligar o seguinte endpoint para nos informar sobre um evento ou conversão que ocorreu do seu lado e que está relacionado a esta notificação push; nós cuidaremos do resto.",
      "webhookRequest": "Solicitação de Webhook",
      "whatToTrack": "O que você gostaria de rastrear?",
      "whereToCapture": "Onde Capturar",
      "whereToCaptureDescription": "Onde você está capturando taxas de conversão?",
      "whichPagesToTrack": "Quais páginas você gostaria que rastreássemos?",
      "yourWebhookUrl": "Sua URL do Webhook"
    },
    "step3": {
      "allPages": " Todas as páginas",
      "displayOnAllPages": "Exibir em todas as URLs de página que contêm a seguinte expressão: ",
      "whereToDisplay": "Onde exibir",
      "whereToDisplayActivity": "Onde você gostaria que exibíssemos esta atividade?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "para ver ícones bonitos (clique com o botão direito do mouse em um ícone -> Copiar endereço da imagem)",
      "messageSettings": "Configurações de mensagem",
      "messageText": "Texto da mensagem",
      "referToVisitorsAs": "Refira-se aos visitantes como",
      "visitIcons8": "Visite"
    },
    "step5": {
      "allowUsersToClose": " Habilitar usuários a fechar a notificação ",
      "behavior": "Comportamento",
      "bottomLeft": "Canto inferior esquerdo",
      "bottomRight": "Canto inferior direito",
      "clickableNotification": " Notificação clicável ",
      "customizeDescription": "Altere as seguintes configurações para controlar o comportamento e a aparência da sua notificação",
      "design": "Design",
      "displayNotificationFor": "Exibir notificação push para",
      "displayRules": "Regras de Exibição",
      "hideOnMobileScreens": " Ocultar em telas de dispositivos móveis ",
      "linkRelativeNote": " Se http:// for Ignorado, a relação abrirá relativamente à página exibida ",
      "minimumEventsToDisplay": "Mínimo de ocorrências para exibindo",
      "notificationLink": "Link da notificação",
      "notificationPosition": "Posição da notificação",
      "openLinkInNewTab": "Abrir link em uma nova guia",
      "selectPosition": "Selecione a posição",
      "showOnlyOncePerSession": " Exiba apenas uma vez por sessão ",
      "titleBackground": "Plano de fundo do título",
      "titleColor": "Cor do Título",
      "topLeft": "Canto superior esquerdo",
      "topRight": "Canto superior direito",
      "typeUrlHere": "Digite a URL aqui"
    },
    "step6": {
      "identifyNotification": "Identifique sua notificação",
      "launchMessage": "Estamos prestes a partir, tomem seus assentos e apertem os cintos de segurança.",
      "notificationName": "Nome da Notificação",
      "notificationNamePrompt": "Qual é o nome da sua notificação?",
      "wellDone": "Muito bem."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Assinatura criada com sucesso",
      "youCanNowSetupWordPress": "Agora você pode configurar seu site WordPress.",
      "subscriptionFailed": "Falha na assinatura",
      "resubscriptionSuccessful": "Reativação de assinatura bem-sucedida",
      "successfullyReactivated": "Sua assinatura do WordPress foi reativada com sucesso",
      "reactiveSub": "Não foi possível reativar a assinatura",
      "resubscriptionFailed": "Falha na reassinatura"
    },
    "v2": {
      "viewDetails": "Visualizar detalhes",
      "chatConversationAssigned": "Conversa por chat atribuída",
      "internalChat": "Chat interno",
      "newTask": "Nova tarefa",
      "appointmentReminder": "Lembrete de compromisso",
      "facebookReview": "Avaliação do Facebook",
      "googleReview": "Avaliação do Google",
      "internalChatMessage": "Mensagem de chat interno",
      "newAppointmentAssigned": "Novo compromisso atribuído",
      "newAppointmentBooked": "Novo compromisso agendado",
      "newCall": "Nova ligação",
      "newEmail": "Novo e-mail",
      "newMention": "Nova menção",
      "newReviewReceived": "Nova avaliação recebida de {contactName}",
      "taskReminder": "Lembrete de tarefa",
      "completed": "concluído",
      "failed": "falhou",
      "subAccount": "Subconta",
      "newMessage": "Nova mensagem",
      "newAppointmentBookedWith": "Novo compromisso agendado com {contactName}",
      "newAppointmentAssignedTo": "Novo compromisso atribuído a {contactName}",
      "appointmentDueIn": "Consulta prevista em {minutes} minutos com {contactName}",
      "newTypeReceived": "Novo {type} recebido de {contactName}.",
      "newChatAssigned": "Novo bate-papo atribuído a partir de {contactName}",
      "taskDueDate": "Tarefa \"{title}\" com prazo em {date} às {time} para {contactName}",
      "tasksDueToday": "{count} tarefas para hoje",
      "tasksOverdue": "{count} tarefas em atraso",
      "taskDueIn": "Tarefa \"{title}\" com vencimento em {dueTime} {unitOfTime} para {contactName}",
      "mentionedInConversation": "{userName} mencionou você em uma conversa com {contactName}",
      "now": "agora"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logotipo da empresa"
      },
      "bestExperience": "a melhor experiência.",
      "optimizedFor": "Esta página está otimizada para",
      "portraitMode": "modo Foto de perfil",
      "toGiveYou": "para oferecer a você"
    }
  },
  "pagination": {
    "goToFirstPage": "Vá para a primeira página",
    "goToLastPage": "Vá para a última página",
    "goToNextPage": "Vá para a próxima página",
    "goToPreviousPage": "Vá para a página anterior",
    "itemsSelected": "{count} itens selecionados",
    "showingEntries": "Exibindo {from} a {to} de {total} entradas"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Por favor, adicione um método de pagamento para",
    "_segment": "/ segmento",
    "ad_manager": "Gerenciador de anúncios",
    "add": "[ADICIONAR:",
    "ai_employee": "Funcionário de AI",
    "billing": {
      "incompleteBillingInfo": "Há informações de faturamento desta conta incompletas. Por favor, atualize imediatamente.",
      "updateNow": "Atualizar agora"
    },
    "charge": "Cobrança",
    "contactLimit": {
      "message": "Você atingiu o limite do seu plano atual para adicionar {contact}. Para continuar, atualize seu plano e desbloqueie capacidade adicional.",
      "upgradeNow": "Fazer upgrade agora",
      "warningMessage": "Você tem {current} contato(s) enquanto seu plano só permite no máximo {limit}.",
      "warningTitle": "O uso da conta está acima do limite. Faça o upgrade para continuar trabalhando sem interrupções."
    },
    "cost_borne_by_you": "custo que cabe a você",
    "dedicated_ip": "IP dedicado",
    "electeditem": "item selecionado",
    "feedback": "Feedback:",
    "hello": "Olá",
    "helpDrawer": {
      "aiSupportAssistant": "Assistente de suporte de AI",
      "clickToCopy": "Clique para copiar o número de relacionamento",
      "clickToCopyToClipboard": "Clique para copiar o número de relacionamento para a área de transferência",
      "companyRelationshipNumber": "Número de relacionamento da empresa",
      "hiImHighly": "Olá, eu sou o Highly!",
      "implementation": "Implementação",
      "joinImplementationVideo": "Participar da videochamada de implementação",
      "joinTrialZoom": "Participar da chamada de teste do Zoom",
      "kickoff": "início",
      "needHelpChatVideo": "Precisa de ajuda? Inicie um chat ou chamada de vídeo conosco agora mesmo!",
      "openAIAssistant": "Abrir assistente de suporte de AI",
      "premium": "Premium",
      "priority": "Prioridade",
      "raiseSupportTicket": "Abra um ticket de suporte",
      "raiseTicket": "Abrir ticket",
      "relationshipNumber": "Número de relacionamento",
      "startAISupportChat": "Iniciar um chat de suporte de AI",
      "startAgentChatWait": "Inicie o chat com agente com tempo de espera entre 2 a 5 minutos",
      "startChatChoose": "Iniciar chat - escolha entre suporte de AI ou chat com um agente",
      "startImplementationVideo": "Iniciar chamada de vídeo de implementação",
      "startZoom": "Iniciar Zoom",
      "startZoomCall": "Iniciar chamada por Zoom",
      "subtitle": "Se quiser conversar com a gente, com a comunidade ou aprender por conta própria, temos tudo o que você precisa!",
      "title": "Ajuda e suporte",
      "trialExperience": "Experiência de teste",
      "useButtonsBelow": "Use qualquer um dos botões abaixo para receber ajuda!",
      "videoCallReward": "Participe de uma videochamada para configurar sua conta — e obtenha {amount} creditado na sua carteira ao participar.",
      "videoCallType": "Participe de uma videochamada comigo para a sua chamada {type}.",
      "yourPremiumSupportSpecialist": "Seu Profissional de Suporte {type}",
      "yourSpecialist": "Seu profissional em {type}",
      "yourSupportSpecialist": "Seu profissional de suporte",
      "videoCall": "Videochamada",
      "active": "Ativo",
      "announcementsAria": "Anúncios — clique para abrir em uma nova guia",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Clique para acessar o Curso de Boas-Vindas do HighLevel",
      "clickToUpgrade": "Clique para fazer upgrade",
      "connectCertifiedAdminAria": "Conecte-se com um administrador certificado — clique para abrir em uma nova guia",
      "connectWithUsAria": "Conecte-se conosco — inicie um chat ao vivo",
      "contactUsAria": "Entre em contato conosco - ligue para a HighLevel no +1(888)732-4197",
      "copied": "Copiado(a)",
      "highlevelEventsAria": "Eventos da HighLevel - clique para abrir em uma nova guia",
      "joinFacebookGroupAria": "Participe do nosso grupo no Facebook — clique para abrir em uma nova aba.",
      "onboardingVideoTutorialsAria": "Tutoriais em vídeo de integração - clique para abrir em uma nova aba",
      "recommended": "Recomendado",
      "visitHelpCenterAria": "Visite nossa Central de Ajuda — clique para abrir em uma nova guia",
      "contactUs": "Entre em contato conosco",
      "agentChatWaitTime": "Chat do agente (~ 2 a 5 minutos de espera)",
      "aiSupportChat": "Chat de suporte de AI",
      "startChat": "Iniciar chat",
      "announcements": "Anúncios",
      "fastestGrowingCommunity": "Faça parte da comunidade de crescimento mais rápido.",
      "callHighlevelPhone": "Ligue para a HighLevel no número +1(888)732-4197",
      "connectCertifiedAdmin": "Conecte-se com um Administrador Certificado.",
      "connectTeamVideoCall": "Conecte-se com a nossa equipe para obter ajuda por uma videochamada ao vivo",
      "connectWithUs": "Entre em contato conosco",
      "dailyBrainstormingSessions": "Sessões diárias de brainstorming com a HighLevel",
      "certifiedAdminDescription": "Explore especialistas da HighLevel que podem ajudar a configurar o seu sistema, automatizar fluxos de trabalho ou personalizar o seu projeto.",
      "getAccessWelcomeCourse": "Tenha acesso ao curso de boas-vindas da HighLevel",
      "premiumSupportDescription": "Obtenha assistência prioritária, orientação de profissionais e acesso direto à nossa equipe técnica via Slack.",
      "highlevelEvents": "Eventos Highlevel",
      "joinFacebookGroup": "Participe do nosso grupo do Facebook",
      "onboardingVideoTutorials": "Tutoriais em vídeo sobre integração",
      "premiumSupport": "Suporte Premium",
      "setupAccountFreeTutorials": "Configure sua conta com tutoriais gratuitos",
      "viewSupportTicketsArticles": "Visualize seus tickets de suporte, nossos artigos de suporte e FAQs úteis!",
      "visitHelpCenter": "Visite nossa Central de Ajuda",
      "welcomeCourse": "Curso de boas-vindas",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Fechar aba Ajuda e Suporte",
      "upgradePlanToEnable": "Você precisa fazer upgrade do seu plano para ativar este recurso",
      "premiumSupportActive": "Seu suporte premium está ativo",
      "premiumSupportClickUpgrade": "Suporte Premium — Clique para atualizar o seu plano",
      "premiumSupportActiveAria": "Suporte Premium - Seu suporte premium está ativo",
      "keepUpToDateNews": "Fique por dentro com todas as últimas notícias e lançamentos!"
    },
    "hi": "Olá",
    "is_scheduled_for_deletion_on": "está agendado(a) para exclusão em",
    "k": "K",
    "limit_updated_from": "limite atualizado de",
    "minimum_must_be": "O mínimo deve ser",
    "more_emails_in_thread": "mais e-mails na conversa",
    "multipleUsers": {
      "chooseAccount": "Selecione uma conta para continuar"
    },
    "must_be_in_range_of_0": "Deve estar na faixa de 0-",
    "numbers_and": "número(s) e",
    "premiumSupport": {
      "assigningManager": "Atribuindo gerente técnico de contas...",
      "bookCall": "Agendar uma ligação",
      "hiIm": "Olá, eu sou o(a) {name}",
      "joinZoomNow": "Participar da chamada por Zoom agora",
      "quickActions": "Atividades Rápidas de Suporte",
      "quickLinks": "Links rápidos",
      "raiseFeatureRequest": "Solicitar recurso",
      "slackChannelCreating": "Aguarde um instante — seu canal premium do Slack está sendo ativado! 🚀",
      "technicalAccountManager": "Gerente técnico de contas",
      "viewRoadmap": "Visualizar o roteiro do produto"
    },
    "prospecting": "Prospecção",
    "reloadPopup": {
      "message": "Notamos que você não atualiza a página há algum tempo. Atualize para aproveitar o melhor desempenho do app.",
      "refreshNow": "Atualizar agora"
    },
    "resell_settings": "Configurações de revenda",
    "row": "linha",
    "select_upto": "Selecione até",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Obtenha suporte especializado no horário que for mais conveniente.",
      "title": "Programação de uma chamada com o suporte da Highlevel"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Essas são as margens que são cobradas de seus clientes ao longo do",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Deixe-nos gerenciar a Twilio para você facilmente",
        "benefit2": "Nossa equipe de suporte cuidará dos seus problemas com a Twilio",
        "button": "Faça isso por mim",
        "drawback": "Pagar {price} a mais no VAS ativado em comparação a você mesmo faz isso",
        "title": "Nós faremos isso por você"
      },
      "lowCreditsMessage": "Você precisa conectar uma conta Twilio para gerenciar chamadas e mensagens de texto enviadas/recebidas na HighLevel.",
      "lowCreditsTitle": "Você está com poucos créditos gratuitos da Twilio, mas não se preocupe, nós vamos ajudá-lo!",
      "selfSetup": {
        "benefit1": "Gerencie suas despesas",
        "benefit2": "Tenha mais controle sobre o seu serviço Twilio",
        "button": "Eu vou gerenciar",
        "drawback1": "Contrate alguém para gerenciar o serviço Twilio",
        "drawback2": "Entre em contato com o suporte da Twilio quando algo não estiver funcionando.",
        "title": "Faça você mesmo"
      },
      "wip": {
        "button": "Configurar o Twilio agora",
        "fallback": "Por enquanto, você terá que gerenciar sua própria conta Twilio.",
        "message": "Agradecemos por nos escolher, mas ainda estamos trabalhando para implementar esse recurso. Entraremos em contato assim que pudermos ativar essa funcionalidade em sua conta.",
        "title": "Ainda estamos trabalhando nisso!!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Carregando mais opções...",
      "noElementsFound": "Ops! Nenhum componente encontrado. Considere alterar o termo de pesquisa.",
      "noLocationsFound": "Nenhum endereço encontrado. Tente uma pesquisa diferente.",
      "typeToSearch": "Digite para pesquisar",
      "enterUserEmail": "Insira o e-mail do usuário"
    },
    "updating": "Atualizando",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Usar modelo"
    },
    "validEmail": {
      "andYouCan": "E você pode",
      "as": "como",
      "canReverify": "Você pode reverificar seu e-mail",
      "emailIs": "Este e-mail é",
      "emailMarkedAs": "Este e-mail foi marcado como",
      "markedAsInvalid": "Este e-mail está marcado como",
      "notVerified": "Não verificado(a)",
      "reverifyHere": "Verifique novamente aqui",
      "verifyHere": "Verificar aqui"
    },
    "will_give_you_about": "vai te dar aproximadamente",
    "checkout": {
      "confirm": "Confirmar",
      "cardInformation": "Detalhes do cartão",
      "cardNumberInvalid": "O número do seu cartão é inválido.",
      "commitment": "comprometimento",
      "paymentConsent": "Ao confirmar, você permite que a LeadConnector cubra este pagamento no seu cartão.",
      "subscriptionConsent": "Ao confirmar sua assinatura, você permite que a LeadConnector cubra seu cartão para este pagamento e os pagamentos futuros destas assinaturas.",
      "endingIn": "terminando em",
      "month": "mês",
      "pay": "Pagar",
      "payWithCard": "pagar com cartão",
      "paymentBeingProcessed": "O pagamento está sendo processado. Não recarregue nem pressione o botão Voltar",
      "proceedWithExistingCard": "Continuar com o cartão atual",
      "proceedWithNewCard": "Continuar com um novo cartão",
      "purchase": "compra",
      "subscribe": "Inscrever-se",
      "subscribeTo": "Inscrever-se para",
      "pleaseUpdateCardDetails": "Atualize os detalhes do cartão",
      "zip": "cep",
      "retry": "tentar de novo",
      "initialChargesProrated": "As cobranças iniciais são proporcionais e a cobrança regular começará a partir de",
      "youWillBeChargedFor": "Você será cobrado por",
      "days": "dias",
      "rightNowForPeriodTill": "neste momento para o período até",
      "startGettingChargedFullAmount": "e começar a ser cobrado o valor total de",
      "perMonthStartingFrom": "/mês a partir de",
      "nameOnCard": "Nome no cartão",
      "somethingWentWrong": "Algo deu errado",
      "errorImg": "erro de imagem",
      "networkError": "Erro de rede, tente novamente mais tarde",
      "paymentCouldNotBeProcessed": "O pagamento não pôde ser processado. Por favor, tente adicionar um cartão novamente."
    },
    "deleteLocation": {
      "back": "Voltar",
      "delete": "Excluir",
      "completeStepsToDelete": "Você precisa realizar algumas etapas simples para excluir essa localização",
      "alsoCloseAssociated": "Também estreitamente associado",
      "scheduling": "Agendando...",
      "subAccountAndDeletePhoneNumbers": "subconta e excluir todos os números de telefone",
      "somethingWentWrongTryAgain": "Algo deu errado... Tente de novo depois de algum tempo",
      "deleteSubAccount": "Exclua subconta",
      "scheduleForDeletion": "Programação para exclusão"
    },
    "productRebilling": {
      "enableRebilling": "Habilitar refaturamento",
      "ratesMayDifferUK": "As taxas podem variar de acordo com a região. Os cálculos apresentados são conforme as taxas do Reino Unido,",
      "examplePricingGpt4oMini": "Exemplo de precificação - GPT-4o Mini",
      "input": "Entrada",
      "output": "Saída",
      "supportDoc": "documento de suporte",
      "unsavedChanges": "Alterações não salvas",
      "to": "para",
      "chargedToCustomerLower": "Cobrado ao cliente",
      "model": "Modelo",
      "profit": "Lucro",
      "saving": "Salvando...",
      "type": "Tipo",
      "updating": "Atualizando...",
      "clickHere": "Clique aqui",
      "chargedToCustomer": "Cobrado ao cliente",
      "enabling": "Habilitando...",
      "forMoreDetails": "para mais detalhes.",
      "tenDollarsWillGive": "Com 10 dólares, você consegue aproximadamente",
      "yourCost": "Seu custo",
      "seeHow": "Veja como",
      "clientCompanyBillingPage": "Página de faturamento da empresa do cliente",
      "connectStripeToEnable": "Para ativar a cobrança recorrente, você precisa conectar sua conta Stripe ao sistema",
      "companyStripeIntegrationPage": "página de integração do Stripe da empresa",
      "enterClientCardInfo": "Para ativar o refaturamento, você precisa inserir as informações do cartão do cliente em",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(para 750.000 palavras)",
      "words": "palavras",
      "yourCostLower": "O seu custo",
      "and": "e",
      "or": "ou",
      "minimumMustBeBetween": "O mínimo deve estar entre",
      "upgradeToAgencyPro": "Atualize para o Agency Pro",
      "planToSetMargins": "planejar para definir margens"
    },
    "m": "m",
    "label": "Rótulo",
    "company_email_": "E-mail da empresa (",
    "me_": "Eu (",
    "automation_type": "Tipo de automação",
    "calendar_groups": "Grupos de calendário",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Nenhum produto disponível",
    "selectProduct": "Selecione um produto"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Mensagens adicionais de {product} não serão cobradas para as subcontas. Para refaturar o cliente, habilite o modo SaaS e o refaturamento.",
      "agreementPrefix": "Eu concordo em habilitar",
      "agreementSuffix": "para este cliente sem revenda e reconheço que serei cobrado",
      "buildResellerOffer": "Crie sua oferta de revenda",
      "deployDirectlyDescription": "Use esta opção se estiver oferecendo {product} como parte da oferta ou se desejar faturar o cliente externamente",
      "deployPrefix": "Implantar",
      "directlySuffix": "Diretamente",
      "learnMore": "Saiba mais.",
      "offerPrefix": "Oferta",
      "resellPrefix": "Revender",
      "resellingPrefix": "Revendendo",
      "subscriptionRestriction": "Não é possível alterar a configuração porque o endereço já está inscrito",
      "zero": "0",
      "highlevelPrice": "Preço do HighLevel",
      "howDoesItWork": "Como funciona?",
      "payNowButton": "Pagar agora",
      "priceValidationError": "O preço deve ser maior ou igual ao preço do HighLevel",
      "saving": "Salvando",
      "yourPrice": "Seu preço",
      "yourProfit": "Seu lucro"
    },
    "whatsapp": {
      "inboundMessagesInfo": "O recebimento de mensagens de entrada e a respectiva resposta com texto livre na janela de conversa por chat são gratuitos. Serão cobradas taxas adicionais para o envio de mensagens com modelos predefinidos.",
      "whatsappLocation": "Subconta do WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Não é possível alterar a configuração porque o endereço já está inscrito",
        "offerPrefix": "Oferta ",
        "poweredByPrefix": " (Desenvolvido por Search Atlas)",
        "toggleTooltipDisable": "Essa ação desabilitará a ferramenta de SEO em todas as subcontas.",
        "toggleTooltipEnable": "Essa ação habilitará a ferramenta de SEO em todas as subcontas.",
        "resellPrefix": "Revender ",
        "howDoesItWork": "Como funciona?",
        "buildResellerOffer": "Crie sua oferta de revenda",
        "yourPrice": "Seu preço",
        "highlevelPrice": "Preço da HighLevel",
        "yourProfit": "Seu lucro",
        "priceValidationError": "O preço deve ser maior ou igual ao preço da HighLevel",
        "saving": "Salvando",
        "save": "Salvar",
        "deployPrefix": "Implantar ",
        "directlySuffix": "Diretamente",
        "deployDirectlyDescription": "Use essa opção se estiver oferecendo SEO como parte da oferta ou se desejar faturar o cliente externamente",
        "agreementPrefix": "Eu concordo em habilitar ",
        "agreementSuffix": " para este cliente sem revenda e reconheço que serei cobrado",
        "payNowButton": "Pagar agora",
        "subscriptionCreating": "A assinatura está sendo criada.<br/>Por favor, não recarregue nem pressione o botão Voltar",
        "subscriptionCreated": "Assinatura criada com sucesso. Aguarde...",
        "subscriptionError": "Não foi possível criar a assinatura, entre em contato com o suporte"
      },
      "adManager": {
        "subscriptionRestriction": "Não é possível alterar a configuração porque o endereço já está inscrito",
        "offerPrefix": "Oferta ",
        "resellingPrefix": "Revendendo",
        "resellPrefix": "Revender ",
        "howDoesItWork": "Como funciona?",
        "bookACall": "Agendar uma ligação",
        "bookCallTooltip": "Agende uma ligação com nossa equipe para saber mais sobre o Ad Manager",
        "buildResellerOffer": "Crie sua oferta de revenda",
        "yourPrice": "Seu preço",
        "highlevelPrice": "Preço da HighLevel",
        "yourProfit": "Seu lucro",
        "priceValidationError": "O preço deve ser maior ou igual ao preço da HighLevel",
        "loading": "Carregando...",
        "save": "Salvar",
        "deployPrefix": "Implantar ",
        "directlySuffix": "Diretamente",
        "deployDirectlyDescription": "Use essa opção se estiver oferecendo o Gerenciador de Anúncios como parte da sua oferta ou se desejar faturar o cliente externamente",
        "agreementPrefix": "Eu concordo em habilitar ",
        "agreementMiddle": " para este cliente sem revenda e reconheço que serei cobrado",
        "agreementSuffix": " por mês",
        "stripeNotConnectedLocationWarning": "O Stripe não está conectado para esta localização. Por favor, conecte o Stripe para habilitar este recurso.",
        "stripeNotConnectedAgencyWarning": "O Stripe não está conectado para esta agência. Por favor, conecte o Stripe para habilitar este recurso.",
        "underSubAccountReselling": "por mês sob revenda de subconta"
      },
      "dedicatedIp": {
        "description": "Isso permite que você refature o IP dedicado (usado para envio de emails) para cobrar os clientes e inclui uma margem de lucro",
        "numberOfIps": "Nº de IPs:",
        "yourCost": "Seu custo:",
        "chargedToCustomer": "Cobrado ao cliente:",
        "profit": "Lucro:",
        "monthlyProfit": "Lucro mensal:",
        "loading": "Carregando...",
        "save": "Salvar",
        "revokeDedication": "Revogar a dedicação",
        "revokeDescription": "Use essa opção para interromper a oferta de novos IPs dedicados ao seu cliente sem cobrar por isso",
        "existingSubscriptionsNote": "As assinaturas de IP atuais não serão afetadas",
        "revoke": "Revogar",
        "provideDirectlyTitle": "Ofereça IP dedicado para e-mail diretamente",
        "provideDirectlyDescription": "Use essa opção para oferecer um IP dedicado ao seu cliente sem cobrar por isso",
        "agreeToProvideText": "Concordo em oferecer IP para esse cliente sem venda adicional",
        "acknowledgeChargeText": "Confirmo que haverá cobrança de US$ 59/mês/IP",
        "agree": "Concordo",
        "yourMonthlyCost": "Seu custo mensal de IP:",
        "monthlyChargeToCustomer": "Cobrança mensal do cliente:",
        "resellingSettingsSuffix": " Configurações de revenda",
        "ipRebillingAmount": "Valor de refaturamento de IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Confirmo que discuti isso com o meu cliente e tenho a aprovação dele",
        "confirmQuestion": "Tem certeza de que deseja desabilitar o modo SaaS para esta conta?",
        "dataLossAck": "Eu reconheço que todos os dados de refaturamento, de assinatura de SaaS e de transação serão perdidos",
        "disableSaas": "Desabilitar SaaS",
        "irreversibleAck": "Entendo que essa ação é irreversível"
      },
      "confirmationModal": {
        "cancelSubscription": "Também cancele a assinatura de SaaS associada",
        "confirmDisable": "Salvar desabilitar",
        "confirmQuestion": "Tem certeza de que deseja desabilitar o modo SaaS?",
        "somethingWentWrong": "Algo deu errado... Tente de novo depois de algum tempo"
      },
      "processingModal": {
        "closeNow": "Fechar agora",
        "closeWindowInstructions": "Você pode fechar esta janela. Quando o processo for concluído, você receberá uma notificação por e-mail.",
        "title": "O SaaS será desativado para esta localização em breve.",
        "typicalTime": "Isso geralmente leva 10 minutos ou menos."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Adicionar campo personalizado",
      "fieldKey": "Token do setor",
      "fieldName": "Nome do campo",
      "idWillBeAdded": "O ID será adicionado após a criação do motivo perdido",
      "lostReasonID": "ID do motivo perdido",
      "placeholder": "Placeholder"
    },
    "locationMailGun": {
      "bccAddress": "Endereço BCC",
      "clearError": "Corrigir erro",
      "deleteConfirmationMessage": "Esta ação removerá a conexão do Mailgun.",
      "deleteConnection": "Apagar conexão",
      "domain": "Domínio",
      "domainsAvailable": "{count} disponível(eis)",
      "invalidApiKey": "Chave de API inválida",
      "selectDomain": "Selecionar domínio"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Falha ao buscar detalhes da transação",
      "transactions": "Vendas"
    },
    "noShowSMS": {
      "smsWithImage": "SMS de não comparecimento com imagem",
      "title": "Personalizar SMS de Avaliação"
    },
    "optOut": {
      "addKeywords": "Adicione uma das seguintes palavras-chave de cancelamento: PARAR, PARAR TUDO, CANCELAR INSCRIÇÃO, CANCELAR, ENCERRAR ou SAIR.",
      "customizeTitle": "Personalize a mensagem de inscrição cancelada",
      "disableConfirm": "Tem certeza de que deseja desabilitar a mensagem de inscrição cancelada?",
      "disableOptOut": "Desabilitar Inscrição cancelada",
      "disableTitle": "Desabilitar mensagem de cancelamento de inscrição?",
      "optInConfirmClient": "Confirmo que vou garantir que os SMS sejam enviados apenas para os contatos que optaram por recebê-lo.",
      "quickTipMessage": "A mensagem inicial que você envia a um indivíduo precisa incluir uma das seguintes palavras-chave padrão para exclusão: STOP, PARAR TUDO, INSCRIÇÃO CANCELADA, CANCELAR, FINALIZAR ou SAIR.",
      "reallyDisableConfirm": "Tem certeza de que realmente deseja desabilitar a mensagem de inscrição cancelada?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Corpo da requisição POST",
        "requestQueryParameters": "Parâmetros de consulta da solicitação",
        "responseBody": "Corpo da resposta"
      },
      "logs": "Registros",
      "logsPage": {
        "clearAll": "Limpar tudo",
        "loadMore": "Carregar mais",
        "price": "Preço",
        "product": "Produto",
        "tabsAriaLabel": "Abas de registros de pagamento"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Adicione texto geral no(a)",
      "beginning": "Início",
      "complianceConfirm": "Confirmo que garantirei que todas as mensagens SMS enviadas por esta conta estejam em conformidade com a política atual",
      "customizeTitle": "Personalizar texto geral",
      "disableConfirm": "Tem certeza de que deseja desabilitar o SenderID?",
      "disableSenderID": "Desabilitar ID do remetente",
      "disableTitle": "Desabilitar o SenderID?",
      "end": "Fim",
      "pleaseAdd": "Incluir {text} conforme mencionado na dica rápida.",
      "quickTipMessage": "A mensagem inicial que você envia para um indivíduo precisa incluir as informações de identificação do remetente. Inclua {text} no campo de texto geral.",
      "reallyDisableConfirm": "Tem certeza de que deseja desabilitar o SenderID?",
      "senderID": "ID do remetente"
    },
    "shopify": {
      "adminApiAccessToken": "Token de acesso da API de administrador",
      "apiTokenRequired": "O token de acesso à API é obrigatório",
      "checkDocumentation": "Consulte esta documentação para obter mais informações",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Token de acesso de API de app personalizado",
      "deleteWarning": "Excluir isso removerá a conexão existente.",
      "existStoreAlertTitle": "A integração com a loja Shopify já existe",
      "integration": "Integração com a Shopify",
      "integrationHealth": "Saúde da Integração",
      "orders": "Pedidos",
      "scopePermissionsWarning": "Certifique-se de que seu app tenha as permissões marcadas com um X vermelho",
      "scopes": "Escopos",
      "scopesDescription": "É necessário conceder escopos de autorização para obter informações da Shopify. Devido a mudanças recentes na Shopify, o método `read_customers` agora é necessário para obter as informações completas dos clientes, em virtude da proteção de dados do cliente implementada pela Shopify.",
      "storeConnectedMessage": "Loja Shopify já conectada com a subconta {locationName}",
      "storeNameHelp": "O nome da sua loja está localizado no URL da sua conta da Shopify, depois de https:// e antes de .myshopify.",
      "storeNameLabel": "Nome da sua loja Shopify",
      "storeNamePlaceholder": "nome da loja",
      "storeNameRequired": "O nome da loja é obrigatório",
      "typeRemoveConfirm": "Digite \"REMOVER\" para confirmar",
      "webhooks": "Webhooks",
      "webhooksDescription": "Para receber todos os eventos da Shopify, precisamos registrar esses webhooks da Shopify durante o processo de integração. Esses webhooks são essenciais para garantir o funcionamento adequado dos recursos da Shopify."
    },
    "slack": {
      "accountConnected": "conta conectada",
      "accountsConnected": "contas conectadas",
      "accountsList": "Lista de todas as contas do Slack",
      "added": "Adicionado {date}",
      "connectChannel": "Conecte o seu canal do Slack",
      "description": "Receba notificações instantâneas no seu canal do Slack. Clique em \"Conectar\" para adicionar um canal do Slack.",
      "manage": "Gerenciar",
      "manageAccounts": "Gerencie contas do Slack",
      "noIntegrations": "Nenhuma integração do Slack encontrada."
    },
    "smtpService": {
      "addFirstService": "Adicione seu primeiro serviço SMTP.",
      "addService": "Adicionar serviço",
      "bccEmails": "E-mails em BCC",
      "cannotDeleteDefaultProvider": "Você não pode excluir o provedor padrão.",
      "contactDeveloper": "Entre em contato com o desenvolvedor deste app.",
      "customProvider": "Provedor personalizado",
      "defaultProvider": "Provedor Padrão",
      "defaultProviderUpdated": "O provedor padrão foi atualizado com sucesso!",
      "emailDomain": "Email / Domínio",
      "emailService": "Serviço de e-mail",
      "enableReplyTracking": "Habilitar rastreamento de resposta",
      "forwardToAssignedUser": "Reenviar para o usuário atribuído",
      "providerType": "Tipo de provedor",
      "smtpConnectionIssue": "Há um problema com esta conexão de smtp. Reconecte esta integração.",
      "useLcEmailMessage": "Use o LeadConnector Email System para carregar e-mails para sua agência e seus clientes."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Publicação automática habilitada",
      "dailyPostLimit": "Limite Diário de Publicações",
      "directoriesDescription": "Quando você receber uma nova avaliação, nós a publicaremos automaticamente em mais de 80 diretórios online que ajudarão a impulsionar sua marca e melhorar seu SEO.",
      "directoriesTitle": "Mais de 80 diretórios e sites",
      "fivePosts": "5 publicações",
      "fiveStars": "5 estrelas",
      "fourPosts": "4 publicações",
      "fourStars": "4 estrelas",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personalize como e quando suas avaliações são publicadas automaticamente em cada uma de suas redes sociais.",
      "manageSettingsTitle": "Gerencie suas Configurações de Publicação em Redes Sociais",
      "postReviewsForRating": "Publique avaliações para esta classificação por estrelas ou superior.",
      "searchEngines": "Mecanismos de busca",
      "threePosts": "3 publicações",
      "threeStars": "3 estrelas",
      "title": "Publicação nas redes sociais"
    },
    "tags": {
      "addNewTag": "Adicionar nova tag",
      "allTags": "Todas as palavras-chave",
      "deletedTags": "Palavras-chave apagadas",
      "here": "aqui.",
      "newTag": "Nova tag",
      "noTagsYet": "Ainda não há tags para exibir",
      "searchTags": "Pesquisar tags",
      "viewDeletedTags": "Você pode visualizar e restaurar as tags apagadas na página Registros de auditoria"
    },
    "templateMessage": {
      "addEmailTemplate": "Adicionar modelo de e-mail (trecho)",
      "addTemplate": "Upload de modelo (trecho)",
      "addTextTemplate": "Adicionar modelo de texto (trecho)",
      "body": "Corpo",
      "deleteTemplateConfirmation": "Tem certeza de que deseja excluir este modelo?",
      "templatesCount": "{count} modelos",
      "title": "Modelos de mensagens (trechos)"
    },
    "unsubscribe": {
      "content": "Conteúdo",
      "contentTooltip": "O conteúdo desta mensagem será adicionado automaticamente a todos os e-mails.",
      "customizeTitle": "Personalizar conteúdo para cancelar inscrição",
      "disableConfirm": "Tem certeza de que deseja desabilitar o link de cancelamento de inscrição do e-mail?",
      "disableTitle": "Desabilitar link de inscrição cancelada?",
      "disableUnsubscribe": "Desativar o cancelamento de inscrição",
      "pleaseAddTag": "Adicione a tag /*cancelar inscrição*/",
      "reallyDisableConfirm": "Tem certeza de que realmente deseja desabilitar o link de cancelamento de inscrição do e-mail?",
      "subscribedConfirm": "Confirmo que o e-mail será enviado apenas para contatos que se inscreveram para recebê-los.",
      "subscribedConfirmClient": "Confirmo que me certificarei de que os e-mails serão enviados apenas para os contatos que se inscreveram para receber emails.",
      "suspensionWarning": "Atividade não conforme pode levar à suspensão dos recursos de e-mail da sua conta.",
      "tagRequirement": "O e-mail inicial que você envia para um indivíduo precisa incluir a tag /*cancelar inscrição*/."
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Esta é a mensagem de correio de voz padrão para todos os números Twilio na localização, a menos que personalizada em",
      "forwardCallsToWebApp": "Encaminhar chamadas para o app web",
      "forwardCallsToMobileApp": "Encaminhar chamadas para o aplicativo móvel",
      "dedicatedNumberRequiredInfo": "Isso só é necessário se os usuários precisarem de um número dedicado. Não é necessário para o correio de voz ou para o encaminhamento da chamada ao usuário designado.",
      "voicemailMessageInfo": "Esta mensagem de voz será reproduzida em vez da mensagem da operadora de telefonia. Recomendamos um tempo limite de 20 segundos ou menos.",
      "noTimeout": "Sem tempo limite",
      "10Secs": "10 s",
      "20Secs": "20 s",
      "voicemailMessageDuration": " Gravaremos uma mensagem de voz se a chamada não for atendida antes desse período",
      "saveCallSettings": "Salvar configurações de chamada"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Quando esta etiqueta estiver presente no contato, essas mensagens NÃO serão entregues ao Eliza",
      "sendToElizaNote": "Por padrão, todas as conversas serão entregues ao Eliza. Se esta tag estiver configurada, <br />as novas conversas serão enviadas para Eliza somente quando esta tag estiver presente em um contato.<br /> Se as tags Eliza bypass e Send to Eliza estiverem configuradas, apenas a tag Send to Eliza será considerada",
      "permissionNote": "Suas permissões de usuário não estão habilitadas para esta página. <br />Por favor, fale com o seu administrador",
      "addFAQ": "Adicionar perguntas frequentes"
    },
    "locationSettings": {
      "ownCardWarning": "Não adicione o seu próprio cartão às subcontas.",
      "addClientCardWarning": "Adicione o cartão do seu cliente (subconta) e não o seu, pois este cartão será utilizado para faturar o seu cliente em seu nome.",
      "stripeConnectMissing": "Conexão Stripe ausente",
      "pleaseContactAgencyToAddPaymentMethods": "Entre em contato com a agência ({email}) para adicionar métodos de pagamento."
    },
    "integrations": {
      "connectWaveAccount": "Conecte a conta Wave da sua localização.",
      "connectXeroAccount": "Conecte a conta Xero do seu local"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "O rastreamento de chamadas GBP está habilitado em outra subconta. O rastreamento de chamadas pode ser habilitado em uma única subconta por vez.",
      "gbpCallTrackingEnabledOnAnotherPage": "O rastreamento de chamadas GBP está habilitado em outra página({pageName}). O rastreamento de chamadas pode ser ativado em uma única subconta e uma única página por local de cada vez.",
      "gbpCallsProperlySetup": "As chamadas GBP estão configuradas corretamente e estão sendo recebidas de",
      "tooManyEditsToPrimaryPhone": "Você fez muitas edições no telefone principal para este negócio. Tente novamente mais tarde.",
      "setupTwilioToStartCallTracking": "Configure a Twilio para iniciar o rastreamento de chamadas",
      "twoSecondaryNumbersSetupAlready": "Você já tem 2 números secundários configurados, não é possível alternar o número",
      "yourAgentIDIs": "Seu ID de agente é"
    },
    "numberPool": {
      "title": "O que acompanhar",
      "tracking": {
        "percentComplete": "34% Concluído",
        "searchLower": "busca"
      },
      "create": {
        "title": "Criar número de rastreamento"
      }
    },
    "phoneNumbers": {
      "title": "O que acompanhar",
      "tracking": {
        "percentComplete": "34% Concluído",
        "heading": "Criar número de rastreamento"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Insira um valor",
      "selectOption": "* Selecione uma opção"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Pelo menos um {filterName} é obrigatório",
      "select": "Selecione {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Carimbo de data/hora"
    },
    "recordsNav": {
      "clickToReloadList": "Clique para atualizar a lista"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Solicitações de revisão por e-mail",
      "smsReviewReq": "Solicitação de revisão por SMS",
      "whatsappReviewReq": "Solicitação de revisão do WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Limpar todos os filtros",
      "noneFound": "nenhum encontrado",
      "saveChangesToList": "Salvar alterações de filtro nesta lista inteligente",
      "saveCombinationAsNew": "Salvar combinação de filtros, colunas e classificação como uma nova lista inteligente.",
      "saveCurrentAsNew": "Salvar os filtros atuais como uma nova lista inteligente",
      "searchAndAddFilter": "Pesquisar e adicionar um filtro",
      "searching": "pesquisando...",
      "undoUnsavedChanges": "Desfazer alterações não salvas"
    },
    "smsStatsPanel": {
      "smsStats": "Estatísticas de SMS"
    },
    "manageDuplicates": "Gerenciar Duplicatas",
    "emailAction": {
      "attachFiles": "Anexar arquivos",
      "customValues": "Valores personalizados",
      "triggerLinks": "Acionar links"
    },
    "atLeastOneRequired": "* Pelo menos um {filterName} é obrigatório",
    "arrayInput": {
      "searchPlaceholder": "Pesquisar {filterName}",
      "searching": "Pesquisando..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Falhou ao buscar os conteúdos do instantâneo",
      "overwriteAll": "Sobrescrever tudo",
      "skipAll": "Ignorar tudo",
      "somethingWentWrongWhileFindingConflicts": "Algo deu errado ao localizar conflitos",
      "step": "Etapa"
    },
    "confirmOverwrite": {
      "confirmButton": "Confirmar substituição",
      "description": "Esta ação é irreversível e pode alterar as configurações de campanhas, oportunidades, funis etc. Confirme sua ação digitando o seguinte no campo de entrada.",
      "title": "Tem certeza de que deseja sobrescrever os dados selecionados?"
    },
    "conflicts": {
      "noConflictsDetected": "Nenhum conflito detectado",
      "overwrite": "Substituir"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Ativos vinculados encontrados",
      "checkingConflicts": "Verificando conflitos",
      "chooseSnapshot": "Selecionar um instantâneo",
      "copyingDataNotification": "Copiando dados para locais selecionados. Aguarde...",
      "linkedLocations": "Localizações vinculadas",
      "noConflictsFound": "Não foram encontrados conflitos",
      "notAuthorizedMessage": "Apenas administradores de exibição da agência podem realizar esta ação",
      "overwriteConflicts": "Conflitos de substituição",
      "pickSnapshot": "Selecionar um Instantâneo",
      "response": "Resposta",
      "selectAssetsToPush": "Selecione os ativos para enviar",
      "selectLocationsToUpdate": "Selecionar localizações para atualizar",
      "snapshotNotAuthorized": "Este instantâneo não está autorizado para esta localização.",
      "snapshotNotSelected": "Instantâneo não selecionado"
    },
    "share": {
      "agencyRestrictedLink": "Link privado de agência",
      "deleteShareLink": "Excluir link para compartilhar",
      "editShareLink": "Editar link para compartilhar",
      "permanentLink": "Link permanente",
      "subaccountRestrictedLink": "Link privado de subconta"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Adicione uma vírgula (<span class='text-base font-bold'> , </span>) após cada número de relação)",
      "addCommaAfterEachSubAccount": "(Adicionar uma vírgula (<span class='text-base font-bold'> , </span>) após cada ID da subconta)",
      "atLeast1EmailRequired": "É necessário pelo menos 1 e-mail.",
      "emailShareLink": "Link de compartilhamento por e-mail",
      "enterOnePerLine": "Insira um por linha",
      "errorGettingLink": "Algo deu errado ao obter o link. Tente de novo mais tarde.",
      "getAgencyRestrictedLink": "Obter link privado de agência",
      "getLink": "Obter link",
      "getOneTimeLink": "Obter link de compartilhamento único",
      "getPermanentLink": "Obter link permanente",
      "getSubAccountRestrictedLink": "Obter link privado de subconta",
      "shareType": "Tipo de compartilhamento",
      "title": "Compartilhar instantâneo"
    },
    "snapshot": {
      "copySnapshotID": "Copiar ID do instantâneo",
      "deleteSnapshot": "Excluir instantâneo",
      "editSnapshot": "Editar instantâneo",
      "pushUpdate": "Atualizar contas vinculadas por push",
      "refreshSnapshot": "Atualizar instantâneo"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Adicione uma vírgula após cada número de relacionamento)",
      "addCommaAfterEachSubAccount": "(Adicionar vírgula após cada ID de subconta)",
      "title": "Atualizar link de compartilhamento"
    }
  },
  "socialMedia": {
    "engagement": "Engajamento",
    "potentialReach": "Alcance Potencial",
    "storiesCreated": "Histórias criadas",
    "recentPosts": "Publicações recentes",
    "notConnected": "Não conectado (Conecte-se agora!)",
    "totalAudience": "Público Total",
    "activeAudience": "Público Ativo",
    "socialMediaOverview": "Visão Geral das Redes Sociais"
  },
  "suspendModal": {
    "currentStatus": "Status atual da assinatura: Pausada",
    "instructions": "Você precisa concluir algumas etapas simples para {action} esta subconta",
    "nextBillingDate": "Próxima data de faturamento:",
    "noKeepCharging": "Não, continuar cobrando o cliente.",
    "pauseSubscriptionQuestion": "Você também quer pausar a assinatura junto com a subconta?",
    "resumeSubAccount": "Continuar com a subconta",
    "resuming": "Continuando...",
    "saasSubscriptionActive": "Essa subconta tem uma assinatura de SaaS ativa.",
    "saasSubscriptionResumed": "A assinatura de SaaS dessa conta será retomada.",
    "yesPause": "Sim, pausar a assinatura"
  },
  "table": {
    "perPageOptions": {
      "5": "5 por página",
      "10": "10 por página",
      "15": "15 por página",
      "20": "20 por página",
      "25": "25 por página",
      "50": "50 por página",
      "100": "100 por página"
    },
    "filterPlaceholder": "Pesquisar...",
    "emptyText": "Nenhum registro encontrado",
    "loading": "Carregando...",
    "showingEntries": "Exibindo {from} a {to} de {total} entradas",
    "noEntriesToShow": "Nenhuma entrada a exibir"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Carregando dados da conta…",
      "toContinueWith": "para continuar com"
    },
    "switcherModal": {
      "comingSoon": "Em breve!",
      "multiLocationMessage": "Este recurso está disponível atualmente apenas para contas individuais. Estamos trabalhando arduamente para disponibilizar isso para contas com várias subconta em breve."
    },
    "importedMessage": "{productName} importado! Navegue até a Biblioteca de modelos e encontre-o na guia {productName}.",
    "permissionErrorMsg": "Esta opção está disponível apenas em planos superiores. Faça upgrade agora para desbloqueá-la.",
    "errors": {
      "sourceDeleted": "Erro: o modelo de origem foi apagado. Ele não está mais disponível. Verifique o status do modelo ou entre em contato com a fonte para obter assistência.",
      "sourceDraft": "Erro: o modelo de origem foi movido para Rascunho. Verifique o status do modelo ou entre em contato com a fonte para obter assistência.",
      "linkedDeleted": "Erro: o modelo de origem, associado ao modelo compartilhado, foi excluído. Verifique o status do modelo ou entre em contato com a fonte para obter assistência.",
      "fetchError": "Parece que há um erro ao obter os detalhes de {productName}. Verifique a URL ou tente novamente.",
      "sameAgency": "Não é possível compartilhar o modelo dentro da mesma agência"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "A ação de adicionar tag de contato requer uma tag.",
    "addNotesRequiresData": "A ação de adicionar observações requer dados de observações.",
    "addTaskRequiresFields": "A ação de adicionar tarefa requer um título e uma data de vencimento.",
    "addToCampaignRequiresCampaign": "A ação de adicionar à campanha requer uma campanha.",
    "addToCustomAudienceRequires": "A Ação de adicionar ao público personalizado do Facebook requer uma conta de anúncios e um público personalizado.",
    "addTrigger": "Adicionar gatilho",
    "anyAction": "Qualquer Ação",
    "anyCondition": "Qualquer status",
    "brokenCustomVariables": "Alguns campos contêm variáveis personalizadas com problemas, corrija-os antes de salvar.",
    "conditionCannotBeEmpty": "O status '{condition}' não pode estar vazio",
    "confirmDeleteTrigger": "Tem certeza de que deseja excluir este gatilho?",
    "customDateFieldRequired": "O filtro de campo de data personalizado é obrigatório para o gatilho de lembrete de data personalizado",
    "detailPage": {
      "chooseTriggerPlaceholder": "Selecionar um gatilho",
      "lastUpdate": "Atualizado em:",
      "loopIdentifiedWarning": "Este gatilho foi bloqueado no status de rascunho porque está causando um loop. Para habilitar este gatilho, entre em contato com o suporte.",
      "ruleNotActiveWarning": "Essa regra não será executada até que você a habilite.",
      "triggerCreation": "Criação de gatilho:",
      "triggerDeletedPrompt": "Este gatilho foi apagado! Deseja redefini-lo?",
      "triggerRunDailyTooltip": "O gatilho é acionado diariamente às 8h AM",
      "whatTriggersRule": "O que deve acionar essa regra?",
      "whichEventTriggersAutomation": "Que evento deve acionar essa automação?"
    },
    "dndContactRequiresState": "A ação de contato DND requer que o estado DND esteja ativado.",
    "emptyConditionNotAllowed": "O Status vazio não é permitido.",
    "emptyFieldNotAllowed": "Campos vazios não são permitidos.",
    "executeWebhookRequiresUrl": "A execução da ação do webhook requer a URL do webhook.",
    "fieldCannotBeEmpty": "{field} não pode estar vazio",
    "fillRequiredFields": "Preencha todos os campos obrigatórios nas atividades.",
    "googleAdwordsRequiresConversion": "A ação de adicionar ao Google Adwords requer conversão.",
    "googleAnalyticsRequiresFields": "A ação de adicionar ao Google Analytics requer um ID de acompanhamento, um tipo de ação e uma categoria de ação",
    "membershipGrantOfferRequiresOffer": "A oferta de concessão de assinatura requer uma proposta.",
    "membershipRemoveOfferRequiresOffer": "A ação de remoção da oferta de assinatura requer uma oferta.",
    "newBasicRule": "Nova regra simples",
    "opportunitiesRequirePipeline": "As ações de oportunidades exigem que você selecione um pipeline.",
    "opportunityLoopWarning": "Este gatilho causará um ciclo de criação de oportunidade. Remova a opção \"Permitir oportunidade duplicada\" ou altere a etapa à qual você está se referindo.",
    "removeContactTagRequiresTag": "A ação de remover a tag de contato requer uma tag.",
    "removeFromCampaignRequiresCampaign": "A ação de remover da campanha requer uma campanha.",
    "removeFromCustomAudienceRequires": "A ação de remover de público personalizado requer uma conta de anúncios e um público personalizado.",
    "rulesBasedOn": "regras baseadas em",
    "selectUserForNotification": "Selecione o usuário para enviar a notificação.",
    "sendEmailRequiresFields": "A ação de enviar um e-mail requer remetente, destinatário, assunto e mensagem.",
    "sendNotificationRequiresFields": "A ação de enviar notificação push requer título, corpo e tipo de usuário para enviar a notificação push.",
    "sendSmsRequiresFields": "A ação de enviar um SMS requer o número e a mensagem.",
    "stripeMinAmountUSD": "O valor deve ser igual ou superior a 50 centavos de dólar USD.",
    "stripeRequiresFields": "A ação de cobrança única do Stripe requer o id do cliente, o valor e a moeda",
    "thatWillFire": "que acionará",
    "triggerCannotBeEmpty": "O gatilho não pode estar vazio",
    "updateContactFieldRequires": "O campo de contato atualizado deve ter pelo menos 1 campo definido."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Pague ${amount} e assine",
      "commitment": "Sem compromisso, cancele a qualquer momento",
      "features": {
        "billedOnUsage": "Cobrança baseada no uso depois que o limite é excedido",
        "externalAI": "Exclui ações de modelos de AI externos, que serão cobradas separadamente",
        "leadingPricing": "Precificação líder do setor!",
        "monthlyPurchase": "Válido para uma compra por mês",
        "premiumActions": "Aplica-se a atividades e gatilhos premium"
      },
      "planDetails": "Detalhes do plano",
      "subscribeAndSave": "Assine e economize hoje mesmo!",
      "title": "${amount} por {executions} execuções por mês"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Esta configuração foi movida para a página de calendários.",
    "toNavigate": "aqui para navegar. Esta página será removida em breve."
  },
  "attribution": {
    "description": "A primeira comunicação é simplesmente o primeiro ponto de contato que um usuário faz. Então, se alguém fosse encontrado pela primeira via um anúncio de pesquisa pago (PPC), esse canal receberia o crédito ao se tratar de uma conversão. Por outro lado, a última interação seria o último canal.",
    "firstInteraction": "Primeira interação",
    "lastInteraction": "Última interação",
    "title": "Atribuição"
  },
  "campaign": {
    "addEvent": "Adicionar evento",
    "a2p": {
      "address": {
        "chooseState": "Selecionar estado...",
        "city": "Cidade*",
        "postalCode": "Código postal/CEP*",
        "streetAddress": "Endereço*",
        "streetAddressHelper": "Deve ser um endereço válido vinculado à sua empresa.",
        "title": "Endereço comercial"
      },
      "addressError": {
        "title": "Falha no envio do endereço"
      },
      "authorizedRep": {
        "jobPosition": "Cargo*",
        "jobTitle": "Cargo*",
        "title": "Informações do representante autorizado"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Marca de Empreendedor Individual",
          "point1": "Apenas 1 número de telefone é permitido",
          "point2": "EIN/SSN/DUNS não são obrigatórios"
        },
        "solePropCampaign": {
          "heading": "Campanha de Empreendedor Individual",
          "point1": "Apenas 1 número pode ser vinculado a uma Campanha de Empreendedor Individual.",
          "point2": "Uma vez aprovado, o seu número padrão será vinculado automaticamente",
          "infoText": "Você também pode atualizar o número após a aprovação.",
          "warningText": "Apenas 1 número pode ser vinculado a uma Campanha de Empreendedor Individual. Depois da aprovação, seu número padrão será vinculado automaticamente; você também pode atualizá-lo após a aprovação."
        },
        "solePropSubtitle": "Detalhes da Marca e Campanha de Empreendedor Individual",
        "standardBrand": {
          "heading": "US$ 4,41 - uma única vez",
          "point1": "EIN/SSN/DUNS obrigatórios",
          "point2": "Mais de 1 número de telefone permitido"
        },
        "standardCampaign": {
          "heading": "US$ 16,54 - uma única vez",
          "point1": "É permitido vincular mais de um número a uma Campanha Padrão.",
          "point2": "EIN/SSN/DUNS obrigatórios",
          "infoText": "Uma taxa adicional de campanha de até US$ 12 por mês será aplicada de acordo com as regras da TCR."
        },
        "standardSubtitle": "Detalhes padrão da marca e da campanha",
        "title": "Detalhes da marca e da campanha"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Informações de contato",
          "contactInfoSubtitle": "Pode ser qualquer pessoa que possa responder a perguntas sobre a marca, caso necessário. Observe que você não pode reutilizar as mesmas informações de contato entre marcas diferentes. Cada marca criada deve ter informações de contato exclusivas.",
          "emailHelper": "Não use o mesmo e-mail para mais de 5 marcas.",
          "phoneNumberHelper": "Não use o mesmo número de telefone para mais de 5 marcas.",
          "profileName": "Nome da empresa ou seu nome e sobrenome*",
          "profileNameHelper": "Use o nome legal da organização que está enviando as mensagens ou seu próprio nome, caso esta marca não represente uma empresa.",
          "nextLoading": "Próximo...",
          "invalidPhoneNumber": "Número de telefone inválido",
          "phoneNumberWithCountryCode": "Número de telefone (com código do país)*",
          "phoneNumberRequired": "O número de telefone é obrigatório.",
          "emailRequired": "O e-mail é obrigatório.",
          "profileNameRequired": "O nome do perfil é necessário."
        },
        "standard": {
          "businessType": "Tipo de empresa*",
          "legalBusinessName": "Razão social*",
          "legalBusinessNameHelper": "Insira o nome exato da empresa, conforme registrado junto ao Governo e mencionado em seus documentos de imposto (CP 575). Ex: Leadconnector LLC em vez de Leadconnector.",
          "regionsOfOperations": "Regiões em que a empresa opera*",
          "registrationNumber": "Número de registro da empresa* / CNPJ*",
          "registrationNumberHelper": "O número usado para identificar a sua empresa. No caso de EIN dos EUA, deve ser um número de 9 dígitos, ex.: 12-3456789.",
          "registrationType": "Tipo de ID de registro comercial*",
          "website": "Site da empresa*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Etapa {currentStep} de {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "O perfil da sua empresa foi enviado com sucesso.",
        "startA2P": "Iniciar registro A2P",
        "title": "Perfil Comercial Enviado com Sucesso",
        "tooltips": {
          "agency": "Os usuários da agência podem iniciar o registro A2P",
          "location": "Usuários de localização podem iniciar o registro A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Fechar exemplo",
          "optInKeywords": "Palavras-chave de adesão*",
          "optInKeywordsHelper": "Máximo de 255 caracteres.",
          "optInKeywordsPlaceholder": "Palavras-chave separadas por vírgulas. Exemplo: SUBSCRIBE, START.",
          "optInMessage": "Mensagem de adesão*",
          "optInMessageInfo": "Deve conter o nome da empresa e a palavra-chave de cancelamento de adesão.",
          "optInMessagePlaceholder": "Exemplo: você se cadastrou com sucesso para receber notificações e SMS promocionais da nome_da_empresa. Responda STOP caso queira cancelar no futuro.",
          "placeholder": "Exemplo: Os usuários finais optam por participar visitando https://www.mycompany.com/book e preenchendo seus dados. Os usuários marcam uma caixa para receber notificações e mensagens promocionais nossas para dar seu consentimento. Além disso, os usuários finais também podem enviar um SMS com a palavra START para +1 (213) 725-2867.",
          "question": "Como os usuários finais dão consentimento para receber mensagens?*",
          "seeExample": "Veja o exemplo"
        },
        "messageDetails": {
          "embeddedLink": "A mensagem incluirá um link incorporado",
          "phoneNumbers": "As mensagens incluirão números de telefone",
          "sampleMessage1Placeholder": "Exemplo: Olá, John! Aqui é a Jane, da nome_da_empresa. Seu agendamento para 20 de julho às 11h00 está confirmado. Por favor, entre em contato com +1(213) 725-2867 caso precise reagendar. Responda STOP para cancelar a inscrição.",
          "sampleMessage2Placeholder": "Modelo: Olá, Brian! Aqui é a Jane, da nome_da_empresa. Vi que você não conseguiu comparecer ao compromisso agendado. Gostaria de reagendar? - https://www.mycompany.com/book. Responda com STOP para cancelar a inscrição.",
          "sampleMessageInfo": "Deve incluir o nome do lead, seu nome, o nome da empresa e a informação de cancelamento de adesão.",
          "subtitle": "Adicionar mensagens de exemplo"
        },
        "useCaseDetails": {
          "explainInDetail": "Explique em detalhes",
          "pickUseCase": "Selecionar caso de uso de campanha",
          "solePropLabel": "Proprietário individual",
          "subtitle": "Digite os detalhes e a descrição da campanha",
          "useCase": "Caso de uso de campanha*",
          "useCaseDescription": "Descrição do caso de uso*",
          "useCaseDescriptionPlaceholder": "Modelo: Esta campanha envia informações sobre agendamentos (mensagens de confirmação e lembrete) aos nossos clientes assim que eles agendam um compromisso conosco em nosso site e optam por receber nossos SMS promocionais e de notificação."
        }
      },
      "einModal": {
        "disableNoEINText": "Somente empresas com endereço válido nos EUA e Canadá podem registrar uma marca A2P sem um ID fiscal.",
        "hasEIN": "Sim, a Empresa que estou registrando tem um ID fiscal (por ex., EIN, CCN, CNPJ etc.).",
        "infoText": "Você pode descobrir seu EIN dos EUA no seu formulário CP 575.",
        "noEIN": "Não, a empresa que estou registrando não possui um número de identificação fiscal (por ex., EIN, CCN, CNPJ etc.).",
        "question": "A empresa que você está registrando possui um ID fiscal (por ex., EIN, CCN, CNPJ etc.)?*",
        "title": "Determinar as necessidades da Brand Boards A2P"
      },
      "exampleModal": {
        "examples": "Exemplos"
      },
      "otpError": {
        "message": "Houve algum problema no envio do OTP.",
        "title": "Falha ao reenviar o OTP"
      },
      "otpSuccess": {
        "title": "Seu OTP foi enviado com sucesso."
      },
      "validation": {
        "cityRequired": "A cidade é obrigatória.",
        "countryRequired": "O país é obrigatório.",
        "invalidMobileNumber": "Número de celular inválido",
        "postalCodeRequired": "O Código postal/CEP é obrigatório.",
        "stateRequired": "O estado é obrigatório.",
        "streetAddressRequired": "O endereço completo é obrigatório."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Proprietário da agência",
      "agencyOwnerAndAdmins": "Proprietários e administradores da agência",
      "contactAgencyOwner": "Se precisar de ajuda, entre em contato com seu(sua)",
      "firstPromoterAccessMessage": "Este relatório da FirstPromoter só pode ser acessado por",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Não foi possível encontrar um parceiro que corresponda aos seus filtros. Clique",
      "paymentDetailsAccessMessage": "Esta seção de detalhes do pagamento só pode ser acessada e editada pelo",
      "toApplyPartner": "para se candidatar como parceiro."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Carregando",
      "legalBusinessNameHelper": "Insira o nome exato da empresa, conforme registrado junto ao Governo e mencionado em seus documentos de imposto (CP 575). Ex: Leadconnector LLC em vez de Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Clique em <span class='font-semibold'>Abrir HighLevel</span> para iniciar o app para desktop.<br>Não está funcionando? Você também pode <a href=\"/\" class='!text-blue-700 hover:underline'>usar o HighLevel no seu navegador</a>",
        "launchingTitle": "Iniciando o HighLevel Desktop",
        "launchButtonText": "Abrir HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Clique em <span class='font-semibold'>Abrir LeadConnector</span> para iniciar o app para desktop.<br>Não está funcionando? Você também pode <a href=\"/\" class='!text-blue-700 hover:underline'>usar o LeadConnector no seu navegador</a>",
        "launchingTitle": "Iniciando o LeadConnector Desktop",
        "launchButtonText": "Abrir LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Selecione uma ação",
        "destination": "Destino",
        "removeFromAllCampaigns": "Essa ação removerá oportunidades de todas as campanhas, exceto da campanha atual",
        "triggerLinks": "Links de gatilho"
      },
      "importTemplate": {
        "errorImporting": "Erro ao importar o modelo!",
        "importTemplate": "Importar modelo",
        "importing": "Importando",
        "title": "Importar o modelo {entityName}",
        "unnamedEntity": "Cópia de {entityName} anônimo(a)"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "abaixo",
          "confirmByTyping": "Por favor, confirme digitando",
          "confirmWord": "CONFIRMAR",
          "existingNotMoved": "Se o seu cliente já tiver o Mailgun ou configuração SMTP, eles não serão transferidos",
          "notNow": "Agora não",
          "pricingInfo": "O LC Email é mais barato que o Mailgun e a cobrança será de cerca de US$ 0,68 por 1000 e-mails",
          "setAsDefault": "Defina o LC Email como provedor padrão para sua agência e para clientes que ainda não possuem Mailgun ou SMTP",
          "thisWill": "Isso irá:",
          "title": "Você está migrando para o Lead Connector Email",
          "useLcEmail": "Usar LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Arraste e solte o conteúdo aqui",
        "editPost": "Editar publicação",
        "enterText": "Insira o texto aqui",
        "exampleComment": "Muito legal!! Estou ansioso por isso!",
        "exampleName": "Tecnologia de teste",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Precisa de revisão?",
        "network": "Rede",
        "photo": "foto",
        "previewPost": "Pré-visualizar publicação",
        "selectNetwork": "Selecione a rede social",
        "sizeExample": "245 kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Você criou um pool de {count} números para rastrear visitantes no seu site. <br />Suas chamadas serão encaminhadas para",
          "createdSingle": "Você criou um número {count} para rastrear os visitantes no seu site. <br />Suas chamadas serão encaminhadas para",
          "percentComplete": "100% concluído"
        },
        "create": {
          "correctErrors": "Corrija os erros!",
          "forwardHelp": "Informe-nos qual telefone deve tocar quando o cliente ligar para o seu número de telefone de rastreamento. Geralmente o seu principal número de telefone comercial. Exemplo: 404-555-1212",
          "heading": "Grupo de números e encaminhamento de chamadas",
          "nameHelp": "O \"{name}\" é como nos referiremos a este número de rastreamento em sua conta. Selecione um nome curto e fácil de lembrar.",
          "newTrackingNumbers": "novos números de rastreamento.",
          "nextTracking": "Próximo: opções de rastreamento",
          "percentComplete": "50% Concluído",
          "pleaseConfirm": "Por favor, confirme:",
          "poolSize": "Tamanho do pool",
          "poolSizeError": "Insira um tamanho de pool entre 4 e 30 números de rastreamento.",
          "poolSizeHelp": "O tamanho do seu pool de números determina quantos visitantes simultâneos podemos monitorar em seu site a qualquer momento. O tamanho do seu pool deve ser um quarto do tráfego de pico por hora relatado no Google Analytics, com um mínimo de 4 números.",
          "swappingHelp": "Informe-nos qual número de telefone devemos trocar no website. Exemplo: 404-555-1212",
          "swappingNumber": "Número de troca",
          "validationError": "Ocorreu um erro ao validar o formulário"
        },
        "features": {
          "activateNumber": "Ativar número",
          "address": "Endereço de {type}",
          "addressHelp": "A compra de números para alguns países exige o endereço. Entre em contato com o suporte para saber como incluir o endereço se precisar de ajuda.",
          "heading": "Propriedades numéricas",
          "leaveBlank": "Deixe em branco para nenhuma mensagem",
          "recordingDescription": "Ative a gravação de chamadas e reproduza uma mensagem curta para o chamador.",
          "recordingHelp": "Algumas jurisdições exigem que ambas as partes consintam com qualquer conversa gravada. Para auxiliar no cumprimento dessas leis, você pode habilitar uma mensagem de saudação para informar a pessoa que está ligando que a ligação poderá ser gravada.",
          "whisperDescription": "Uma breve mensagem que é reproduzida antes da ligação. O chamador não ouve essa mensagem."
        },
        "tracking": {
          "heading": "Opções de rastreamento",
          "nextCreatePool": "Próximo: criar pool",
          "percentComplete": "34% Concluído",
          "searchLower": "busca"
        },
        "whatToTrack": {
          "heading": "O que você deseja rastrear em seu site?",
          "trackCampaign": "Acompanhar uma campanha de marketing",
          "trackCampaignDescription": "Crie um número de telefone que rastreie todos os chamadores a uma única campanha de marketing.",
          "trackVisitor": "Rastrear a atividade dos visitantes",
          "trackVisitorDescription": "Crie vários números que correlacionem ligações com visitantes do site, palavras-chave PPC e mais."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "clique aqui para atualizar.",
      "issuesLoadingApp": "Se você estiver enfrentando problemas para carregar o app",
      "loadingFreshData": "Carregando dados novos...",
      "loadingNewSubAccountData": "Carregando dados da nova subconta..."
    },
    "login": {
      "bySigningInYouAgree": "Ao fazer login, você concorda com nossos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termos e condições</a>",
      "newPasswordSent": "Uma nova senha será enviada para o seu e-mail."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Por:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Emblema de parceiro"
        },
        "checkout": {
          "cardInformation": "Detalhes do cartão",
          "cardNumberInvalid": "O número do seu cartão é inválido.",
          "commitment": "compromisso",
          "consentOneTime": "Ao confirmar, você permite que a LeadConnector cobre este pagamento no seu cartão.",
          "consentSubscription": "Ao confirmar sua assinatura, você permite que a LeadConnector cobre seu cartão para este pagamento e os pagamentos futuros destas assinaturas.",
          "defaultIntervalCount": "1",
          "endingIn": "terminando em",
          "errorImageAlt": "Ilustração de erro",
          "intervalSuffix": "(s)",
          "month": "mês",
          "pay": "Pagar",
          "payWithCard": "pagar com cartão",
          "paymentProcessing": "O pagamento está sendo processado. Não recarregue nem pressione o botão Voltar",
          "proceedWithExistingCard": "Continuar com o cartão atual",
          "proceedWithNewCard": "Continuar com um novo cartão",
          "prorationDetails": "Você será cobrado por {days} dias agora pelo período até {billingEnd} e começará a ser cobrado o valor total de ${amount}/mês a partir de {billingDate}.",
          "prorationMessage": "As cobranças iniciais são proporcionais e a cobrança regular começará a partir de {billingDate}",
          "purchase": "comprar",
          "subscribe": "Inscrever-se",
          "subscribeTo": "Inscrever-se para",
          "updateCardDetails": "Atualize os detalhes do cartão",
          "zip": "cep"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Etapa {currentStep} de 8",
          "successDescription": "Sua marca e campanha A2P foram enviadas.",
          "successMessage": "Observação: você receberá uma mensagem OTP no número de celular informado para verificação pela TCR. Responda \"Sim\" dentro de 24 horas após receber o SMS.",
          "successWaitDays": "7 dias",
          "successWaitPrefix": "Pode levar até ",
          "successWaitSuffix": " para aprovação da sua marca e mais 4-5 semanas para aprovação da campanha."
        },
        "reminder": {
          "noReplyYet": "Ainda sem resposta",
          "patientConfirmed": "Paciente confirmado"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key obrigatória"
        },
        "update": {
          "brandNameHelper": "Use o nome legal da organização que está enviando as mensagens.",
          "businessVerticals": "Segmentos de negócios*",
          "resendOTP": "Reenviar OTP",
          "retryOTPTitle": "Reenviar verificação de OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Adicionar e-mail personalizado"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Adicionar provedor",
        "clickHereForInfo": "Clique aqui para obter mais informações.",
        "clickHereToFindOut": "Clique aqui para saber mais sobre eles.",
        "createProviderError": "Algo deu errado ao criar o provedor!",
        "gmailLimitations": "O Gmail tem algumas limitações.",
        "needHelp": "Precisa de ajuda para encontrar o servidor SMTP e o número da porta?",
        "port25NotSupported": "A porta 25 não é suportada! Por favor, utilize a porta 2525",
        "providerExists": "Já existe um provedor com este e-mail/nome de usuário.",
        "providerName": "Nome do provedor",
        "selectProvider": "Selecionar provedor",
        "smtpPortNumber": "Número da porta SMTP",
        "smtpProvider": "Provedor SMTP",
        "smtpServer": "Servidor SMTP",
        "username": "Nome de usuário",
        "usernameOrEmailRequired": "O nome de usuário ou o e-mail é obrigatório.",
        "verifySmtpAccount": "Verifique a conta SMTP"
      },
      "addTagModal": {
        "addTag": "Adicionar tag",
        "editTag": "Editar tag",
        "tagAlreadyExists": "A tag {tag} já existe"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Este relatório do FirstPromoter só pode ser acessado pelo <strong>proprietário e pelos administradores da agência</strong>. Se precisar de ajuda, entre em contato com o <strong>Proprietário da agência ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Painel FirstPromoter",
        "noPartnersFound": "Não foi possível encontrar um parceiro que corresponda aos seus filtros. Clique <a href='javascript:void(0);'>aqui</a> para se candidatar como parceiro.",
        "paymentDetailsAccessMessage": "Esta seção de detalhes de pagamento só pode ser acessada e editada pelo <strong>Proprietário da agência</strong>. Se precisar de ajuda, entre em contato com o <strong>Proprietário da agência ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Detalhes do compromisso"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Carregar instantâneo:",
        "loadSnapshotWarning": "Deseja carregar o instantâneo associado a este plano? <br /> <strong class='text-danger'>Os dados existentes podem ser perdidos</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Alterar senha",
          "confirmPassword": "Confirme a nova senha",
          "expired": "Seu link de redefinição de senha expirou.",
          "regenerateLink": "Gerar link novamente",
          "success": "Senha alterada com sucesso",
          "title": "Definir nova senha",
          "passwordMismatch": "As senhas não coincidem"
        },
        "forgotPassword": {
          "contactAgency": "entre em contato com a sua agência.",
          "contactSupport": "ligue para o suporte da HighLevel 24/7",
          "supportMessage": "Se não tiver acesso a essa caixa de e-mail,",
          "successMessage": "Um link de redefinição de senha foi enviado para o seu endereço de e-mail.",
          "rateLimitError": "Excesso de solicitações de redefinição de senha. Tente novamente mais tarde."
        },
        "login": {
          "inactivityMsg": "percebemos que você está inativo há algum tempo e, por isso, encerramos sua sessão para garantir sua segurança.",
          "loginButton": "Login",
          "resetPasswordMsg": "Um link de redefinição de senha será enviado para o seu e-mail.",
          "signInWithGoogle": "Fazer login com o Google",
          "contactHighLevelSupport": " ligue para o suporte da HighLevel 24/7"
        },
        "logout": {
          "loggingOut": "Saindo..."
        },
        "otp": {
          "enterBackupCode": "Insira seu código de backup",
          "resend": "Reenviar",
          "resendIn": "Reenviar em",
          "sendToPhone": "Enviar código para o telefone",
          "sending": "Enviando",
          "useAuthenticator": "Usar app de autenticação",
          "useBackupCode": "Usar código de backup",
          "verifyButton": "Verificar com o código de backup"
        },
        "sso": {
          "agreeTerms": "Ao fazer login, você concorda com nossos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termos e condições</a>",
          "and": "e",
          "loginDifferentMethod": "Fazer login usando um método diferente",
          "loginSuccessRedirecting": "Login bem-sucedido, redirecionando...",
          "processing": "Processando sua solicitação...",
          "redirecting": "Redirecionando...",
          "redirectingToDashboard": "Redirecionando para o painel...",
          "signedIn": "Conectado",
          "signingIn": "Entrando...",
          "testFailedRedirecting": "Falha no teste, redirecionando...",
          "testSuccessRedirecting": "Teste bem-sucedido, redirecionando..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Endereço da empresa: {address}",
        "businessDetailsText": "Os seguintes detalhes comerciais serão enviados ao Google Local Services Ads para integração com o Reserva do Google. Verifique e confirme ou clique em {link} para atualizar seu perfil comercial.",
        "businessInfoRequired": "As informações comerciais listadas acima são necessárias para integração, {link} para atualizar os detalhes comerciais ausentes ou incorretos.",
        "businessName": "Nome da empresa: {name}",
        "businessNiche": "Nicho de negócios: {niche}",
        "city": "Cidade: {city}",
        "confirmDetails": "Confirmo que as informações acima mencionadas estão corretas",
        "country": "País: {country}",
        "mustConfirmDetails": "Você deve confirmar as informações acima mencionadas.",
        "phoneNumber": "Número de telefone: {phone}",
        "state": "Estado: {state}",
        "zipCode": "CEP: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Adicionar Horas",
        "applyAll": "Aplicar tudo"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Atenda à ligação e insira este código de verificação:",
          "leadConnectorCalling": "O Lead Connector está ligando...",
          "title": "Adicionar um ID do chamador por voz",
          "waitingForVerification": "Aguardando verificação..."
        },
        "callerIdVerificationStatus": {
          "failed": "A verificação do ID do chamador falhou. Tente novamente.",
          "success": "Você verificou <strong>{contact}</strong> com sucesso."
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Adicionar número(s) existente(s)",
          "areaCode": "Código de área:",
          "checkAvailability": "Conferir disponibilidade",
          "checkingAvailability": "Verificando disponibilidade do número.",
          "chooseAreaCode": "Selecionar um código de área",
          "choosePhoneNumbers": "Selecionar número(s) de telefone",
          "goBack": "Volte",
          "localNumbers": "{type} local(is)",
          "nextNumberFeatures": "Próximo: Recursos de número",
          "noExistingNumbers": "Não há números existentes para adicionar",
          "noNumbersAvailable": "Não há números disponíveis",
          "notEnoughNumbers": "Não há números suficientes disponíveis",
          "numbersAvailable": "Números disponíveis",
          "numbersDifferentArea": "Números em outro código de área",
          "numbersLocalTo": "Números locais para <strong>{number}</strong>",
          "problemChecking": "Problema ao verificar a disponibilidade do número. Por favor, verifique sua conexão de rede ou entre em contato com o suporte.",
          "somethingWentWrong": "Algo deu errado. Verifique suas credenciais da conta Twilio e contate o suporte caso o problema continue.",
          "tollFreeNumbers": "Números gratuitos (sobretaxa de US$ 2,00 por número por mês)",
          "percentageComplete": "67% concluído"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Entendo as consequência; exclua o conjunto",
          "confirmText": "Digite <b>{name}</b> para confirmar",
          "title": "Exclusão NumberPool - ** ** <strong>{name}</strong>",
          "warning": "Esta ação não pode ser desfeita. Isso excluirá permanentemente o(s) número(s) da sua conta Twilio, junto com o conjunto de números (Number Pool) do nosso banco de dados. Se você estiver excluindo o conjunto de números devido a algum problema, entre em contato com nossa equipe de suporte."
        },
        "editNumberFormatModal": {
          "description": "Você pode atualizar a formatação dos números alternados e dos números do conjunto conforme sua necessidade. Certifique-se de que os números de troca apareçam no site da mesma forma que foram formatados.",
          "title": "Atualizar formatação do número - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Adicionar/Editar ID do grupo",
          "callConnectTooltip": "Este recurso exige que o destinatário pressione uma tecla para conectar a chamada, o que melhora a precisão dos relatórios de chamadas.",
          "createGroupIdDescription": "Criar/adicionar um ID de grupo exclusivo para usar vários pools de números com um único snippet JavaScript.",
          "enableCallConnect": "Ativar recurso de conexão da chamada",
          "groupId": "ID do grupo",
          "outboundCallTimeout": "Tempo limite para chamadas de saída",
          "passCallerID": "Usar o número chamado como ID do chamador",
          "passCallerIDTooltip": "Por padrão, o sistema passa o número do chamador, mas se você quiser que o ID do chamador seja o número discado pelo chamador, ative este recurso",
          "selectCallerID": "Selecionar ID do chamador",
          "timeDuration": "Duração em segundos",
          "titleNumber": "Número - <strong>{number}</strong>",
          "updateWhisperWarning": "Atualize a mensagem de aviso, pois este recurso exige que o destinatário pressione uma tecla para conectar a chamada.",
          "useVerifiedNumber": "Use seu número verificado como ID do chamador para chamadas de saída",
          "useVerifiedNumberTooltip": "Aplicável apenas para números de telefone verificados. Você pode verificar um número em Configurações > Números de Telefone > Adicionar ID do chamador verificado"
        },
        "emailOTPModal": {
          "confirmCode": "Confirmar código",
          "resendCode": "Se você não recebeu o código, clique aqui para reenviar",
          "unexpectedIssue": "Ocorreu um erro inesperado"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informações do Campo Personalizado",
          "customFieldTooltip": "Tooltip de Campo Personalizado: {options}",
          "field": "Campo {companyName}",
          "trackingParameters": "Parâmetros de rastreamento",
          "zipCode": "Código postal"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Adicionar números alternados",
          "addingSnippets": "Adicionando trechos de código Javascript",
          "groupSnippet": "Trecho do grupo \"{id}\"",
          "normalSnippet": "Trecho normal",
          "noswapDescription": "Se não quiser que troquemos o número em um determinado local, adicione uma classe \"noswap\".",
          "notReplacing": "Sem substituição em determinado local",
          "requiredSteps": "Etapas obrigatórias",
          "snippetsDescription": "Copie o trecho de código abaixo e adicione-o logo acima da tag de fechamento do corpo de cada página em que você quer substituir os números.",
          "swappingDescription": "Use os números abaixo para habilitar a troca de números de telefone. Selecione um formato local, internacional ou até mesmo ambos."
        },
        "newPhoneNumberModal": {
          "areaCode": "Código de área",
          "availableNumbers": "Números disponíveis",
          "bundle": "Pacote",
          "chooseAddress": "Selecionar endereço...",
          "chooseBundle": "Selecionar pacote...",
          "createRegulatory": "Gere um pacote/endereço regulatório aqui.",
          "monthlyFee": "Cobrança mensal",
          "noNumbersFound": "Nenhum número encontrado, tente outro código de área.",
          "selectAddress": "Selecione “Endereço” para comprar um número.",
          "selectBundle": "Selecione “Pacote” para comprar um número.",
          "title": "Adicionar número de telefone",
          "upgradeAccount": "Atualize sua conta Twilio. Somente contas atualizadas podem comprar números de telefone e fazer chamadas",
          "cardAuthenticationFailed": "Falha na autenticação do cartão!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Você precisa aceitar os termos e a política de privacidade.",
          "clickingProceed": "Ao clicar em Continuar, a página de vinculação do LSA será aberta em uma nova aba",
          "configureCalendar": "Configure ao menos um calendário para continuar com a Integração do Reserve com o Google",
          "configureCalendarBtn": "Configurar calendário",
          "linkOneAccount": "Certifique-se de vincular apenas uma conta. Entre em contato com o Suporte se não conseguir visualizar a página mostrada na captura acima.",
          "readInstructions": "Eu li as instruções mencionadas anteriormente"
        },
        "updateTrackingModal": {
          "title": "Atualizar opção de rastreamento"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Visível apenas para administradores da agência)",
          "updatedEvery24Hours": "(atualizado a cada 24 horas)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendário não selecionado para sincronização",
          "check": "Verificar {email}",
          "checkForConflicts": "Verificar conflitos",
          "checkForConflictsTooltip": "Defina o(s) calendário(s) a serem verificados para evitar agendamentos duplicados.",
          "contactCreationAllowed": "Criação de contato permitida",
          "googleCalendar": "Logotipo do Google Agenda",
          "noGoogleAccounts": "Nenhuma conta Google/Outlook foi adicionada ainda nas configurações de Integrações",
          "noGoogleAccountsTeamMember": "Nenhuma conta Google/Outlook adicionada para este membro da equipe nesta localização. Peça ao membro da equipe para fazer login na própria conta e adicionar a conexão com o Google nas configurações de Integrações.",
          "outlookCalendar": "Calendário do Usuário (Outlook)",
          "primaryCalendarTooltip": "Defina o calendário ao qual você gostaria de adicionar novos eventos conforme forem programados.",
          "runTriggerAllowed": "Permissão para executar gatilho"
        },
        "warningModal": {
          "contactAgency": "Entre em contato com sua agência para alterar as configurações de e-mail.",
          "title": "Aviso"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Suporte por chat mais rápido, 24 horas por dia",
            "faster247Ticket": "Suporte de tickets e tempos de resposta mais rápidos, 24 horas por dia"
          },
          "highlight": {
            "description": "Entendemos, você precisa acelerar. Quando você tem uma dúvida ou preocupação, quer que ela seja respondida o mais rápido possível! Com o upgrade de suporte prioritário, você pode pular a fila e acelerar automaticamente suas solicitações para a frente da fila.",
            "heading": "Preparado para o tratamento VIP?"
          },
          "name": "Suporte prioritário",
          "success": {
            "description": "O suporte prioritário foi ativado em sua conta. Chega de esperar na fila.",
            "heading": "Agora você é um cliente prioritário!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Clonar {entityName}",
        "cloning": "Clonando...",
        "cloningLimit": "A clonagem é limitada a 3 locais por vez",
        "error": "Erro ao clonar o funil!",
        "locationsLabel": "Selecionar localizações",
        "nameLabel": "Nome para o clonado {entityName}",
        "namePlaceholder": "Insira o nome para o {entityName}clonado",
        "selectUpTo": "Selecionar até {maxSelectableLocations} endereços",
        "title": "Clonar {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Com o CNAM, o nome da sua empresa aparece no identificador de chamadas, tornando suas ligações imediatamente reconhecíveis e aumentando a confiança. Informe seus clientes que é você quem está ligando todas as vezes.",
          "title": "Faça com que suas ligações se destaquem!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirmar e registrar",
          "description": "Exiba o nome da sua empresa para quem recebe a ligação e aumente a confiança e as taxas de atendimento.",
          "title": "Aumente a confiança nas suas ligações com o CNAM",
          "warning": "A exibição do nome da empresa não é garantida, especialmente em dispositivos móveis."
        },
        "submitted": {
          "checkStatus": "Verifique o status do CNAM",
          "description": "O nome da sua empresa deve começar a aparecer para os contatos compatíveis em cerca de 3 a 5 dias.",
          "subtitle": "Sua solicitação de CNAM foi enviada.",
          "title": "Parabéns!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirmar exclusão",
        "confirmation": "Confirmação"
      },
      "createAddress": {
        "successTitle": "Endereço enviado com sucesso",
        "underReview": "O endereço enviado está em avaliação"
      },
      "createEndUser": {
        "dateFormat": "O formato da data deve ser AAAA-MM-DD.",
        "phoneExample": " Exemplo: +14155552671",
        "title": "Dados da empresa:"
      },
      "customValueModal": {
        "changingNameWarning": "A alteração do nome não afetará a chave do campo.",
        "editCustomValue": "Editar valor personalizado",
        "fieldKeyCreatedWarning": "A chave do campo será criada de acordo com o nome e não poderá ser alterada posteriormente.",
        "nameRequired": "O campo Nome é obrigatório",
        "nameValidation": "O nome deve ser alfanumérico e conter pelo menos um caractere",
        "valueRequired": "O campo Valor é obrigatório"
      },
      "details": {
        "addressName": "Nome do endereço",
        "addressTitle": "Dados do endereço",
        "bundleName": "Nome do pacote",
        "bundleTitle": "Informações do pacote regulatório",
        "countryFlag": "Bandeira do(a) {country}",
        "id": "ID",
        "organisation": "Organização",
        "rejectionReason": "Motivo da rejeição",
        "status": {
          "approved": "Aprovado(a)",
          "notValidated": "Não verificado(a)",
          "rejected": "Rejeitado",
          "validated": "Verificado(a)"
        },
        "typeOfNumber": "Tipo de número"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Selecione o escritório",
        "whichOffice": "Qual escritório você deseja vincular a esta conta?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Permitir a criação de contato:",
        "allowTrigger": "Permitir gatilho:",
        "doNotSync": "Não sincronize novos eventos com o calendário principal",
        "primaryCalendarTooltip": "Você só pode selecionar um calendário com acesso de gravação que não tenha sido selecionado para verificação de conflitos.",
        "selectDefaultCalendar": "Selecionar calendário padrão",
        "whichCalendar": "Qual calendário devemos usar para sincronizar (ler e gravar) eventos?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Verifique se há conflitos nestes",
        "howToCheckConflicts": "Como devemos verificar se há conflitos?"
      },
      "ejectModal": {
        "agencyClosing": "A conta da agência Elite Marketing com a Highlevel está sendo encerrada. Para manter sua conta, entre em contato com {userName} para migrar sua conta diretamente para a Highlevel.",
        "cancelWarning": "Informamos que sua conta será oficialmente cancelada em 30 de junho de 2025 e não poderemos recuperar seus dados após essa data caso a transferência não seja concluída.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Se tiver alguma dúvida, entre em contato conosco em",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Para ajudá-lo durante esta transição gratuita, aplicamos {months} de acesso gratuito à sua nova assinatura.",
        "intro": "Devido a violações recorrentes dos Termos de Serviço da HighLevel, a Elite Marketing Authority (EMA) foi permanentemente removida da plataforma HighLevel.",
        "platformCommitment": "Como a plataforma que impulsiona os serviços da EMA, a HighLevel está comprometida em manter um ambiente seguro, em conformidade com as normas e confiável para todos os usuários. Para evitar interrupções na sua conta, estamos aqui para ajudá-lo a fazer uma transição tranquila, seja para outro provedor sem marca ou diretamente para a HighLevel.",
        "questions": "Se tiver alguma dúvida,",
        "retainAccess": "Para manter o acesso aos seus dados e ferramentas existentes, clique no botão abaixo e siga as instruções para iniciar a transferência.",
        "speakWithTeam": "para falar com nossa equipe.",
        "startTransfer": "Comece sua transferência gratuita",
        "title": "Atenção, Clientes da Elite Marketing",
        "viewFaqs": "Veja as perguntas frequentes aqui:",
        "whiteLabel": "Se preferir acessar a HighLevel por meio de outro provedor sem marca, teremos prazer em atender a essa alteração por meio do nosso sistema de tickets de suporte, após a transferência da sua conta diretamente para a HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Criado(a) em",
        "updatedOn": "Atualizado(a) em"
      },
      "error": {
        "title": "Falha no envio do pacote regulatório"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Mais de uma página possui este URL, altere o caminho desta página para que funcione.",
          "urlNotFound": "Ops, não conseguimos encontrar a URL que você estava procurando"
        },
        "productRebilling": {
          "requestFailed": "Falha na solicitação"
        },
        "template": {
          "categoryNotFound": "Desculpe, não conseguimos encontrar a categoria que você estava procurando.",
          "internalError": "Ocorreu um erro interno!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "A subconta que você está tentando transferir está habilitada para HIPAA e não pode ser transferida para uma agência não HIPAA."
          },
          "limitExceeded": {
            "message": "A agência para a qual você está tentando transferir a subconta atingiu o limite de uso e não pode obter mais subcontas.  Peça a eles para excluir uma subconta que não está em uso ou fazer upgrade para um plano de agência superior para obter esta subconta."
          },
          "pendingRequest": {
            "heading": "Uma solicitação de transferência para essa subconta já está pendente.",
            "message": "Cancele a solicitação de transferência já existente para esta subconta antes de prosseguir para criar uma nova."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Não consegue encontrar a página que está procurando? Acesse as configurações do seu Facebook e verifique se todas as páginas estão selecionadas.",
        "instagramAvailable": "O Instagram está disponível para esta conta!",
        "noPages": "Você não tem nenhuma página sob esta conta.",
        "title": "Selecione a página do Facebook que você deseja vincular a esta subconta"
      },
      "googleLocationSelect": {
        "closeButton": "Fechar!",
        "enableCallTracking": "Habilitar rastreamento de chamadas em GBP",
        "noBusinesses": "Você não tem nenhuma empresa conectada sob esta conta."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Mais eficiente",
          "faster": "Mais rápida",
          "itsText": "É",
          "smoother": "Mais suave",
          "title": "Uma nova experiência de importação chegou!",
          "warningMessage": "Habilitar a nova experiência de Importação ativa Labs para esta subconta e o Recurso Beta."
        },
        "validateEmails": "Validar e-mails?"
      },
      "initBundle": {
        "numberType": "Tipo de números que você pretende usar",
        "numberTypes": {
          "local": "Números locais",
          "mobile": "Celular",
          "tollfree": "Ligação gratuita"
        },
        "selectCountry": "Selecione seu país",
        "selectUserType": "Selecione o tipo de usuário",
        "userTypes": {
          "business": "Empresa",
          "individual": "Individual"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Último crédito adicionado em:",
        "currentBalance": "Saldo atual",
        "debitBalance": "- Saldo devedor",
        "depositComplimentaryCreditsOf": "Deposite créditos gratuitos de",
        "manageBalance": "Gerenciar saldo",
        "mustBeValidInteger": "Deve ser um número inteiro válido",
        "nextDate": "Próxima data:",
        "perMonth": "por mês",
        "remainingWalletBalance": "Saldo restante da carteira desta subconta",
        "rolloverCredits": "Transferir créditos para o próximo mês",
        "toManageMonthlyCredits": "Para gerenciar créditos mensais,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Adicionar nova assinatura"
      },
      "manualActions": {
        "confirmDelete": "Tem certeza de que deseja excluir esta ação?",
        "confirmDeleteAll": "Tem certeza de que deseja excluir todas as ações manuais nesta página?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Gere uma senha forte",
          "sendEmailNotification": "Além disso, envie uma notificação por e-mail."
        }
      },
      "modal": {
        "description": "Você precisa concluir algumas etapas simples de conformidade para usar os sistemas de telefonia",
        "submit": "Enviar",
        "title": "Serviço de telefonia do Lead Connector"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visitantes da página inicial",
          "launched": "Lançado(a)",
          "newNotification": "Nova notificação",
          "startMessage": "Comece a impulsionar suas conversões criando sua primeira notificação",
          "types": {
            "combination": "Combinação"
          }
        },
        "page": {
          "createTitle": "Criar nova notificação",
          "steps": {
            "display": "Exibir",
            "track": "Rastrear"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Informações adicionais",
          "calendarEvent": "Evento de calendário",
          "hideAssignedTo": "Ocultar atribuído a",
          "hideTags": "Ocultar tags"
        },
        "filters": {
          "dateAddedAsc": "↑ Data de adição (ASC)",
          "dateAddedDesc": "↓ Data de adição (DESC)",
          "orderBy": "OrderBy"
        },
        "getStarted": "comece já!",
        "noPipelines": "Ops! Parece que não há pipelines. Crie um novo pipeline para"
      },
      "pages": {
        "pageMoved": {
          "title": "Listagens on-line foram movidas"
        }
      },
      "recentlyVisited": {
        "prices": "{count} preços"
      },
      "reminders": {
        "appointmentReminders": "Lembretes de compromissos",
        "apptTime": "Horário do agendamento",
        "defaultDateRange": "Domingo, 1º de abr. de 2018 - Segunda-feira, 30 de abr. de 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "Em espera",
        "rebillingOnHoldWarning": "Esta conta já tem configurações de refaturamento em espera. O plano SaaS só pode ser anexado depois que o cliente adicionar um método de pagamento.",
        "subscriptionId": "ID da assinatura:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Confirmar e prosseguir",
        "documents": {
          "acceptedDocuments": "Documentos aceitos",
          "acceptedDocumentsLabel": "Documentos aceitos:",
          "additionalInfo": "Informações adicionais:",
          "createAddressLink": "Criar endereço.",
          "createAddressPrompt": "Gere um endereço primeiro e então continue com a criação do pacote.",
          "documentInfo": "PNG, JPG, PDF de até 5 MB",
          "documentType": "Tipo de documento",
          "option": "Opção {number}",
          "selectAddress": "Selecionar endereço:",
          "selectDocumentType": "Selecionar tipo de documento:",
          "selectFile": "Selecionar arquivo",
          "title": "Documentos necessários:",
          "updateDocuments": "Atualizar Arquivos"
        },
        "everythingIn": "Tudo em <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "incluir o cartão de crédito aqui",
          "message": "Peça ao seu cliente para",
          "title": "A localização precisa incluir um método de pagamento primeiro."
        },
        "noSaasPlan": {
          "linkText": "crie seus planos SaaS aqui.",
          "message": "Por favor,",
          "title": "Você não tem nenhum plano SaaS configurado."
        },
        "saasModeSetupPendingWarning": "O plano SaaS será ativado depois que o cliente adicionar um método de pagamento. Até lá, o acesso à conta será restrito.",
        "skipForNow": "Ignorar por agora",
        "skipPlan": "Ignorar plano",
        "success": {
          "title": "Pacote regulatório enviado com sucesso",
          "underReview": "Pacote submetido em avaliação"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Esta opção adicionará um novo endereço à sua conta",
          "label": "Pacote de endereços"
        },
        "regulatoryBundle": {
          "description": "Esta opção ajudará você a criar um novo pacote regulatório",
          "label": "Pacote regulatório"
        },
        "title": "Selecione o pacote que deseja incluir"
      },
      "settings": {
        "billing": "Faturamento",
        "calendars": "Calendários",
        "customEmails": "E-mails personalizados",
        "domains": "Domínios",
        "domainsAndUrlRedirects": "Domínios e Redirecionamentos de URL",
        "facebookFormFieldsMapping": "Mapeamento de campos de formulário do Facebook",
        "groups": "Grupos",
        "integrations": "Integrações",
        "labs": "Laboratórios",
        "media": "Mídia",
        "noShowSMS": "SMS de não comparecimento",
        "pipelines": "Pipelines",
        "profile": "Perfil",
        "smtpAndMailGunService": "Serviço SMTP e MailGun",
        "templates": "Modelos",
        "urlRedirects": "Redirecionamentos de URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Suas chamadas agora estão verificadas!"
        },
        "modal": {
          "andThe": " e o ",
          "certification": "Confirmo que o Perfil comercial associado é o originador das chamadas telefônicas e certifico que participarei dos esforços de rastreamento, incluindo aqueles iniciados pelo",
          "failedTitle": "Falha no envio",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 às 19:47:14",
          "linkInfo": {
            "description": "Todos os números atuais disponíveis e os números adquiridos no futuro serão automaticamente registrados no SHAKEN/STIR.",
            "title": "Todos os números serão vinculados automaticamente."
          },
          "stiPa": "Administrador de Política de Identidade Telefônica Segura (STI-PA)",
          "subtitle": "Insira os detalhes e a descrição",
          "successMessage": "Sua solicitação de registro SHAKEN/STIR foi enviada. A aprovação pode levar de <b>3 a 4</b> dias. O status será atualizado em breve.",
          "successTitle": "Chamadas verificadas SHAKEN/STIR ativadas.",
          "title": "Ativar chamadas verificadas SHAKEN/STIR",
          "tracebackGroup": "Grupo de Rastreamento de Telecom dos EUA"
        },
        "withCnam": {
          "cnamPromo": "Deseja dar mais um passo? Mostre o nome da sua empresa nas ligações usando CNAM.",
          "registerCnam": "Registre-se no CNAM",
          "title": "Aumente a confiança do cliente e melhore as taxas de atendimento das chamadas."
        },
        "successMessage": "Sua solicitação de registro SHAKEN/STIR foi enviada. Pode levar até <b>3 a 4 dias</b> para ser aprovado. O status será atualizado em breve."
      },
      "shopify": {
        "selectLocation": "Selecione a localização que deseja vincular a esta loja Shopify"
      },
      "signup": {
        "accountType": "Tipo de conta",
        "agencyProAccount": "Conta Agência Pro (US$ 497/mês)",
        "agencyTestAccount": "Conta de Teste da Agência",
        "freeTrialMessage": "Obtenha uma avaliação <strong>gratuita</strong> de 14 dias ao se inscrever agora mesmo.",
        "freelancerAccount": "Conta Freelancer (US$ 297/mês)",
        "getStartedForFree": "Comece gratuitamente!",
        "pickPassword": "Selecionar uma senha",
        "signUp": "Cadastrar-se",
        "starterAccount": "Conta iniciante (US$ 97/mês)",
        "termsAndConditions": "Ao se cadastrar, você concorda com nossos <a href='https://www.gohighlevel.com/privacy' target='_blank'>Termos e Condições</a>",
        "yourCompanyName": "Nome da sua empresa",
        "yourFullName": "Seu nome completo"
      },
      "standardPlan": {
        "description": "Temos os seguintes planos para registros de marca padrão.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN obrigatório para o registro",
            "moreThan1Phone": "Mais de 1 número de telefone permitido"
          },
          "highVolume": {
            "heading": "Padrão de Alto volume",
            "point3": "Até 600.000 segmentos por dia",
            "infoText": "Será cobrada uma taxa única de US$ 20,95 pelo registro da marca e da campanha. Uma cobrança adicional de campanha de até US$ 2,25 por mês será aplicada de acordo com as regras da TCR.",
            "point2": "Enviar até 3000 segmentos por dia",
            "point1": "EIN obrigatório para o registro"
          },
          "lowVolume": {
            "heading": "Padrão de Baixo volume",
            "recommended": "Recomendado",
            "point3": "Até 6000 segmentos por dia",
            "infoText": "Será cobrada uma taxa única de US$ 20,95 pelo registro da marca e da campanha. Uma taxa adicional de campanha de até US$ 2,25 por mês será aplicada de acordo com as regras da TCR.",
            "point2": "Enviar até 3000 segmentos por dia",
            "point1": "EIN obrigatório para o registro"
          }
        },
        "title": "Selecione o seu Plano de marca padrão"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Detalhes do agendamento",
          "form": "Formulário",
          "quiz": "Questionário",
          "submissionDetail": "Detalhes do envio",
          "survey": "Pesquisa"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Somente administradores/usuários da agência têm acesso a essa subconta. Atualmente, você e outros administradores/usuários da conta não têm acesso a essa subconta.",
          "heading": "Esta subconta foi pausada."
        },
        "temporarily": {
          "description": "Todos os seus dados estão seguros e todos os gatilhos/campanhas etc., continuarão a funcionar após a ativação.",
          "heading": " Sua conta foi temporariamente suspensa."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Aplicar somente a contatos não atribuídos",
          "splitTraffic": "Tráfego dividido",
          "trafficWeightage": "Ponderação de tráfego",
          "userRequired": "O usuário precisa ser selecionado",
          "weightage": "Ponderação"
        },
        "birthdayFilters": {
          "afterDays": "Depois de X dias",
          "beforeDays": "Antes X dias",
          "dayIs": "O dia é",
          "daysInNumber": "Número de dias",
          "hasTag": "Tem palavra-chave",
          "monthIs": "O mês é",
          "selectDay": "Selecionar dia",
          "selectMonth": "Selecionar mês"
        },
        "botConversation": {
          "enterTimeout": "Insira um tempo limite (em horas)",
          "selectEliza": "Selecionar Eliza",
          "selectThankyouTemplate": "Selecione o modelo de agradecimento",
          "selectWelcomeTemplate": "Selecione o modelo de boas-vindas"
        },
        "contactField": {
          "addField": "Adicionar setor",
          "defineFilters": "Definir filtros"
        },
        "copyModal": {
          "title": "Copiar o gatilho"
        },
        "detailModal": {
          "actionsPerform": "Que ações devemos executar?",
          "campaignNameRequired": "O campo de nome da campanha é obrigatório",
          "campaignsDeprecation": "As campanhas não são mais mantidas. Para garantir uma transição tranquila, converta suas campanhas existentes em fluxos de trabalho.",
          "folderName": "Nome da pasta",
          "mustSelectFolder": "É necessário selecionar uma pasta.",
          "newFolderName": "Novo nome da pasta",
          "selectFolder": "Selecionar pasta",
          "triggerNameRequired": "O campo Nome do gatilho é obrigatório",
          "triggersDeprecation": "Os gatilhos não são mais mantidos. Para garantir uma transição tranquila, converta seus Gatilhos existentes em Fluxos de trabalho.",
          "triggerName": "Nome do gatilho"
        },
        "dnd": {
          "disableAll": "Desabilitar DND para todos os canais",
          "disableSpecific": "Desabilitar DND para canais específicos",
          "enableAll": "Habilitar DND para todos os canais",
          "enableSpecific": "Habilitar DND para canais específicos",
          "selectAction": "Selecionar ação"
        },
        "email": {
          "sendTestEmail": "Enviar e-mail de teste",
          "smtpWarning": "Os provedores SMTP têm algumas limitações. Clique aqui para saber mais."
        },
        "facebook": {
          "avatarAlt": "Avatar do Facebook",
          "selectCustomAudience": "Selecionar público personalizado"
        },
        "googleAds": {
          "conversionName": "Nome da conversão",
          "conversionTooltip": "A origem da conversão deve ser Import From Clicks e a categoria deve ser Imported Lead ou Lead",
          "noConversions": "Nenhuma taxa de conversão encontrada",
          "selectConversion": "Selecionar conversão"
        },
        "googleAnalytics": {
          "eventAction": "Ação do evento",
          "eventActionRequired": "A ação do evento é obrigatória.",
          "eventCategory": "Categoria do evento",
          "eventCategoryRequired": "A categoria do evento é obrigatória.",
          "eventLabel": "Rótulo do evento",
          "eventValue": "Valor do Evento",
          "hitType": "Tipo de acerto",
          "hitTypeRequired": "O tipo de acerto é obrigatório.",
          "trackingId": "ID de rastreamento",
          "trackingIdRequired": "O ID de rastreamento é obrigatório."
        },
        "membershipOffer": {
          "selectOffer": "Selecionar oferta"
        },
        "notification": {
          "selectRedirectPage": "Selecionar página de redirecionamento",
          "selectUser": "Selecionar usuário",
          "selectUserType": "Selecionar tipo de usuário"
        },
        "sms": {
          "sendTestSMS": "Enviar SMS de teste"
        },
        "stripeCharge": {
          "customerId": "ID do cliente Stripe",
          "enterAmount": "Digite o valor",
          "selectCurrency": "Selecionar moeda"
        },
        "webhook": {
          "webhookUrl": "URL do Webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Data da atividade",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Agências no plano Pro faturam cerca de US$ 363 por mês ao repassar custos de telefonia para seus clientes",
          "title": "Quer refaturar isso para seus clientes?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Falha ao enviar seu perfil."
        },
        "success": {
          "message": "Sua marca e campanha A2P foram enviadas.<br/><br/><b>Observação:</b> Você <b>receberá uma mensagem OTP no número de celular informado para verificação</b> pela TCR. Por favor, <b>responda Sim dentro de 24 horas</b> após receber o SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Limite de contatos",
        "maxContactsAllowed": "Máximo de contatos permitidos na subconta",
        "maxUsersAllowed": "Número máximo de usuários permitidos na subconta",
        "unlimited": "Ilimitado",
        "usageLimits": "Limites de uso",
        "userLimit": "Limite de usuários",
        "userLimitHelpMessage": "Apenas usuários com nível de subconta contam para esse limite. Você ainda pode adicionar quantos usuários de agência desejar às subcontas"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Concordo em habilitar Listagens para este cliente sem venda adicional e reconheço que serei cobrado",
          "deployDirectly": "Implantar Listagens diretamente",
          "deployDirectlyDesc": "Use esta opção se você estiver oferecendo Listagens como parte da sua oferta ou se desejar faturar seu cliente externamente",
          "minimumCommitment": "com um período de compromisso mínimo de 1 mês.",
          "offerListings": "Listagens de ofertas",
          "resellListings": "Listagens para revenda",
          "subscribedInfo": "{withoutUpsell} Sem venda adicional, {withUpsell} com venda adicional e {withSaas} com pacote SaaS",
          "subscriptionCreated": "Assinatura criada com sucesso. Aguarde...",
          "subscriptionCreating": "A assinatura está sendo criada.<br/>Por favor, não recarregue nem pressione o botão Voltar",
          "unableToCreate": "Não foi possível criar a assinatura, entre em contato com o suporte",
          "unavailabilityForAgencyAdmin": "O Yext não está disponível neste país. Se você acredita que isso é um erro, solicite-o em nosso roadmap em",
          "yourResellOffer": "Sua oferta de revenda"
        }
      },
      "selectCountry": "Selecione seu país",
      "documents": {
        "additionalInfo": "Informações adicionais",
        "createAddressLink": "Gerar endereço.",
        "createAddressPrompt": "Crie um endereço primeiro e então prossiga com a criação do pacote.",
        "selectAddress": "Selecionar endereço:"
      }
    },
    "triggers": {
      "emptyTrigger": "Gatilho vazio"
    },
    "util": {
      "addFiles": "+ Adicionar arquivos",
      "fillValues": "Preencha os valores",
      "image": "imagem",
      "ok": "OK",
      "pleaseTypeOrCancel": "Digite {consentString} acima ou cancele esta ação.",
      "pressEnterToAddCustomOption": "Pressione Enter para adicionar uma opção personalizada",
      "required": "* obrigatório",
      "unsaved": "Não salvo"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Para habilitar o fluxo de trabalho para um local, acesse a guia Contas, clique no ícone de três pontos à direita de uma subconta e selecione <strong>Habilitar construtor de fluxo de trabalho</strong>. Este processo é temporário, pois os fluxos de trabalho entrarão em funcionamento em todas as subcontas na próxima semana."
      },
      "faq": "FAQ",
      "gotIt": "Entendi",
      "workflowIsLive": "O fluxo de trabalho já está ativo na sua conta!"
    },
    "action": {
      "stats": {
        "bounced": "Rejeitado(a)",
        "clicked": "Clicado(a)",
        "delivered": "Entregue",
        "opened": "Aberto(a)",
        "replied": "Respondido(a)",
        "unsubscribed": "Inscrição cancelada",
        "total": "Total",
        "failed": "Falhou"
      },
      "actions": {
        "edit": "Editar",
        "send": "Enviar",
        "remove": "Remover"
      },
      "timing": {
        "days": "Dias",
        "immediately": "Imediatamente",
        "before": "Antes",
        "after": "Depois",
        "minutes": "Minutos",
        "hours": "Horas"
      },
      "labels": {
        "template": "Modelo",
        "manual": "Manual"
      },
      "details": {
        "hideDetail": "Ocultar detalhes",
        "showDetail": "Exibir detalhes"
      },
      "queue": {
        "people": "pessoas",
        "person": "indivíduo",
        "queued": "em fila"
      },
      "tooltips": {
        "clickedHelp": "A precisão do rastreamento de cliques pode variar conforme o cliente de e-mail e as configurações do usuário.",
        "statsAccuracy": "A precisão das estatísticas pode variar conforme o cliente de e-mail e as configurações do usuário."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Tem certeza de que deseja apagar esta solicitação em massa?",
        "startImmediately": "Comece imediatamente"
      },
      "modal": {
        "contactTypes": {
          "all": "Todos",
          "leads": "Oportunidades",
          "customers": "Clientes"
        },
        "buttons": {
          "cancel": "Cancelar",
          "update": "Atualizar",
          "add": "Adicionar"
        },
        "labels": {
          "name": "Nome",
          "contactType": "Tipo de contato",
          "campaign": "Campanha",
          "scheduledDate": "Data programada",
          "tag": "Tag"
        },
        "placeholders": {
          "tags": "Tags",
          "selectCampaign": "Selecionar campanha",
          "pickType": "Selecione o tipo"
        },
        "sections": {
          "bulkRequest": "Solicitação em massa",
          "whoShouldRun": "Para quem ele deve executar?"
        },
        "titleAdd": "Adicionar solicitação em massa",
        "titleEdit": "Editar solicitação em massa",
        "validation": {
          "scheduledDateRequired": "A data programada é obrigatória"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Mostrar mais"
    },
    "list": {
      "confirmDeleteFolder": "Confirmar Exclusão da Pasta",
      "delete": "Excluir",
      "confirmDelete": "Tem certeza de que deseja apagar esta campanha?",
      "moveToFolder": "Mover para a pasta",
      "pleaseRename": "renomeie",
      "removeFromFolder": "Remover da pasta"
    },
    "copy": {
      "title": "Copiar campanha",
      "newCampaignName": "Novo nome da campanha",
      "locations": "Locais"
    }
  },
  "compliance": {
    "findOutMore": "Saiba mais",
    "gdprDescription": "Levamos muito a sério a proteção dos seus dados pessoais e a dos dados dos seus clientes. Tratamos todas as informações pessoais com total confidencialidade e em conformidade com as normas legais de proteção de dados e com esta declaração de privacidade.",
    "gdprTitle": "Conformidade com o GDPR",
    "hipaaDescription": "Ative os recursos de segurança para garantir que os dados da sua conta HighLevel estejam protegidos e atendam aos requisitos da HIPAA",
    "hipaaTitle": "Conformidade com a HIPAA"
  },
  "customValues": {
    "key": "Chave",
    "selectedItemsCountSingular": "{count} linha selecionada",
    "selectedItemsCountPlural": "{count} linhas selecionadas"
  },
  "facebookAdFields": {
    "checkIcon": "Formulário mapeado com sucesso",
    "errorMessage": "O token de acesso da página expirou ou não possui as permissões necessárias. Certifique-se de que você tem acesso administrativo às páginas."
  },
  "fbLeadSync": {
    "confirmTitle": "Confirmar sincronização de Leads do Facebook?",
    "impactMessage": "Por favor, entenda o impacto da sincronização de Leads do Facebook antes de prosseguir:",
    "observations": "1. A sincronização importará os Leads do Facebook e criará novos contatos para todos os leads gerados nos últimos {days} dias que ainda não estejam na sua lista de contatos. <br>2. Se você importou leads manualmente via CSV do Facebook Ads Manager, desative a opção &quot;Permitir contatos duplicados&quot; para evitar duplicações durante a sincronização. <br>3. Se você tiver fluxos de trabalho que sejam disparados na <b>criação de contato</b> ou <b>envio de formulário de Lead do Facebook</b>, eles serão disparados para cada novo contato criado. <br>4. Contatos existentes criados por meio de Leads do Facebook não serão afetados. <br>5. O horário de criação do contato registrado será o horário atual. <br>6. A sincronização pode levar até uma hora para ser concluída, dependendo da quantidade de leads que ainda precisam ser sincronizados. <br>",
    "proceedQuestion": "Deseja continuar com a sincronização de Leads do Facebook?"
  },
  "integrationAI": {
    "accountDisconnected": "Conta desconectada!",
    "appNotFound": "Configuração do aplicativo não encontrada. Usando dados alternativos (fallback).",
    "checkingConnection": "Verificando status da conexão...",
    "connecting": "Conectando...",
    "disconnectApp": "Desconectar aplicativo",
    "disconnecting": "Desconectando...",
    "loadingAppInfo": "Carregando informações do aplicativo...",
    "refreshConnection": "Atualizar conexão",
    "refreshing": "Atualizando...",
    "svgNotAvailable": "SVG não disponível"
  },
  "phoneSystem": {
    "additionalSettings": "Configurações adicionais",
    "messaging": "Mensagens",
    "messagingAnalytics": "Análise de mensagens",
    "regulatoryBundles": "Pacotes Regulatórios",
    "title": "Sistema de telefonia",
    "trustCenter": "Central de confiança",
    "voice": "Voz"
  },
  "demo": {
    "draggable": {
      "title": "Teste de componente móvel",
      "usingVue3": "Usando o recurso Draggable compatível com Vue 3",
      "description": "Este módulo agora utiliza o componente móvel revisado e compatível com Vue 3.",
      "buttons": {
        "resetAllLists": "Redefinir todas as listas",
        "clearLog": "Limpar registro",
        "stopLoading": "Parar carregamento",
        "simulateLoading": "Simular carregamento",
        "refreshData": "Atualizar dados"
      },
      "examples": {
        "basicDraggable": "Móvel básico",
        "draggableWithElement": "Arrastável com Elemento",
        "draggableWithTransitionGroup": "Móvel com grupo de transição",
        "draggableWithMoveFunction": "Móvel com função de movimentação"
      },
      "eventLog": "Registro de eventos",
      "handle": "Identificador",
      "name": "Nome",
      "cannotMove": "(não é possível mover)"
    },
    "tableDemo": {
      "title": "Demonstração do Vue 3 UIBTable",
      "basicControls": "Controles básicos",
      "labels": {
        "filter": "Filtrar:",
        "sortBy": "Ordenar por:",
        "sortDirection": "Direção de ordenação:",
        "perPage": "Por página:",
        "tableStyling": "Estilização de tabela:"
      },
      "placeholders": {
        "typeToSearch": "Digite para pesquisar..."
      },
      "checkboxLabels": {
        "striped": "Listrado",
        "bordered": "Com borda",
        "hover": "Passe o mouse",
        "small": "Pequeno(a)",
        "responsive": "Responsivo"
      },
      "fields": {
        "id": "ID",
        "name": "Nome",
        "email": "E-mail",
        "status": "Status",
        "created": "Criado(a)",
        "actions": "Ações"
      },
      "statuses": {
        "active": "Ativo(a)",
        "inactive": "Inativo(a)",
        "pending": "Pendente",
        "banned": "Banido"
      },
      "modal": {
        "title": "Detalhes do item",
        "close": "Fechar"
      },
      "messages": {
        "confirmDelete": "Tem certeza de que deseja excluir {name}?",
        "editItem": "Editar item {id}",
        "showingItems": "Exibindo {count} de {total} itens"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Confirmar e prosseguir",
      "everythingIn": "Tudo em <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "incluir o cartão de crédito aqui",
        "message": "Peça ao seu cliente para",
        "title": "A localização precisa incluir um método de pagamento primeiro."
      },
      "noSaasPlan": {
        "linkText": "Crie seus planos SaaS aqui.",
        "message": "Por favor",
        "title": "Você não tem nenhum plano SaaS configurado."
      },
      "saasModeSetupPendingWarning": "O plano de SaaS será ativado depois que o cliente adicionar um método de pagamento. Até lá, o acesso à conta será restrito.",
      "skipForNow": "Ignorar por enquanto",
      "skipPlan": "Ignorar plano"
    }
  },
  "isv": {
    "business_registration_id_type": "Tipo de ID de registro comercial",
    "business_registration_number": "Número de registro da empresa",
    "business_website": "Site da empresa",
    "enter_your_business_registration_id_type": "Informe o tipo de identificação do registro da sua empresa",
    "name_of_other_registration_id_type": "Nome de outro tipo de ID de registro",
    "pick_business_industry": "Selecione o setor empresarial",
    "pick_business_registration_id_type": "Escolha o tipo de ID de registro comercial",
    "emailWithStar": "E-mail*",
    "businessIndustry": "Setor de atuação da empresa*",
    "businessType": "Tipo de empresa*",
    "regionsOfOperations": "Regiões onde a empresa opera*",
    "registrationNumber": "CNPJ*",
    "registrationNumberHelper": "O número usado para identificar a sua empresa. No caso de EIN dos EUA, deve ser um número de 9 dígitos, ex.: 12-3456789.",
    "businessWebsiteWithStar": "Site da empresa*",
    "businessTypeWithStar": "Tipo de empresa",
    "businessWebsite": "Site da empresa"
  },
  "aiProductRebilling": {
    "enableRebilling": "Habilitar refaturamento",
    "ratesMayDiffer": "As taxas podem variar de acordo com a região. Os cálculos apresentados são conforme as taxas do Reino Unido,",
    "supportDoc": "documento de suporte",
    "cancel": "Cancelar",
    "profit": "Lucro",
    "chargedToCustomer": "Cobrado ao cliente",
    "enabling": "Habilitando...",
    "forMore": "para mais detalhes.",
    "rebillAmount": "Valor de refaturamento",
    "tenDollarsWillGive": "Com 10 dólares, você consegue aproximadamente",
    "yourCost": "Seu custo",
    "clientBillingPage": "página de faturamento da empresa do cliente",
    "needStripeConnection": "Para ativar a cobrança recorrente, é necessário conectar sua conta Stripe.",
    "per1000Words": "por 1000 palavras",
    "perImage": "por imagem",
    "perReviewResponse": "por Resposta de Avaliação",
    "perFunnel": "por funil",
    "minimumBetween": "O mínimo deve estar entre {min} e {max}",
    "images": "imagens",
    "reviewResponse": "resposta de avaliação",
    "funnel": "funil",
    "pleaseCheckSupport": "verifique"
  },
  "a2p": {
    "otpSuccess": {
      "title": "Sucesso do OTP",
      "message": "Mensagem de Sucesso do OTP"
    },
    "otpError": {
      "title": "Erro de OTP",
      "message": "Mensagem de Erro de OTP"
    },
    "businessProfileError": {
      "title": "Erro no perfil da empresa",
      "message": "Mensagem de Erro do Perfil Comercial"
    },
    "addressError": {
      "title": "Erro de Endereço",
      "status": "Status de erro de endereço"
    },
    "profileError": {
      "title": "Erro de Perfil A2P",
      "message": "Mensagem de Erro do Perfil A2P"
    },
    "address": {
      "country": "País",
      "state": "Estado",
      "chooseCountry": "Selecionar um país...",
      "statePlaceholder": "Insira o estado",
      "chooseState": "Selecionar estado",
      "city": "Cidade*",
      "postalCode": "Código postal/CEP*",
      "streetAddress": "Endereço*",
      "streetAddressHelper": "Deve ser um endereço válido vinculado à sua empresa.",
      "title": "Endereço comercial"
    },
    "validation": {
      "brandNameRequired": "O nome da marca é necessário.",
      "businessVerticalRequired": "O segmento de atuação é obrigatório.",
      "cityRequired": "A cidade é obrigatória",
      "countryRequired": "O país é obrigatório.",
      "invalidMobileNumber": "Número de celular inválido.",
      "mobileNumberRequired": "O número de telefone é obrigatório.",
      "postalCodeRequired": "É necessário informar o código postal.",
      "stateRequired": "O estado é obrigatório.",
      "streetAddressRequired": "É necessário o endereço completo."
    },
    "authorizedRep": {
      "email": "E-mail*",
      "firstName": "Nome*",
      "jobPosition": "Cargo*",
      "jobTitle": "Cargo",
      "jobTitlePlaceholder": "Insira o título do cargo",
      "lastName": "Sobrenome*",
      "phoneNumber": "Número de Telefone*",
      "phoneNumberPlaceholder": "Insira o número de telefone",
      "pickJobPosition": "Selecione o cargo",
      "title": "Informações do representante autorizado"
    },
    "registration": {
      "stepProgress": "Etapa {currentStep} de 8",
      "successTitle": "Sua marca e campanha A2P foram enviadas.",
      "successWaitDays": "7 dias",
      "successWaitPrefix": "Pode levar até ",
      "successWaitSuffix": " para aprovação da sua marca e mais 4-5 semanas para aprovação da campanha.",
      "otpNote": "Observação: Você receberá uma mensagem OTP no número de celular informado para verificação pela TCR. Responda Sim dentro de 24 horas após receber o SMS."
    },
    "update": {
      "brandDetailsTitle": "Atualizar Detalhes da Marca",
      "brandName": "Nome da marca*",
      "brandNameHelper": "Use o nome legal da organização que está enviando as mensagens ou o seu próprio nome, caso esta marca não represente uma empresa.",
      "businessVerticals": "Setor de atuação da empresa*",
      "chooseVertical": "Selecione o segmento...",
      "mobileNumber": "Número de celular para verificação de OTP (Com código do país)*",
      "mobileNumberHelper": "Informe um número de celular ao qual você tenha acesso para confirmar a verificação OTP. Somente números dos EUA ou do Canadá serão aceitos. Você não pode usar um número de telefone CPaaS, como um obtido do LeadConnector. Você não pode usar o mesmo número de celular para registrar mais de 3 marcas de Empreendedor Individual. Esse limite é controlado pelo TCR.",
      "updateButton": "Atualizar",
      "retryOTPTitle": "Tentar novamente OTP",
      "retryOTPMessage": "Clique no botão abaixo para reenviar a mensagem de verificação do OTP.",
      "sending": "Enviando...",
      "resendOTP": "Reenviar OTP"
    },
    "einModal": {
      "title": "Você tem um EIN?",
      "question": "Você tem um Número de Identificação do Empregador (EIN)?",
      "hasEIN": "Sim, eu tenho um EIN",
      "noEIN": "Não, eu não possuo um EIN",
      "disableNoEINText": "O EIN é necessário para locais fora dos EUA/CA",
      "infoText": "Um EIN é necessário para empresas nos Estados Unidos e Canadá."
    },
    "brandDetails": {
      "brandHeading": "Informações do Brand Boards",
      "brandName": "Nome da marca*",
      "brandNameHelper": "Use o nome legal da organização que está enviando as mensagens ou o seu próprio nome, caso esta marca não represente uma empresa.",
      "businessIndustry": "Setor de atuação*",
      "chooseVertical": "Escolha o segmento...",
      "mobileNumber": "Número de celular para verificação OTP (com código do país)*",
      "mobileNumberHelper": "Informe um número de celular ao qual você tenha acesso para confirmar o código OTP. Somente números dos EUA ou do Canadá serão aceitos. Você não pode usar um número CPaaS, como aqueles fornecidos pelo LeadConnector. Você não pode usar o mesmo número de celular para registrar mais de 3 marcas de Empreendedor Individual. Esse limite é controlado pelo TCR.",
      "solePropBrand": {
        "heading": "Marca de Empreendedor Individual",
        "point1": "Apenas 1 número de telefone é permitido",
        "point2": "EIN/SSN/DUNS não são necessários",
        "subheading": "Registro de Marca de Proprietário Único"
      },
      "solePropCampaign": {
        "heading": "Campanha de Empreendedor Individual",
        "point1": "Apenas 1 número pode ser vinculado a uma Campanha de Empreendedor Individual.",
        "point2": "Uma vez aprovado, o seu número padrão será vinculado automaticamente",
        "infoText": "Você também pode atualizar o número após a aprovação.",
        "warningText": "Apenas 1 número pode ser vinculado a uma Campanha de Empreendedor Individual. Depois da aprovação, o seu número padrão será vinculado automaticamente; você também pode atualizá-lo após a aprovação.",
        "subheading": "Registro de Campanha de Empresa Individual"
      },
      "solePropSubtitle": "Detalhes da campanha e Brand Boards da Sole Prop",
      "standardBrand": {
        "heading": "$4,41 - Uma vez",
        "point1": "EIN/SSN/DUNS obrigatórios",
        "point2": "Mais de 1 número de telefone permitido",
        "subheading": "Registro Padrão de Marca"
      },
      "standardCampaign": {
        "heading": "US$ 16,54 - pagamento único",
        "point1": "É permitido vincular mais de 1 número a uma Campanha Padrão.",
        "point2": "EIN/SSN/DUNS obrigatórios",
        "infoText": "Pode ser aplicada uma taxa adicional de até US$ 12 por mês, conforme as regras do TCR.",
        "subheading": "Registro Padrão de Campanha"
      },
      "standardSubtitle": "Detalhes padrão de marca e campanha",
      "title": "Detalhes da campanha e da marca"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detalhes do Caso de Uso da Campanha",
        "subtitle": "Digite os detalhes e a descrição da campanha",
        "useCase": "Caso de Uso de Campanha*",
        "pickUseCase": "Selecionar caso de uso de campanha",
        "useCaseDescription": "Descrição do Caso de Uso*",
        "explainInDetail": "Explique em detalhes",
        "useCaseDescriptionPlaceholder": "Modelo: Esta Campanha envia Detalhes sobre Compromisso - mensagens de confirmação & Lembrete para nossos Clientes assim que eles tenham Agendado um Compromisso conosco em nosso Site e optam por herdarem SMS Promocional e de Lembrete de nós.",
        "useCaseDescriptionHelper": "Forneça uma descrição detalhada de como você utilizará esta campanha.",
        "solePropLabel": "Proprietário Individual",
        "seeExamples": "Veja Exemplos",
        "closeExamples": "Fechar Exemplos"
      }
    }
  },
  "opportunities": {
    "email": "E-mail",
    "phone": "Telefone",
    "status": "Status",
    "contactType": "Tipo de contato",
    "bulkOperation": "Operação em massa",
    "contactName": "Nome do contato",
    "unassigned": "Não atribuído",
    "abandoned": "Abandonado(a)",
    "addOpportunityName": "Adicionar nome da oportunidade",
    "companyName": "Nome da empresa",
    "contactInfo": "Informações de contato",
    "enterValue": "Digite o valor",
    "lost": "Perdido(a)",
    "open": "Abrir",
    "opportunityInfo": "Informações da oportunidade",
    "opportunityName": "Nome da oportunidade",
    "opportunitySource": "Fonte da oportunidade",
    "owner": "Proprietário",
    "pipeline": "Pipeline",
    "selectPipeline": "Selecionar Pipeline",
    "selectStage": "Selecionar estágio",
    "stage": "Estágio",
    "won": "Ganho(a)",
    "createdOn": "Criado em",
    "goToContactDetail": "Ir para a página de detalhes de contato",
    "leadValue": "Valor do lead",
    "removeOwner": "Remover Proprietário",
    "createdBy": "Criado por",
    "notAllowedToChange": "Você não tem permissão para alterar este contato",
    "opportunityAlreadyExists": "Já existe uma oportunidade para este contato no funil selecionado",
    "filters": {
      "all": "Todos",
      "statuses": {
        "all": "Todos",
        "open": "Abrir",
        "won": "Ganhou",
        "lost": "Perdeu",
        "abandoned": "Abandonou"
      },
      "search": "Pesquisar",
      "status": "Status",
      "campaign": "Campanha",
      "owner": "Proprietário",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Data adicionada (ASC)",
      "dateAddedDesc": "↓ Data de adição (DESC)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Observação",
      "task": "Tarefa",
      "companyName": "Nome da empresa",
      "additionalInfo": "Informações adicionais",
      "calendarEvent": "Evento de calendário",
      "hideAssignedTo": "Ocultar atribuído a",
      "hideTags": "Ocultar tags"
    },
    "buttons": {
      "new": "Novo"
    },
    "dragActions": {
      "abandoned": "Abandonou",
      "lost": "Perdeu",
      "won": "Ganhou"
    },
    "getStarted": "começar!",
    "noPipelines": "Ops! Parece que não há pipelines. Crie um novo pipeline para",
    "addTask": "Adicionar tarefa",
    "tasksCount": "{count} tarefas"
  },
  "appointmentDetails": "Detalhes do compromisso",
  "cloneFunnel": {
    "cloneButton": "Clonar {entityName}",
    "cloning": "Clonando...",
    "cloningLimit": "A clonagem é limitada a 3 locais por vez.",
    "error": "Erro ao clonar o funil!",
    "locationsLabel": "Selecionar localizações",
    "nameLabel": "Nome para o clonado {entityName}",
    "namePlaceholder": "Insira o nome para o {entityName} clonado",
    "selectUpTo": "Selecionar até {maxSelectableLocations} endereços",
    "title": "Clonar {entityName}"
  },
  "errors": "Erros",
  "renderEmailAddress": "Renderizar Endereço de E-mail",
  "noPaymentMethodWarning": "Aviso de método de pagamento não disponível",
  "pageDetail": "Detalhe da página",
  "activityHistory": "Histórico de Atividades",
  "uiAlert": "Alerta de UI",
  "eventModals": {
    "wait": {
      "save": "Salvar",
      "days": "Dias",
      "fri": "Sex",
      "mon": "Seg",
      "sat": "Sáb",
      "sun": "Dom",
      "thu": "Qui",
      "tue": "Ter",
      "wed": "Qua",
      "wait": "Esperar",
      "minutes": "Minutos",
      "hours": "Horas",
      "title": "Editar Evento de Espera",
      "whichDaysResume": "Quais dias devemos retomar?",
      "pickDayError": "Selecione pelo menos um dia",
      "whatTimeResume": "A que horas devemos continuar?"
    },
    "sms": {
      "send": "Enviar",
      "name": "Nome",
      "attachFile": "Anexar documento",
      "learnMore": "Saiba mais",
      "sendTest": "Teste de envio",
      "title": "Editar Evento {eventType}",
      "titleTemplate": "Editar modelo {eventType}",
      "nameRequired": "O nome é obrigatório",
      "pickTemplate": "Selecione Modelo",
      "appCharacters": "Personagens do App",
      "numSegments": "Número de Segmentos",
      "approximateCost": "Preço aproximado",
      "costEstimateNote": "Nota de estimativa de custos",
      "urlAttachmentAutocompleteToken": "Anexo de URL",
      "addFileUrl": "Adicionar URL do Arquivo",
      "urlImageAlt": "URL da Imagem",
      "fileImageAlt": "Imagem de arquivo",
      "enterMessage": "Insira a mensagem",
      "mobilePhonePlaceholder": "Celular",
      "unsupportedContentType": "Tipo de conteúdo não compatível: {fileType}",
      "urlAttachmentWarning": "{count} O anexo de URL{plural} falhou ao carregar. Quer continuar?",
      "provideMobileNumber": "Por favor, forneça o número de telefone móvel"
    },
    "email": {
      "text": "Texto",
      "checkLinks": "Verifique os links nos quais você tem um valor personalizado. Há um \"%20\" extra entre {{ e os valores personalizados.",
      "errorOccurred": "Ocorreu um erro. Tente novamente.",
      "insertToAddress": "Insira um endereço de destino."
    },
    "voicemail": {
      "save": "Salvar",
      "dropFile": "Solte o arquivo aqui ou clique para carregar",
      "faq": "Perguntas frequentes",
      "title": "Editar Evento de Correio de Voz",
      "voicemailFile": "Arquivo de correio de voz",
      "warning": "Aviso: os arquivos de correio de voz devem estar nos formatos MP3, WAV ou GSM.",
      "unsupportedFormat": "Formato de arquivo não compatível. Use MP3, WAV ou GSM."
    },
    "call": {
      "title": "Editar Evento de Chamada",
      "save": "Salvar",
      "name": "Nome",
      "nameRequired": "O nome é obrigatório",
      "callWhisper": "Aviso de chamada",
      "whisperMessage": "Mensagem de aviso",
      "thisIsTheMessage": "Esta é a mensagem que será reproduzida para o agente antes de conectar a chamada.",
      "callTimeoutS": "Tempo limite de chamada(s)",
      "timeoutSeconds": "Tempo limite (segundos)",
      "disableVoicemailDetect": "Desabilitar Detecção de Correio de Voz",
      "callWillPatchInstantly": "A chamada será conectada instantaneamente sem detectar a caixa postal."
    }
  },
  "emailTemplate": {
    "createdOn": "Criado(a) em",
    "updatedOn": "Atualizado(a) em"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Saiba Mais",
      "description": "Descrição do CNAM"
    },
    "submitted": {
      "checkStatus": "Verifique o status do CNAM",
      "description": "O nome da sua empresa deve começar a aparecer para os contatos compatíveis em cerca de 3 a 5 dias.",
      "subtitle": "Sua solicitação de CNAM foi enviada.",
      "title": "Parabéns!"
    },
    "registration": {
      "confirm": "Confirmar",
      "learnMore": "Saiba mais",
      "characterLimit": "{count}/15",
      "title": "Registro CNAM",
      "description": "Insira o nome da sua empresa (máximo 15 caracteres)",
      "warning": "Aviso: o nome da sua empresa será exibido no ID do chamador. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Erro de Atualização",
      "message": "Mensagem de Erro de Atualização"
    },
    "success": {
      "message": "Sua marca e campanha A2P foram enviadas.<br/><br/><b>Observação:</b> Você <b>receberá uma mensagem OTP no número de celular informado para verificação</b> pela TCR. Responda <b>“Yes” dentro de 24 horas</b> após receber o SMS.",
      "title": "Sua marca e sua campanha A2P foram enviadas para aprovação. Pode levar até <b>7 dias</b> para a aprovação da sua marca e mais 4 a 5 semanas para a aprovação da campanha."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Erro no pacote regulatório",
      "status": "Status de Erro do Pacote Regulatório"
    },
    "createAddress": {
      "successMessage": "Sua marca e campanha A2P foram enviadas.",
      "successTitle": "Endereço enviado com sucesso",
      "underReview": "O endereço enviado está em avaliação."
    },
    "createEndUser": {
      "dateFormat": "O formato da data deve ser AAAA-MM-DD.",
      "phoneExample": " Exemplo: +14155552671",
      "title": "Dados da empresa:"
    },
    "success": {
      "title": "Pacote regulatório enviado com sucesso",
      "underReview": "Pacote submetido em avaliação",
      "message": "Sua solicitação de registro SHAKEN/STIR foi enviada. A aprovação pode levar de <b>3 a 4 dias</b>. O status será atualizado em breve."
    },
    "documents": {
      "additionalInfo": "Informações adicionais",
      "createAddressLink": "Gerar endereço.",
      "createAddressPrompt": "Gere um endereço primeiro e então continue com a criação do pacote.",
      "selectAddress": "Selecionar endereço:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Esta opção adicionará um novo endereço à sua conta",
        "label": "Pacote de Endereços"
      },
      "regulatoryBundle": {
        "description": "Esta opção ajudará você a criar um novo pacote regulatório",
        "label": "Pacote Regulatório"
      },
      "title": "Selecione o pacote que você deseja incluir"
    },
    "modal": {
      "back": "Voltar",
      "next": "Próximo",
      "submit": "Enviar",
      "title": "Novo Pacote Regulatório",
      "description": "Crie um novo pacote regulatório para a sua localização"
    }
  },
  "reminder": {
    "phone": "Telefone",
    "noReplyYet": "Ainda sem resposta"
  },
  "sendGrid": {
    "apiKey": "Chave de API do SendGrid",
    "save": "Salvar no SendGrid",
    "apiKeyRequired": "A chave da API SendGrid é obrigatória."
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Fazer upgrade",
      "subtitle": "Agências no plano Pro ganham cerca de US$ 363 por mês repassando custos de telefonia aos seus clientes.",
      "title": "Você quer refaturar isso para seus clientes?"
    }
  },
  "emailField": {
    "label": "E-mail",
    "placeholder": "E-mail",
    "tooltip": {
      "primary": "Principal",
      "emails": "E-mails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Carregar instantâneo:",
    "loadSnapshotWarning": "Deseja carregar o instantâneo associado a este plano? <br /> <strong class='text-danger'>Os dados existentes podem ser perdidos</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Somente administradores/usuários da agência têm acesso a essa subconta. Atualmente, você e outros administradores/usuários da conta não têm acesso a essa subconta.",
      "heading": "Esta subconta foi pausada."
    },
    "temporarily": {
      "description": "Todos os seus dados estão seguros e todos os gatilhos, campanhas etc. continuarão a funcionar depois da ativação.",
      "heading": " Sua conta foi temporariamente pausada."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nome fantasia",
    "title": "Atualizar ID do chamador"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Selecione o escritório",
    "whichOffice": "Qual escritório você deseja vincular a esta conta?",
    "connect": "Conecte-se!"
  },
  "phoneField": {
    "label": "Telefone",
    "placeholder": "Número de telefone",
    "tooltip": {
      "invalidNumber": "Número de telefone inválido",
      "notSmsCapable": "Este número {type} não é capaz de enviar SMS."
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Detalhes do agendamento",
      "form": "Formulário",
      "quiz": "Questionário",
      "submissionDetail": "Detalhes de envio",
      "survey": "Pesquisa"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Sua solicitação de registro SHAKEN/STIR foi enviada. A aprovação pode levar de <b>3 a 4 dias</b>. O status será atualizado em breve.",
      "title": "Chamadas verificadas SHAKEN/STIR ativadas."
    },
    "modal": {
      "andThe": " e o ",
      "businessProfile": "Perfil comercial",
      "certification": "Confirmo que o Perfil Comercial associado é o originador das chamadas telefônicas e certifico que participarei dos esforços de rastreamento, incluindo aqueles iniciados pelo Administrador de Política de Identidade de Telefonia Segura (STI-PA).",
      "failedTitle": "Falha no envio",
      "friendlyName": "Nome amigável",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 às 19:47:14",
      "linkInfo": {
        "description": "Todos os números atuais disponíveis e os números adquiridos no futuro serão automaticamente registrados no SHAKEN/STIR.",
        "title": "Todos os números serão vinculados automaticamente."
      },
      "stiPa": "Administrador de Política de Sexo de Telefonia Bloquear (STI-PA)",
      "subtitle": "Insira os detalhes e a descrição",
      "successMessage": "Sua solicitação de registro SHAKEN/STIR foi enviada. A aprovação pode levar de <b>3 a 4</b> dias. O status será atualizado em breve.",
      "successTitle": "Chamadas verificadas SHAKEN/STIR ativadas.",
      "title": "Ativar chamadas verificadas SHAKEN/STIR",
      "tracebackGroup": "Grupo de Rastreamento de Telecom dos EUA"
    },
    "withCnam": {
      "cnamPromo": "Registre-se no CNAM para exibir o nome da sua empresa no identificador de chamadas",
      "registerCnam": "Registrar CNAM"
    }
  },
  "task": {
    "2day": "2 dias",
    "3day": "3 dias",
    "4day": "4 dias",
    "5day": "5 dias",
    "addTask": "Adicionar tarefa",
    "countTasks": "{count} tarefas"
  },
  "updatedProductsModal": {
    "title": "Produtos Atualizados",
    "copyDirectSaleLink": "Copiar Link de Venda Direta",
    "setupFeeInstruction": "A taxa de configuração pode ser ajustada no Stripe Dashboard. ",
    "doNotDeleteWarning": "Não exclua produtos ou preços do Stripe Dashboard. Isso vai interromper a integração."
  },
  "termsOfService": {
    "privacyLink": "Política de privacidade",
    "accept": "Aceitar",
    "termsLink": "Termos de serviço",
    "updateMessage": "Atualizamos os nossos Termos de Serviço e a Política de Privacidade. Revise e aceite para continuar.",
    "agreementPrefix": "Ao continuar, você concorda com nossos ",
    "agreementConjunction": " e "
  },
  "callerIdVerificationModal": {
    "answerCall": "Atenda à ligação e insira este código de verificação:",
    "leadConnectorCalling": "O Lead Connector está ligando...",
    "title": "Adicionar um ID do Chamador por Voz",
    "waitingForVerification": "Aguardando verificação..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirmar código",
    "resendCode": "Se você não recebeu o código, clique aqui para reenviar"
  },
  "survey": {
    "copy": {
      "cancel": "Cancelar",
      "location": "Localização",
      "copy": "Copiar",
      "newSurveyName": "Novo Nome da Pesquisa",
      "title": "Copiar Pesquisa",
      "locationRequired": "A localização é obrigatória"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nome do produto",
    "planDetails": "Detalhes do plano",
    "title": "Detalhes do produto",
    "planId": "ID do Plano",
    "copiedToClipboard": "Copiado para a área de transferência"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Mais Eficiente",
      "faster": "Mais rápido",
      "itsText": "É",
      "smoother": "Mais suave",
      "title": "Uma nova experiência de importação chegou!",
      "warningMessage": "Habilitar a nova experiência de Importação ativa Labs para esta subconta e ativar o Recurso Beta.",
      "tryNow": "Testar agora"
    },
    "validateEmails": "Validar e-mails?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Preço do HighLevel",
      "howDoesItWork": "Como funciona?",
      "payNow": "Pagar agora",
      "priceError": "O preço deve ser maior ou igual ao preço do HighLevel",
      "saving": "Salvando",
      "yourPrice": "Seu preço",
      "yourProfit": "Seu lucro",
      "subscriptionCreating": "A assinatura está sendo criada.<br/>Não recarregue nem pressione o botão Voltar",
      "subscriptionCreated": "Assinatura criada com sucesso. Aguarde...",
      "unableToCreate": "Não foi possível criar a assinatura. Entre em contato com o suporte.",
      "perMonth": "por mês",
      "agreeToEnable": "Eu concordo em salvar os anúncios para este cliente sem venda adicional e reconheço que serei cobrado.",
      "deployDirectly": "Implantar Listagens Diretamente",
      "deployDirectlyDesc": "Use esta opção se você estiver oferecendo anúncios como parte da sua oferta ou se desejar faturar seu cliente externamente",
      "minimumCommitment": "com um período de compromisso mínimo de 1 mês",
      "offerListings": "Listagens de Ofertas",
      "resellListings": "Listagens para revenda",
      "subscribedInfo": "{withoutUpsell} Sem venda adicional, {withUpsell} com venda adicional e {withSaas} com pacote SaaS",
      "yourResellOffer": "Sua oferta de revenda"
    }
  }
}
